/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as EmailVerifiedRouteImport } from './routes/emailVerified'
import { Route as IndexDothtmlRouteImport } from './routes/index[.]html'
import { Route as InsufficientPermissionsRouteImport } from './routes/insufficientPermissions'
import { Route as LoggedOutRouteImport } from './routes/loggedOut'
import { Route as AuthenticatedShellRouteImport } from './routes/_authenticated/_shell'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as CustomAppWindowWindowIdRouteImport } from './routes/customAppWindow/$windowId'
import { Route as ViewsSplatRouteImport } from './routes/views/$'
import { Route as AuthenticatedShellIndexRouteImport } from './routes/_authenticated/_shell/index'
import { Route as AuthenticatedShellBiRouteImport } from './routes/_authenticated/_shell/bi'
import { Route as AuthenticatedShellDevTestRouteImport } from './routes/_authenticated/_shell/devTest'
import { Route as ConnectionOauthCallbackRouteImport } from './routes/connection/oauth/callback'
import { Route as WopiActionFileIdRouteImport } from './routes/wopi/$action/$fileId'
import { Route as AuthenticatedShellAiCostsRouteImport } from './routes/_authenticated/_shell/ai/costs'
import { Route as AuthenticatedShellAiManagementRouteImport } from './routes/_authenticated/_shell/ai/management'
import { Route as AuthenticatedShellAppsCustomAppIdRouteImport } from './routes/_authenticated/_shell/apps/$customAppId'
import { Route as AuthenticatedShellCommonCompaniesRouteImport } from './routes/_authenticated/_shell/common/companies'
import { Route as AuthenticatedShellCommonCurrenciesRouteImport } from './routes/_authenticated/_shell/common/currencies'
import { Route as AuthenticatedShellCommonDocumentTemplatesRouteImport } from './routes/_authenticated/_shell/common/documentTemplates'
import { Route as AuthenticatedShellCommonEmailTemplatesRouteImport } from './routes/_authenticated/_shell/common/emailTemplates'
import { Route as AuthenticatedShellCommonNumberSequencesRouteImport } from './routes/_authenticated/_shell/common/numberSequences'
import { Route as AuthenticatedShellCommonObjectAttributeFieldsRouteImport } from './routes/_authenticated/_shell/common/objectAttributeFields'
import { Route as AuthenticatedShellCommonSitesRouteImport } from './routes/_authenticated/_shell/common/sites'
import { Route as AuthenticatedShellCommonSystemDiagramsRouteImport } from './routes/_authenticated/_shell/common/systemDiagrams'
import { Route as AuthenticatedShellConfiguratorLibrariesRouteImport } from './routes/_authenticated/_shell/configurator/libraries'
import { Route as AuthenticatedShellConfiguratorOptionListsRouteImport } from './routes/_authenticated/_shell/configurator/optionLists'
import { Route as AuthenticatedShellConfiguratorProductFamiliesRouteImport } from './routes/_authenticated/_shell/configurator/productFamilies'
import { Route as AuthenticatedShellConfiguratorProductFamilyCategoriesRouteImport } from './routes/_authenticated/_shell/configurator/productFamilyCategories'
import { Route as AuthenticatedShellConfiguratorTablesRouteImport } from './routes/_authenticated/_shell/configurator/tables'
import { Route as AuthenticatedShellCrmContactsRouteImport } from './routes/_authenticated/_shell/crm/contacts'
import { Route as AuthenticatedShellCrmCustomersRouteImport } from './routes/_authenticated/_shell/crm/customers'
import { Route as AuthenticatedShellCrmIncomingLeadsRouteImport } from './routes/_authenticated/_shell/crm/incomingLeads'
import { Route as AuthenticatedShellCrmSalesAreasRouteImport } from './routes/_authenticated/_shell/crm/salesAreas'
import { Route as AuthenticatedShellCrmSalesLeadActivitiesRouteImport } from './routes/_authenticated/_shell/crm/salesLeadActivities'
import { Route as AuthenticatedShellCrmSalesLeadActivityCategoriesRouteImport } from './routes/_authenticated/_shell/crm/salesLeadActivityCategories'
import { Route as AuthenticatedShellCrmSalesLeadSourcesRouteImport } from './routes/_authenticated/_shell/crm/salesLeadSources'
import { Route as AuthenticatedShellCrmSalesLeadsRouteImport } from './routes/_authenticated/_shell/crm/salesLeads'
import { Route as AuthenticatedShellCrmSalesPipelineRouteImport } from './routes/_authenticated/_shell/crm/salesPipeline'
import { Route as AuthenticatedShellCrmSalesPipelineBoardRouteImport } from './routes/_authenticated/_shell/crm/salesPipelineBoard'
import { Route as AuthenticatedShellCustomizationsApiConnectionsRouteImport } from './routes/_authenticated/_shell/customizations/api-connections'
import { Route as AuthenticatedShellCustomizationsApiKeysRouteImport } from './routes/_authenticated/_shell/customizations/api-keys'
import { Route as AuthenticatedShellCustomizationsCustomAppsRouteImport } from './routes/_authenticated/_shell/customizations/custom-apps'
import { Route as AuthenticatedShellCustomizationsCustomFunctionsRouteImport } from './routes/_authenticated/_shell/customizations/custom-functions'
import { Route as AuthenticatedShellCustomizationsSentEmailsRouteImport } from './routes/_authenticated/_shell/customizations/sent-emails'
import { Route as AuthenticatedShellDocumentsDocumentCategoriesRouteImport } from './routes/_authenticated/_shell/documents/documentCategories'
import { Route as AuthenticatedShellDocumentsSearchRouteImport } from './routes/_authenticated/_shell/documents/search'
import { Route as AuthenticatedShellMellanoLisToLsbRouteImport } from './routes/_authenticated/_shell/mellano/lisToLsb'
import { Route as AuthenticatedShellMellanoPaintingControlChartsRouteImport } from './routes/_authenticated/_shell/mellano/paintingControlCharts'
import { Route as AuthenticatedShellProductDesignBomLineGroupsRouteImport } from './routes/_authenticated/_shell/productDesign/bomLineGroups'
import { Route as AuthenticatedShellProductManagementCatalogPartsRouteImport } from './routes/_authenticated/_shell/productManagement/catalogParts'
import { Route as AuthenticatedShellProductManagementPartCategoriesRouteImport } from './routes/_authenticated/_shell/productManagement/partCategories'
import { Route as AuthenticatedShellProductManagementProductChangeCategoriesRouteImport } from './routes/_authenticated/_shell/productManagement/productChangeCategories'
import { Route as AuthenticatedShellProductManagementProductChangePackagesRouteImport } from './routes/_authenticated/_shell/productManagement/productChangePackages'
import { Route as AuthenticatedShellProductManagementProductChangeRequestsRouteImport } from './routes/_authenticated/_shell/productManagement/productChangeRequests'
import { Route as AuthenticatedShellProductManagementProductChangesRouteImport } from './routes/_authenticated/_shell/productManagement/productChanges'
import { Route as AuthenticatedShellProductManagementSearchPartsByAttributesRouteImport } from './routes/_authenticated/_shell/productManagement/searchPartsByAttributes'
import { Route as AuthenticatedShellProductManagementUnitsRouteImport } from './routes/_authenticated/_shell/productManagement/units'
import { Route as AuthenticatedShellProductionOnProductionLineRouteImport } from './routes/_authenticated/_shell/production/onProductionLine'
import { Route as AuthenticatedShellProductionOperationsRouteImport } from './routes/_authenticated/_shell/production/operations'
import { Route as AuthenticatedShellProductionProductionLineGroupJobQueueRouteImport } from './routes/_authenticated/_shell/production/productionLineGroupJobQueue'
import { Route as AuthenticatedShellProductionProductionLineJobQueueRouteImport } from './routes/_authenticated/_shell/production/productionLineJobQueue'
import { Route as AuthenticatedShellProductionProductionLinesRouteImport } from './routes/_authenticated/_shell/production/productionLines'
import { Route as AuthenticatedShellProductionShopOrderBatchJobQueueRouteImport } from './routes/_authenticated/_shell/production/shopOrderBatchJobQueue'
import { Route as AuthenticatedShellProductionShopOrderBatchesRouteImport } from './routes/_authenticated/_shell/production/shopOrderBatches'
import { Route as AuthenticatedShellProductionShopOrderPackagingRouteImport } from './routes/_authenticated/_shell/production/shopOrderPackaging'
import { Route as AuthenticatedShellProductionShopOrdersRouteImport } from './routes/_authenticated/_shell/production/shopOrders'
import { Route as AuthenticatedShellProductionSubcontractingJobQueueRouteImport } from './routes/_authenticated/_shell/production/subcontractingJobQueue'
import { Route as AuthenticatedShellProductionSupplementShopOrderRouteImport } from './routes/_authenticated/_shell/production/supplementShopOrder'
import { Route as AuthenticatedShellProductionWorkCenterIncompleteOperationsRouteImport } from './routes/_authenticated/_shell/production/workCenterIncompleteOperations'
import { Route as AuthenticatedShellProductionWorkCenterJobQueueRouteImport } from './routes/_authenticated/_shell/production/workCenterJobQueue'
import { Route as AuthenticatedShellProductionWorkCentersRouteImport } from './routes/_authenticated/_shell/production/workCenters'
import { Route as AuthenticatedShellProjectActivityResourcesRouteImport } from './routes/_authenticated/_shell/project/activityResources'
import { Route as AuthenticatedShellProjectActivityTypesRouteImport } from './routes/_authenticated/_shell/project/activityTypes'
import { Route as AuthenticatedShellProjectCostEventsRouteImport } from './routes/_authenticated/_shell/project/costEvents'
import { Route as AuthenticatedShellProjectJobQueueRouteImport } from './routes/_authenticated/_shell/project/jobQueue'
import { Route as AuthenticatedShellProjectProjectTypesRouteImport } from './routes/_authenticated/_shell/project/projectTypes'
import { Route as AuthenticatedShellProjectProjectsRouteImport } from './routes/_authenticated/_shell/project/projects'
import { Route as AuthenticatedShellProjectResourcesGanttRouteImport } from './routes/_authenticated/_shell/project/resourcesGantt'
import { Route as AuthenticatedShellProjectSchedulingRouteImport } from './routes/_authenticated/_shell/project/scheduling'
import { Route as AuthenticatedShellProjectSubProjectTypesRouteImport } from './routes/_authenticated/_shell/project/subProjectTypes'
import { Route as AuthenticatedShellProjectTreeRouteImport } from './routes/_authenticated/_shell/project/tree'
import { Route as AuthenticatedShellPurchaseAllPurchaseOrderLinesRouteImport } from './routes/_authenticated/_shell/purchase/allPurchaseOrderLines'
import { Route as AuthenticatedShellPurchaseDeliveryNoticesRouteImport } from './routes/_authenticated/_shell/purchase/deliveryNotices'
import { Route as AuthenticatedShellPurchaseProcessViewRouteImport } from './routes/_authenticated/_shell/purchase/processView'
import { Route as AuthenticatedShellPurchasePurchaseOrderConfirmationsRouteImport } from './routes/_authenticated/_shell/purchase/purchaseOrderConfirmations'
import { Route as AuthenticatedShellPurchasePurchaseOrdersRouteImport } from './routes/_authenticated/_shell/purchase/purchaseOrders'
import { Route as AuthenticatedShellPurchasePurchaseOrdersToReceiveRouteImport } from './routes/_authenticated/_shell/purchase/purchaseOrdersToReceive'
import { Route as AuthenticatedShellPurchasePurchaseRequestsRouteImport } from './routes/_authenticated/_shell/purchase/purchaseRequests'
import { Route as AuthenticatedShellSalesAccountingRouteImport } from './routes/_authenticated/_shell/sales/accounting'
import { Route as AuthenticatedShellSalesAllCustomerOrderLinesRouteImport } from './routes/_authenticated/_shell/sales/allCustomerOrderLines'
import { Route as AuthenticatedShellSalesBillingPlanLinesToApproveRouteImport } from './routes/_authenticated/_shell/sales/billingPlanLinesToApprove'
import { Route as AuthenticatedShellSalesBillingPlanModelsRouteImport } from './routes/_authenticated/_shell/sales/billingPlanModels'
import { Route as AuthenticatedShellSalesBillingPlanPartsRouteImport } from './routes/_authenticated/_shell/sales/billingPlanParts'
import { Route as AuthenticatedShellSalesContractualTermsRouteImport } from './routes/_authenticated/_shell/sales/contractualTerms'
import { Route as AuthenticatedShellSalesCustomerGroupsRouteImport } from './routes/_authenticated/_shell/sales/customerGroups'
import { Route as AuthenticatedShellSalesCustomerOfferTypesRouteImport } from './routes/_authenticated/_shell/sales/customerOfferTypes'
import { Route as AuthenticatedShellSalesCustomerOrderSalesConditionsRouteImport } from './routes/_authenticated/_shell/sales/customerOrderSalesConditions'
import { Route as AuthenticatedShellSalesCustomerOrderTypesRouteImport } from './routes/_authenticated/_shell/sales/customerOrderTypes'
import { Route as AuthenticatedShellSalesCustomerOrdersRouteImport } from './routes/_authenticated/_shell/sales/customerOrders'
import { Route as AuthenticatedShellSalesCustomerPriceGroupsRouteImport } from './routes/_authenticated/_shell/sales/customerPriceGroups'
import { Route as AuthenticatedShellSalesCustomersRouteImport } from './routes/_authenticated/_shell/sales/customers'
import { Route as AuthenticatedShellSalesEInvoiceOperatorsRouteImport } from './routes/_authenticated/_shell/sales/eInvoiceOperators'
import { Route as AuthenticatedShellSalesOffersRouteImport } from './routes/_authenticated/_shell/sales/offers'
import { Route as AuthenticatedShellSalesOrderDeliveryProcessViewRouteImport } from './routes/_authenticated/_shell/sales/orderDeliveryProcessView'
import { Route as AuthenticatedShellSalesPaymentTermRouteImport } from './routes/_authenticated/_shell/sales/paymentTerm'
import { Route as AuthenticatedShellSalesReceivedCustomerOrdersRouteImport } from './routes/_authenticated/_shell/sales/receivedCustomerOrders'
import { Route as AuthenticatedShellSalesSalesConditionsRouteImport } from './routes/_authenticated/_shell/sales/salesConditions'
import { Route as AuthenticatedShellSalesSalesPartCategoriesRouteImport } from './routes/_authenticated/_shell/sales/salesPartCategories'
import { Route as AuthenticatedShellSalesSalesPartPriceGroupsRouteImport } from './routes/_authenticated/_shell/sales/salesPartPriceGroups'
import { Route as AuthenticatedShellSalesSalesPartsRouteImport } from './routes/_authenticated/_shell/sales/salesParts'
import { Route as AuthenticatedShellSalesSalespersonsRouteImport } from './routes/_authenticated/_shell/sales/salespersons'
import { Route as AuthenticatedShellSalesTransportRoutesRouteImport } from './routes/_authenticated/_shell/sales/transportRoutes'
import { Route as AuthenticatedShellSalesVatCodesRouteImport } from './routes/_authenticated/_shell/sales/vatCodes'
import { Route as AuthenticatedShellSalesVatHandlingTypesRouteImport } from './routes/_authenticated/_shell/sales/vatHandlingTypes'
import { Route as AuthenticatedShellSalvosSalesCommissionLimitsRouteImport } from './routes/_authenticated/_shell/salvos/salesCommissionLimits'
import { Route as AuthenticatedShellSpcCalendarsRouteImport } from './routes/_authenticated/_shell/spc/calendars'
import { Route as AuthenticatedShellSpcControlChartsRouteImport } from './routes/_authenticated/_shell/spc/controlCharts'
import { Route as AuthenticatedShellSpcCycleTimeMeasurementRouteImport } from './routes/_authenticated/_shell/spc/cycleTimeMeasurement'
import { Route as AuthenticatedShellSpcDimensionSearchRouteImport } from './routes/_authenticated/_shell/spc/dimensionSearch'
import { Route as AuthenticatedShellSpcImportDataRouteImport } from './routes/_authenticated/_shell/spc/importData'
import { Route as AuthenticatedShellSpcProcessImprovementCategoriesRouteImport } from './routes/_authenticated/_shell/spc/processImprovementCategories'
import { Route as AuthenticatedShellSpcProcessImprovementsRouteImport } from './routes/_authenticated/_shell/spc/processImprovements'
import { Route as AuthenticatedShellSpcResourcesRouteImport } from './routes/_authenticated/_shell/spc/resources'
import { Route as AuthenticatedShellSpcTimeMeasurementRouteImport } from './routes/_authenticated/_shell/spc/timeMeasurement'
import { Route as AuthenticatedShellSpcYieldChartsRouteImport } from './routes/_authenticated/_shell/spc/yieldCharts'
import { Route as AuthenticatedShellSurveysSurveyCategoriesRouteImport } from './routes/_authenticated/_shell/surveys/surveyCategories'
import { Route as AuthenticatedShellSurveysSurveyFormsRouteImport } from './routes/_authenticated/_shell/surveys/surveyForms'
import { Route as AuthenticatedShellTasksAllTasksRouteImport } from './routes/_authenticated/_shell/tasks/allTasks'
import { Route as AuthenticatedShellTasksMyRouteImport } from './routes/_authenticated/_shell/tasks/my'
import { Route as AuthenticatedShellTasksOnMyResponsibilityRouteImport } from './routes/_authenticated/_shell/tasks/onMyResponsibility'
import { Route as AuthenticatedShellTasksTaskTemplatesRouteImport } from './routes/_authenticated/_shell/tasks/taskTemplates'
import { Route as AuthenticatedShellUsersManagementRouteImport } from './routes/_authenticated/_shell/users/management'
import { Route as AuthenticatedShellUsersRolesRouteImport } from './routes/_authenticated/_shell/users/roles'
import { Route as AuthenticatedShellWarehouseDataCollectionRouteImport } from './routes/_authenticated/_shell/warehouse/dataCollection'
import { Route as AuthenticatedShellWarehouseDeliveryPackageTypesRouteImport } from './routes/_authenticated/_shell/warehouse/deliveryPackageTypes'
import { Route as AuthenticatedShellWarehouseInventoryLevelProfileRouteImport } from './routes/_authenticated/_shell/warehouse/inventoryLevelProfile'
import { Route as AuthenticatedShellWarehousePartCostCalculationRouteImport } from './routes/_authenticated/_shell/warehouse/partCostCalculation'
import { Route as AuthenticatedShellWarehousePartImportCodesRouteImport } from './routes/_authenticated/_shell/warehouse/partImportCodes'
import { Route as AuthenticatedShellWarehousePartsRouteImport } from './routes/_authenticated/_shell/warehouse/parts'
import { Route as AuthenticatedShellWarehouseTransferJobQueueRouteImport } from './routes/_authenticated/_shell/warehouse/transferJobQueue'
import { Route as AuthenticatedShellWarehouseUnverifiedPartsRouteImport } from './routes/_authenticated/_shell/warehouse/unverifiedParts'
import { Route as AuthenticatedShellWarehouseWarehouseLocationPartsRouteImport } from './routes/_authenticated/_shell/warehouse/warehouseLocationParts'
import { Route as AuthenticatedShellWarehouseWarehouseLocationsRouteImport } from './routes/_authenticated/_shell/warehouse/warehouseLocations'
import { Route as AuthenticatedShellWarehouseWarehouseTransfersRouteImport } from './routes/_authenticated/_shell/warehouse/warehouseTransfers'
import { Route as AuthenticatedShellWorkspaceCategoriesRouteImport } from './routes/_authenticated/_shell/workspace/categories'
import { Route as AuthenticatedShellWorkspaceWorkspacesRouteImport } from './routes/_authenticated/_shell/workspace/workspaces'
import { Route as AuthenticatedShellCommonAccountingAccountsRouteImport } from './routes/_authenticated/_shell/common/accounting/accounts'
import { Route as AuthenticatedShellCommonAccountingDimensionsRouteImport } from './routes/_authenticated/_shell/common/accounting/dimensions'
import { Route as AuthenticatedShellErpCommonAddCostEventRouteImport } from './routes/_authenticated/_shell/erp/common/addCostEvent'
import { Route as AuthenticatedShellErpCommonCostEventObjectTypeSettingsRouteImport } from './routes/_authenticated/_shell/erp/common/costEventObjectTypeSettings'
import { Route as AuthenticatedShellErpCommonCostEventPriceListsRouteImport } from './routes/_authenticated/_shell/erp/common/costEventPriceLists'
import { Route as AuthenticatedShellErpCommonCostEventsRouteImport } from './routes/_authenticated/_shell/erp/common/costEvents'
import { Route as AuthenticatedShellErpConfiguratorLogSearchRouteImport } from './routes/_authenticated/_shell/erp/configurator/logSearch'
import { Route as AuthenticatedShellErpDeliveryTransportEquipmentRouteImport } from './routes/_authenticated/_shell/erp/delivery/transportEquipment'
import { Route as AuthenticatedShellErpInventoryForecastRouteImport } from './routes/_authenticated/_shell/erp/inventory/forecast'
import { Route as AuthenticatedShellErpProductionCapacityRouteImport } from './routes/_authenticated/_shell/erp/production/capacity'
import { Route as AuthenticatedShellErpProductionCompletedQuantityRouteImport } from './routes/_authenticated/_shell/erp/production/completedQuantity'
import { Route as AuthenticatedShellErpProductionLoadChartRouteImport } from './routes/_authenticated/_shell/erp/production/loadChart'
import { Route as AuthenticatedShellErpProductionProductionPlanningRouteImport } from './routes/_authenticated/_shell/erp/production/productionPlanning'
import { Route as AuthenticatedShellErpProductionSalesProductionBacklogRouteImport } from './routes/_authenticated/_shell/erp/production/salesProductionBacklog'
import { Route as AuthenticatedShellErpPurchaseSupplierGroupsRouteImport } from './routes/_authenticated/_shell/erp/purchase/supplierGroups'
import { Route as AuthenticatedShellErpPurchaseSuppliersRouteImport } from './routes/_authenticated/_shell/erp/purchase/suppliers'
import { Route as AuthenticatedShellErpReclamationsReclamationCategoryRouteImport } from './routes/_authenticated/_shell/erp/reclamations/reclamationCategory'
import { Route as AuthenticatedShellErpReclamationsReclamationCauseRouteImport } from './routes/_authenticated/_shell/erp/reclamations/reclamationCause'
import { Route as AuthenticatedShellErpReclamationsReclamationHandlingMethodRouteImport } from './routes/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod'
import { Route as AuthenticatedShellErpReclamationsReclamationLocationRouteImport } from './routes/_authenticated/_shell/erp/reclamations/reclamationLocation'
import { Route as AuthenticatedShellErpReclamationsReclamationsRouteImport } from './routes/_authenticated/_shell/erp/reclamations/reclamations'
import { Route as AuthenticatedShellErpReclamationsRoundsRouteImport } from './routes/_authenticated/_shell/erp/reclamations/rounds'
import { Route as AuthenticatedShellErpReclamationsWeekPlanningRouteImport } from './routes/_authenticated/_shell/erp/reclamations/weekPlanning'
import { Route as AuthenticatedShellErpReclamationsWorkQueueRouteImport } from './routes/_authenticated/_shell/erp/reclamations/workQueue'
import { Route as AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRouteImport } from './routes/_authenticated/_shell/erp/safetyControlSurvey/noteCategories'
import { Route as AuthenticatedShellErpSafetyControlSurveySummaryRouteImport } from './routes/_authenticated/_shell/erp/safetyControlSurvey/summary'
import { Route as AuthenticatedShellErpSafetyControlSurveySurveysRouteImport } from './routes/_authenticated/_shell/erp/safetyControlSurvey/surveys'
import { Route as AuthenticatedShellErpSafetyControlSurveyTeamsRouteImport } from './routes/_authenticated/_shell/erp/safetyControlSurvey/teams'
import { Route as AuthenticatedShellErpSalesCustomerOrderImportRouteImport } from './routes/_authenticated/_shell/erp/sales/customerOrderImport'
import { Route as AuthenticatedShellErpVertexIndConfigRouteImport } from './routes/_authenticated/_shell/erp/vertexInd/config'
import { Route as AuthenticatedShellErpWarehouseCargoDriversRouteImport } from './routes/_authenticated/_shell/erp/warehouse/cargoDrivers'
import { Route as AuthenticatedShellErpWarehouseDeliveryMethodsRouteImport } from './routes/_authenticated/_shell/erp/warehouse/deliveryMethods'
import { Route as AuthenticatedShellErpWarehouseDeliveryTermsRouteImport } from './routes/_authenticated/_shell/erp/warehouse/deliveryTerms'
import { Route as AuthenticatedShellErpWarehouseWarehousePickerGroupsRouteImport } from './routes/_authenticated/_shell/erp/warehouse/warehousePickerGroups'
import { Route as AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRouteImport } from './routes/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups'
import { Route as AuthenticatedShellMellanoLuukkuCapacityRouteImport } from './routes/_authenticated/_shell/mellano/luukku/capacity'
import { Route as AuthenticatedShellMellanoLuukkuDataCollectionRouteImport } from './routes/_authenticated/_shell/mellano/luukku/dataCollection'
import { Route as AuthenticatedShellMellanoLuukkuDispatchSlottingRouteImport } from './routes/_authenticated/_shell/mellano/luukku/dispatchSlotting'
import { Route as AuthenticatedShellMellanoLuukkuDrillStampsRouteImport } from './routes/_authenticated/_shell/mellano/luukku/drillStamps'
import { Route as AuthenticatedShellMellanoLuukkuHandPaintingPlanRouteImport } from './routes/_authenticated/_shell/mellano/luukku/handPaintingPlan'
import { Route as AuthenticatedShellMellanoLuukkuKetMetricsRouteImport } from './routes/_authenticated/_shell/mellano/luukku/ketMetrics'
import { Route as AuthenticatedShellMellanoLuukkuMelamineStockForecastRouteImport } from './routes/_authenticated/_shell/mellano/luukku/melamineStockForecast'
import { Route as AuthenticatedShellMellanoLuukkuOrderStatusRouteImport } from './routes/_authenticated/_shell/mellano/luukku/orderStatus'
import { Route as AuthenticatedShellMellanoLuukkuPackagedAmountRouteImport } from './routes/_authenticated/_shell/mellano/luukku/packagedAmount'
import { Route as AuthenticatedShellMellanoLuukkuPaintStockForecastRouteImport } from './routes/_authenticated/_shell/mellano/luukku/paintStockForecast'
import { Route as AuthenticatedShellMellanoLuukkuPaintingPlanRouteImport } from './routes/_authenticated/_shell/mellano/luukku/paintingPlan'
import { Route as AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRouteImport } from './routes/_authenticated/_shell/mellano/luukku/paintingRoundDefects'
import { Route as AuthenticatedShellMellanoLuukkuPaintingRoundsRouteImport } from './routes/_authenticated/_shell/mellano/luukku/paintingRounds'
import { Route as AuthenticatedShellMellanoLuukkuProductionPlanningRouteImport } from './routes/_authenticated/_shell/mellano/luukku/productionPlanning'
import { Route as AuthenticatedShellMellanoLuukkuProductionStatusRouteImport } from './routes/_authenticated/_shell/mellano/luukku/productionStatus'
import { Route as AuthenticatedShellMellanoLuukkuPurchaseOrderImportRouteImport } from './routes/_authenticated/_shell/mellano/luukku/purchaseOrderImport'
import { Route as AuthenticatedShellMellanoLuukkuPurchaseSuggestionRouteImport } from './routes/_authenticated/_shell/mellano/luukku/purchaseSuggestion'
import { Route as AuthenticatedShellMellanoLuukkuShiftDefectsRouteImport } from './routes/_authenticated/_shell/mellano/luukku/shiftDefects'
import { Route as AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRouteImport } from './routes/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches'
import { Route as AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRouteImport } from './routes/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress'
import { Route as AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRouteImport } from './routes/_authenticated/_shell/mellano/luukku/unsentRonkkoDeliveries'
import { Route as AuthenticatedShellMellanoLuukkuWorkOrderSlottingRouteImport } from './routes/_authenticated/_shell/mellano/luukku/workOrderSlotting'
import { Route as AuthenticatedShellMellanoWinnerDesignsRouteImport } from './routes/_authenticated/_shell/mellano/winner/designs'
import { Route as AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRouteImport } from './routes/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId'
import { Route as AuthenticatedShellProductionProductionLinesStatusProductionLineIdRouteImport } from './routes/_authenticated/_shell/production/productionLinesStatus/$productionLineId'
import { Route as AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRouteImport } from './routes/_authenticated/_shell/production/systemDiagrams/$systemDiagramId'
import { Route as AuthenticatedShellProjectDeliveryAllDeliveriesRouteImport } from './routes/_authenticated/_shell/project/delivery/allDeliveries'
import { Route as AuthenticatedShellProjectDeliveryAllDeliveryPackagesRouteImport } from './routes/_authenticated/_shell/project/delivery/allDeliveryPackages'
import { Route as AuthenticatedShellProjectDeliveryDeliverableActivitiesRouteImport } from './routes/_authenticated/_shell/project/delivery/deliverableActivities'
import { Route as AuthenticatedShellProjectDeliveryDeliverableProjectsRouteImport } from './routes/_authenticated/_shell/project/delivery/deliverableProjects'
import { Route as AuthenticatedShellProjectDeliveryDeliverableSubProjectsRouteImport } from './routes/_authenticated/_shell/project/delivery/deliverableSubProjects'
import { Route as AuthenticatedShellProjectDeliveryPickableProjectsRouteImport } from './routes/_authenticated/_shell/project/delivery/pickableProjects'
import { Route as AuthenticatedShellProjectDeliveryUndeliveredPackagesRouteImport } from './routes/_authenticated/_shell/project/delivery/undeliveredPackages'
import { Route as AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRouteImport } from './routes/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries'
import { Route as AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRouteImport } from './routes/_authenticated/_shell/sales/delivery/deliverableCustomerOrders'
import { Route as AuthenticatedShellSalesDeliveryOwnTransportsRouteImport } from './routes/_authenticated/_shell/sales/delivery/ownTransports'
import { Route as AuthenticatedShellSalesDeliveryTransportPlanningRouteImport } from './routes/_authenticated/_shell/sales/delivery/transportPlanning'
import { Route as AuthenticatedShellSalesDeliveryTransportsRouteImport } from './routes/_authenticated/_shell/sales/delivery/transports'
import { Route as AuthenticatedShellSalesPickingAllDeliveryPackagesRouteImport } from './routes/_authenticated/_shell/sales/picking/allDeliveryPackages'
import { Route as AuthenticatedShellSalesPickingPickableCustomerOrdersRouteImport } from './routes/_authenticated/_shell/sales/picking/pickableCustomerOrders'
import { Route as AuthenticatedShellSalesPickingUndeliveredPackagesRouteImport } from './routes/_authenticated/_shell/sales/picking/undeliveredPackages'
import { Route as AuthenticatedShellSalesPricingPriceListsRouteImport } from './routes/_authenticated/_shell/sales/pricing/priceLists'
import { Route as AuthenticatedShellSalesSalesCommissionsCreatePaymentRouteImport } from './routes/_authenticated/_shell/sales/salesCommissions/createPayment'
import { Route as AuthenticatedShellSalesSalesCommissionsLineNamesRouteImport } from './routes/_authenticated/_shell/sales/salesCommissions/lineNames'
import { Route as AuthenticatedShellSalesSalesCommissionsPaymentsRouteImport } from './routes/_authenticated/_shell/sales/salesCommissions/payments'
import { Route as AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRouteImport } from './routes/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines'
import { Route as AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRouteImport } from './routes/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId'
import { Route as AuthenticatedShellSpcCChartEventsSearchRouteImport } from './routes/_authenticated/_shell/spc/cChartEvents/search'
import { Route as AuthenticatedShellSpcControlChartCollectionsManagementRouteImport } from './routes/_authenticated/_shell/spc/controlChartCollections/management'
import { Route as AuthenticatedShellSpcControlChartParentGroupParentGroupIdRouteImport } from './routes/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId'
import { Route as AuthenticatedShellSpcDefectGroupsParentGroupIdRouteImport } from './routes/_authenticated/_shell/spc/defectGroups/$parentGroupId'
import { Route as AuthenticatedShellSpcMasterDataYieldChartsRouteImport } from './routes/_authenticated/_shell/spc/masterData/yieldCharts'
import { Route as AuthenticatedShellSpcSpecialCausesChartGroupsRouteImport } from './routes/_authenticated/_shell/spc/specialCauses/chartGroups'
import { Route as AuthenticatedShellSpcSpecialCausesResourcesRouteImport } from './routes/_authenticated/_shell/spc/specialCauses/resources'
import { Route as AuthenticatedShellSpcSummaryViewsIndexRouteImport } from './routes/_authenticated/_shell/spc/summaryViews/index'
import { Route as AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRouteImport } from './routes/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId'
import { Route as AuthenticatedShellSurveysSubmissionsAuditRouteImport } from './routes/_authenticated/_shell/surveys/submissions/audit'
import { Route as AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRouteImport } from './routes/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents'
import { Route as AuthenticatedShellWarehouseInventoryManualEventsRouteImport } from './routes/_authenticated/_shell/warehouse/inventory/manualEvents'
import { Route as AuthenticatedShellWarehouseInventoryStockCountsRouteImport } from './routes/_authenticated/_shell/warehouse/inventory/stockCounts'
import { Route as AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRouteImport } from './routes/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines'
import { Route as AuthenticatedShellErpProjectDeliveryBundlingRouteImport } from './routes/_authenticated/_shell/erp/project/delivery/bundling'
import { Route as AuthenticatedShellErpProjectDeliveryLoadingRouteImport } from './routes/_authenticated/_shell/erp/project/delivery/loading'
import { Route as AuthenticatedShellErpProjectDeliveryOutboundWarehouseRouteImport } from './routes/_authenticated/_shell/erp/project/delivery/outboundWarehouse'
import { Route as AuthenticatedShellErpSalesDeliveryBundlingRouteImport } from './routes/_authenticated/_shell/erp/sales/delivery/bundling'
import { Route as AuthenticatedShellErpSalesDeliveryLoadingRouteImport } from './routes/_authenticated/_shell/erp/sales/delivery/loading'
import { Route as AuthenticatedShellErpSalesDeliveryOutboundWarehouseRouteImport } from './routes/_authenticated/_shell/erp/sales/delivery/outboundWarehouse'
import { Route as AuthenticatedShellErpSalesInvoicingAllInvoicesRouteImport } from './routes/_authenticated/_shell/erp/sales/invoicing/allInvoices'
import { Route as AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRouteImport } from './routes/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders'
import { Route as AuthenticatedShellErpSalesReportsCustomerOrderBacklogRouteImport } from './routes/_authenticated/_shell/erp/sales/reports/customerOrderBacklog'
import { Route as AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRouteImport } from './routes/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog'
import { Route as AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRouteImport } from './routes/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue'
import { Route as AuthenticatedShellErpWarehouseReportsWarehouseValueRouteImport } from './routes/_authenticated/_shell/erp/warehouse/reports/warehouseValue'
import { Route as AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRouteImport } from './routes/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
import { Route as AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRouteImport } from './routes/_authenticated/_shell/spc/controlChartCollections/view/$collectionId'
import { Route as AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRouteImport } from './routes/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId'
import { Route as AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRouteImport } from './routes/_authenticated/_shell/spc/processDiagrams/resources/$resourceId'
import { Route as AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRouteImport } from './routes/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId'
import { Route as AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRouteImport } from './routes/_authenticated/_shell/spc/summaryViews/grid/$summaryViewId'
import { Route as AuthenticatedShellErpSalesInvoicingReportsInvoicesRouteImport } from './routes/_authenticated/_shell/erp/sales/invoicing/reports/invoices'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailVerifiedRoute = EmailVerifiedRouteImport.update({
  id: '/emailVerified',
  path: '/emailVerified',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexDothtmlRoute = IndexDothtmlRouteImport.update({
  id: '/index.html',
  path: '/index.html',
  getParentRoute: () => rootRouteImport,
} as any)
const InsufficientPermissionsRoute = InsufficientPermissionsRouteImport.update({
  id: '/insufficientPermissions',
  path: '/insufficientPermissions',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedOutRoute = LoggedOutRouteImport.update({
  id: '/loggedOut',
  path: '/loggedOut',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellRoute = AuthenticatedShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const CustomAppWindowWindowIdRoute = CustomAppWindowWindowIdRouteImport.update({
  id: '/customAppWindow/$windowId',
  path: '/customAppWindow/$windowId',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewsSplatRoute = ViewsSplatRouteImport.update({
  id: '/views/$',
  path: '/views/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellIndexRoute = AuthenticatedShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellBiRoute = AuthenticatedShellBiRouteImport.update({
  id: '/bi',
  path: '/bi',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellDevTestRoute =
  AuthenticatedShellDevTestRouteImport.update({
    id: '/devTest',
    path: '/devTest',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const ConnectionOauthCallbackRoute = ConnectionOauthCallbackRouteImport.update({
  id: '/connection/oauth/callback',
  path: '/connection/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const WopiActionFileIdRoute = WopiActionFileIdRouteImport.update({
  id: '/wopi/$action/$fileId',
  path: '/wopi/$action/$fileId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellAiCostsRoute =
  AuthenticatedShellAiCostsRouteImport.update({
    id: '/ai/costs',
    path: '/ai/costs',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellAiManagementRoute =
  AuthenticatedShellAiManagementRouteImport.update({
    id: '/ai/management',
    path: '/ai/management',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellAppsCustomAppIdRoute =
  AuthenticatedShellAppsCustomAppIdRouteImport.update({
    id: '/apps/$customAppId',
    path: '/apps/$customAppId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonCompaniesRoute =
  AuthenticatedShellCommonCompaniesRouteImport.update({
    id: '/common/companies',
    path: '/common/companies',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonCurrenciesRoute =
  AuthenticatedShellCommonCurrenciesRouteImport.update({
    id: '/common/currencies',
    path: '/common/currencies',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonDocumentTemplatesRoute =
  AuthenticatedShellCommonDocumentTemplatesRouteImport.update({
    id: '/common/documentTemplates',
    path: '/common/documentTemplates',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonEmailTemplatesRoute =
  AuthenticatedShellCommonEmailTemplatesRouteImport.update({
    id: '/common/emailTemplates',
    path: '/common/emailTemplates',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonNumberSequencesRoute =
  AuthenticatedShellCommonNumberSequencesRouteImport.update({
    id: '/common/numberSequences',
    path: '/common/numberSequences',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonObjectAttributeFieldsRoute =
  AuthenticatedShellCommonObjectAttributeFieldsRouteImport.update({
    id: '/common/objectAttributeFields',
    path: '/common/objectAttributeFields',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonSitesRoute =
  AuthenticatedShellCommonSitesRouteImport.update({
    id: '/common/sites',
    path: '/common/sites',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonSystemDiagramsRoute =
  AuthenticatedShellCommonSystemDiagramsRouteImport.update({
    id: '/common/systemDiagrams',
    path: '/common/systemDiagrams',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellConfiguratorLibrariesRoute =
  AuthenticatedShellConfiguratorLibrariesRouteImport.update({
    id: '/configurator/libraries',
    path: '/configurator/libraries',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellConfiguratorOptionListsRoute =
  AuthenticatedShellConfiguratorOptionListsRouteImport.update({
    id: '/configurator/optionLists',
    path: '/configurator/optionLists',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellConfiguratorProductFamiliesRoute =
  AuthenticatedShellConfiguratorProductFamiliesRouteImport.update({
    id: '/configurator/productFamilies',
    path: '/configurator/productFamilies',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellConfiguratorProductFamilyCategoriesRoute =
  AuthenticatedShellConfiguratorProductFamilyCategoriesRouteImport.update({
    id: '/configurator/productFamilyCategories',
    path: '/configurator/productFamilyCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellConfiguratorTablesRoute =
  AuthenticatedShellConfiguratorTablesRouteImport.update({
    id: '/configurator/tables',
    path: '/configurator/tables',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmContactsRoute =
  AuthenticatedShellCrmContactsRouteImport.update({
    id: '/crm/contacts',
    path: '/crm/contacts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmCustomersRoute =
  AuthenticatedShellCrmCustomersRouteImport.update({
    id: '/crm/customers',
    path: '/crm/customers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmIncomingLeadsRoute =
  AuthenticatedShellCrmIncomingLeadsRouteImport.update({
    id: '/crm/incomingLeads',
    path: '/crm/incomingLeads',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesAreasRoute =
  AuthenticatedShellCrmSalesAreasRouteImport.update({
    id: '/crm/salesAreas',
    path: '/crm/salesAreas',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesLeadActivitiesRoute =
  AuthenticatedShellCrmSalesLeadActivitiesRouteImport.update({
    id: '/crm/salesLeadActivities',
    path: '/crm/salesLeadActivities',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesLeadActivityCategoriesRoute =
  AuthenticatedShellCrmSalesLeadActivityCategoriesRouteImport.update({
    id: '/crm/salesLeadActivityCategories',
    path: '/crm/salesLeadActivityCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesLeadSourcesRoute =
  AuthenticatedShellCrmSalesLeadSourcesRouteImport.update({
    id: '/crm/salesLeadSources',
    path: '/crm/salesLeadSources',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesLeadsRoute =
  AuthenticatedShellCrmSalesLeadsRouteImport.update({
    id: '/crm/salesLeads',
    path: '/crm/salesLeads',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesPipelineRoute =
  AuthenticatedShellCrmSalesPipelineRouteImport.update({
    id: '/crm/salesPipeline',
    path: '/crm/salesPipeline',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCrmSalesPipelineBoardRoute =
  AuthenticatedShellCrmSalesPipelineBoardRouteImport.update({
    id: '/crm/salesPipelineBoard',
    path: '/crm/salesPipelineBoard',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCustomizationsApiConnectionsRoute =
  AuthenticatedShellCustomizationsApiConnectionsRouteImport.update({
    id: '/customizations/api-connections',
    path: '/customizations/api-connections',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCustomizationsApiKeysRoute =
  AuthenticatedShellCustomizationsApiKeysRouteImport.update({
    id: '/customizations/api-keys',
    path: '/customizations/api-keys',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCustomizationsCustomAppsRoute =
  AuthenticatedShellCustomizationsCustomAppsRouteImport.update({
    id: '/customizations/custom-apps',
    path: '/customizations/custom-apps',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCustomizationsCustomFunctionsRoute =
  AuthenticatedShellCustomizationsCustomFunctionsRouteImport.update({
    id: '/customizations/custom-functions',
    path: '/customizations/custom-functions',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCustomizationsSentEmailsRoute =
  AuthenticatedShellCustomizationsSentEmailsRouteImport.update({
    id: '/customizations/sent-emails',
    path: '/customizations/sent-emails',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellDocumentsDocumentCategoriesRoute =
  AuthenticatedShellDocumentsDocumentCategoriesRouteImport.update({
    id: '/documents/documentCategories',
    path: '/documents/documentCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellDocumentsSearchRoute =
  AuthenticatedShellDocumentsSearchRouteImport.update({
    id: '/documents/search',
    path: '/documents/search',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLisToLsbRoute =
  AuthenticatedShellMellanoLisToLsbRouteImport.update({
    id: '/mellano/lisToLsb',
    path: '/mellano/lisToLsb',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoPaintingControlChartsRoute =
  AuthenticatedShellMellanoPaintingControlChartsRouteImport.update({
    id: '/mellano/paintingControlCharts',
    path: '/mellano/paintingControlCharts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductDesignBomLineGroupsRoute =
  AuthenticatedShellProductDesignBomLineGroupsRouteImport.update({
    id: '/productDesign/bomLineGroups',
    path: '/productDesign/bomLineGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementCatalogPartsRoute =
  AuthenticatedShellProductManagementCatalogPartsRouteImport.update({
    id: '/productManagement/catalogParts',
    path: '/productManagement/catalogParts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementPartCategoriesRoute =
  AuthenticatedShellProductManagementPartCategoriesRouteImport.update({
    id: '/productManagement/partCategories',
    path: '/productManagement/partCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementProductChangeCategoriesRoute =
  AuthenticatedShellProductManagementProductChangeCategoriesRouteImport.update({
    id: '/productManagement/productChangeCategories',
    path: '/productManagement/productChangeCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementProductChangePackagesRoute =
  AuthenticatedShellProductManagementProductChangePackagesRouteImport.update({
    id: '/productManagement/productChangePackages',
    path: '/productManagement/productChangePackages',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementProductChangeRequestsRoute =
  AuthenticatedShellProductManagementProductChangeRequestsRouteImport.update({
    id: '/productManagement/productChangeRequests',
    path: '/productManagement/productChangeRequests',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementProductChangesRoute =
  AuthenticatedShellProductManagementProductChangesRouteImport.update({
    id: '/productManagement/productChanges',
    path: '/productManagement/productChanges',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementSearchPartsByAttributesRoute =
  AuthenticatedShellProductManagementSearchPartsByAttributesRouteImport.update({
    id: '/productManagement/searchPartsByAttributes',
    path: '/productManagement/searchPartsByAttributes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductManagementUnitsRoute =
  AuthenticatedShellProductManagementUnitsRouteImport.update({
    id: '/productManagement/units',
    path: '/productManagement/units',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionOnProductionLineRoute =
  AuthenticatedShellProductionOnProductionLineRouteImport.update({
    id: '/production/onProductionLine',
    path: '/production/onProductionLine',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionOperationsRoute =
  AuthenticatedShellProductionOperationsRouteImport.update({
    id: '/production/operations',
    path: '/production/operations',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionProductionLineGroupJobQueueRoute =
  AuthenticatedShellProductionProductionLineGroupJobQueueRouteImport.update({
    id: '/production/productionLineGroupJobQueue',
    path: '/production/productionLineGroupJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionProductionLineJobQueueRoute =
  AuthenticatedShellProductionProductionLineJobQueueRouteImport.update({
    id: '/production/productionLineJobQueue',
    path: '/production/productionLineJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionProductionLinesRoute =
  AuthenticatedShellProductionProductionLinesRouteImport.update({
    id: '/production/productionLines',
    path: '/production/productionLines',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionShopOrderBatchJobQueueRoute =
  AuthenticatedShellProductionShopOrderBatchJobQueueRouteImport.update({
    id: '/production/shopOrderBatchJobQueue',
    path: '/production/shopOrderBatchJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionShopOrderBatchesRoute =
  AuthenticatedShellProductionShopOrderBatchesRouteImport.update({
    id: '/production/shopOrderBatches',
    path: '/production/shopOrderBatches',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionShopOrderPackagingRoute =
  AuthenticatedShellProductionShopOrderPackagingRouteImport.update({
    id: '/production/shopOrderPackaging',
    path: '/production/shopOrderPackaging',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionShopOrdersRoute =
  AuthenticatedShellProductionShopOrdersRouteImport.update({
    id: '/production/shopOrders',
    path: '/production/shopOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionSubcontractingJobQueueRoute =
  AuthenticatedShellProductionSubcontractingJobQueueRouteImport.update({
    id: '/production/subcontractingJobQueue',
    path: '/production/subcontractingJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionSupplementShopOrderRoute =
  AuthenticatedShellProductionSupplementShopOrderRouteImport.update({
    id: '/production/supplementShopOrder',
    path: '/production/supplementShopOrder',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute =
  AuthenticatedShellProductionWorkCenterIncompleteOperationsRouteImport.update({
    id: '/production/workCenterIncompleteOperations',
    path: '/production/workCenterIncompleteOperations',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionWorkCenterJobQueueRoute =
  AuthenticatedShellProductionWorkCenterJobQueueRouteImport.update({
    id: '/production/workCenterJobQueue',
    path: '/production/workCenterJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionWorkCentersRoute =
  AuthenticatedShellProductionWorkCentersRouteImport.update({
    id: '/production/workCenters',
    path: '/production/workCenters',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectActivityResourcesRoute =
  AuthenticatedShellProjectActivityResourcesRouteImport.update({
    id: '/project/activityResources',
    path: '/project/activityResources',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectActivityTypesRoute =
  AuthenticatedShellProjectActivityTypesRouteImport.update({
    id: '/project/activityTypes',
    path: '/project/activityTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectCostEventsRoute =
  AuthenticatedShellProjectCostEventsRouteImport.update({
    id: '/project/costEvents',
    path: '/project/costEvents',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectJobQueueRoute =
  AuthenticatedShellProjectJobQueueRouteImport.update({
    id: '/project/jobQueue',
    path: '/project/jobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectProjectTypesRoute =
  AuthenticatedShellProjectProjectTypesRouteImport.update({
    id: '/project/projectTypes',
    path: '/project/projectTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectProjectsRoute =
  AuthenticatedShellProjectProjectsRouteImport.update({
    id: '/project/projects',
    path: '/project/projects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectResourcesGanttRoute =
  AuthenticatedShellProjectResourcesGanttRouteImport.update({
    id: '/project/resourcesGantt',
    path: '/project/resourcesGantt',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectSchedulingRoute =
  AuthenticatedShellProjectSchedulingRouteImport.update({
    id: '/project/scheduling',
    path: '/project/scheduling',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectSubProjectTypesRoute =
  AuthenticatedShellProjectSubProjectTypesRouteImport.update({
    id: '/project/subProjectTypes',
    path: '/project/subProjectTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectTreeRoute =
  AuthenticatedShellProjectTreeRouteImport.update({
    id: '/project/tree',
    path: '/project/tree',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute =
  AuthenticatedShellPurchaseAllPurchaseOrderLinesRouteImport.update({
    id: '/purchase/allPurchaseOrderLines',
    path: '/purchase/allPurchaseOrderLines',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchaseDeliveryNoticesRoute =
  AuthenticatedShellPurchaseDeliveryNoticesRouteImport.update({
    id: '/purchase/deliveryNotices',
    path: '/purchase/deliveryNotices',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchaseProcessViewRoute =
  AuthenticatedShellPurchaseProcessViewRouteImport.update({
    id: '/purchase/processView',
    path: '/purchase/processView',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute =
  AuthenticatedShellPurchasePurchaseOrderConfirmationsRouteImport.update({
    id: '/purchase/purchaseOrderConfirmations',
    path: '/purchase/purchaseOrderConfirmations',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchasePurchaseOrdersRoute =
  AuthenticatedShellPurchasePurchaseOrdersRouteImport.update({
    id: '/purchase/purchaseOrders',
    path: '/purchase/purchaseOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute =
  AuthenticatedShellPurchasePurchaseOrdersToReceiveRouteImport.update({
    id: '/purchase/purchaseOrdersToReceive',
    path: '/purchase/purchaseOrdersToReceive',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPurchasePurchaseRequestsRoute =
  AuthenticatedShellPurchasePurchaseRequestsRouteImport.update({
    id: '/purchase/purchaseRequests',
    path: '/purchase/purchaseRequests',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesAccountingRoute =
  AuthenticatedShellSalesAccountingRouteImport.update({
    id: '/sales/accounting',
    path: '/sales/accounting',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesAllCustomerOrderLinesRoute =
  AuthenticatedShellSalesAllCustomerOrderLinesRouteImport.update({
    id: '/sales/allCustomerOrderLines',
    path: '/sales/allCustomerOrderLines',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesBillingPlanLinesToApproveRoute =
  AuthenticatedShellSalesBillingPlanLinesToApproveRouteImport.update({
    id: '/sales/billingPlanLinesToApprove',
    path: '/sales/billingPlanLinesToApprove',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesBillingPlanModelsRoute =
  AuthenticatedShellSalesBillingPlanModelsRouteImport.update({
    id: '/sales/billingPlanModels',
    path: '/sales/billingPlanModels',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesBillingPlanPartsRoute =
  AuthenticatedShellSalesBillingPlanPartsRouteImport.update({
    id: '/sales/billingPlanParts',
    path: '/sales/billingPlanParts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesContractualTermsRoute =
  AuthenticatedShellSalesContractualTermsRouteImport.update({
    id: '/sales/contractualTerms',
    path: '/sales/contractualTerms',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerGroupsRoute =
  AuthenticatedShellSalesCustomerGroupsRouteImport.update({
    id: '/sales/customerGroups',
    path: '/sales/customerGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerOfferTypesRoute =
  AuthenticatedShellSalesCustomerOfferTypesRouteImport.update({
    id: '/sales/customerOfferTypes',
    path: '/sales/customerOfferTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerOrderSalesConditionsRoute =
  AuthenticatedShellSalesCustomerOrderSalesConditionsRouteImport.update({
    id: '/sales/customerOrderSalesConditions',
    path: '/sales/customerOrderSalesConditions',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerOrderTypesRoute =
  AuthenticatedShellSalesCustomerOrderTypesRouteImport.update({
    id: '/sales/customerOrderTypes',
    path: '/sales/customerOrderTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerOrdersRoute =
  AuthenticatedShellSalesCustomerOrdersRouteImport.update({
    id: '/sales/customerOrders',
    path: '/sales/customerOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomerPriceGroupsRoute =
  AuthenticatedShellSalesCustomerPriceGroupsRouteImport.update({
    id: '/sales/customerPriceGroups',
    path: '/sales/customerPriceGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesCustomersRoute =
  AuthenticatedShellSalesCustomersRouteImport.update({
    id: '/sales/customers',
    path: '/sales/customers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesEInvoiceOperatorsRoute =
  AuthenticatedShellSalesEInvoiceOperatorsRouteImport.update({
    id: '/sales/eInvoiceOperators',
    path: '/sales/eInvoiceOperators',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesOffersRoute =
  AuthenticatedShellSalesOffersRouteImport.update({
    id: '/sales/offers',
    path: '/sales/offers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesOrderDeliveryProcessViewRoute =
  AuthenticatedShellSalesOrderDeliveryProcessViewRouteImport.update({
    id: '/sales/orderDeliveryProcessView',
    path: '/sales/orderDeliveryProcessView',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesPaymentTermRoute =
  AuthenticatedShellSalesPaymentTermRouteImport.update({
    id: '/sales/paymentTerm',
    path: '/sales/paymentTerm',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesReceivedCustomerOrdersRoute =
  AuthenticatedShellSalesReceivedCustomerOrdersRouteImport.update({
    id: '/sales/receivedCustomerOrders',
    path: '/sales/receivedCustomerOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesConditionsRoute =
  AuthenticatedShellSalesSalesConditionsRouteImport.update({
    id: '/sales/salesConditions',
    path: '/sales/salesConditions',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesPartCategoriesRoute =
  AuthenticatedShellSalesSalesPartCategoriesRouteImport.update({
    id: '/sales/salesPartCategories',
    path: '/sales/salesPartCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesPartPriceGroupsRoute =
  AuthenticatedShellSalesSalesPartPriceGroupsRouteImport.update({
    id: '/sales/salesPartPriceGroups',
    path: '/sales/salesPartPriceGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesPartsRoute =
  AuthenticatedShellSalesSalesPartsRouteImport.update({
    id: '/sales/salesParts',
    path: '/sales/salesParts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalespersonsRoute =
  AuthenticatedShellSalesSalespersonsRouteImport.update({
    id: '/sales/salespersons',
    path: '/sales/salespersons',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesTransportRoutesRoute =
  AuthenticatedShellSalesTransportRoutesRouteImport.update({
    id: '/sales/transportRoutes',
    path: '/sales/transportRoutes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesVatCodesRoute =
  AuthenticatedShellSalesVatCodesRouteImport.update({
    id: '/sales/vatCodes',
    path: '/sales/vatCodes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesVatHandlingTypesRoute =
  AuthenticatedShellSalesVatHandlingTypesRouteImport.update({
    id: '/sales/vatHandlingTypes',
    path: '/sales/vatHandlingTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalvosSalesCommissionLimitsRoute =
  AuthenticatedShellSalvosSalesCommissionLimitsRouteImport.update({
    id: '/salvos/salesCommissionLimits',
    path: '/salvos/salesCommissionLimits',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcCalendarsRoute =
  AuthenticatedShellSpcCalendarsRouteImport.update({
    id: '/spc/calendars',
    path: '/spc/calendars',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcControlChartsRoute =
  AuthenticatedShellSpcControlChartsRouteImport.update({
    id: '/spc/controlCharts',
    path: '/spc/controlCharts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcCycleTimeMeasurementRoute =
  AuthenticatedShellSpcCycleTimeMeasurementRouteImport.update({
    id: '/spc/cycleTimeMeasurement',
    path: '/spc/cycleTimeMeasurement',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcDimensionSearchRoute =
  AuthenticatedShellSpcDimensionSearchRouteImport.update({
    id: '/spc/dimensionSearch',
    path: '/spc/dimensionSearch',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcImportDataRoute =
  AuthenticatedShellSpcImportDataRouteImport.update({
    id: '/spc/importData',
    path: '/spc/importData',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcProcessImprovementCategoriesRoute =
  AuthenticatedShellSpcProcessImprovementCategoriesRouteImport.update({
    id: '/spc/processImprovementCategories',
    path: '/spc/processImprovementCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcProcessImprovementsRoute =
  AuthenticatedShellSpcProcessImprovementsRouteImport.update({
    id: '/spc/processImprovements',
    path: '/spc/processImprovements',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcResourcesRoute =
  AuthenticatedShellSpcResourcesRouteImport.update({
    id: '/spc/resources',
    path: '/spc/resources',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcTimeMeasurementRoute =
  AuthenticatedShellSpcTimeMeasurementRouteImport.update({
    id: '/spc/timeMeasurement',
    path: '/spc/timeMeasurement',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcYieldChartsRoute =
  AuthenticatedShellSpcYieldChartsRouteImport.update({
    id: '/spc/yieldCharts',
    path: '/spc/yieldCharts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSurveysSurveyCategoriesRoute =
  AuthenticatedShellSurveysSurveyCategoriesRouteImport.update({
    id: '/surveys/surveyCategories',
    path: '/surveys/surveyCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSurveysSurveyFormsRoute =
  AuthenticatedShellSurveysSurveyFormsRouteImport.update({
    id: '/surveys/surveyForms',
    path: '/surveys/surveyForms',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellTasksAllTasksRoute =
  AuthenticatedShellTasksAllTasksRouteImport.update({
    id: '/tasks/allTasks',
    path: '/tasks/allTasks',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellTasksMyRoute =
  AuthenticatedShellTasksMyRouteImport.update({
    id: '/tasks/my',
    path: '/tasks/my',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellTasksOnMyResponsibilityRoute =
  AuthenticatedShellTasksOnMyResponsibilityRouteImport.update({
    id: '/tasks/onMyResponsibility',
    path: '/tasks/onMyResponsibility',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellTasksTaskTemplatesRoute =
  AuthenticatedShellTasksTaskTemplatesRouteImport.update({
    id: '/tasks/taskTemplates',
    path: '/tasks/taskTemplates',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellUsersManagementRoute =
  AuthenticatedShellUsersManagementRouteImport.update({
    id: '/users/management',
    path: '/users/management',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellUsersRolesRoute =
  AuthenticatedShellUsersRolesRouteImport.update({
    id: '/users/roles',
    path: '/users/roles',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseDataCollectionRoute =
  AuthenticatedShellWarehouseDataCollectionRouteImport.update({
    id: '/warehouse/dataCollection',
    path: '/warehouse/dataCollection',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseDeliveryPackageTypesRoute =
  AuthenticatedShellWarehouseDeliveryPackageTypesRouteImport.update({
    id: '/warehouse/deliveryPackageTypes',
    path: '/warehouse/deliveryPackageTypes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseInventoryLevelProfileRoute =
  AuthenticatedShellWarehouseInventoryLevelProfileRouteImport.update({
    id: '/warehouse/inventoryLevelProfile',
    path: '/warehouse/inventoryLevelProfile',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehousePartCostCalculationRoute =
  AuthenticatedShellWarehousePartCostCalculationRouteImport.update({
    id: '/warehouse/partCostCalculation',
    path: '/warehouse/partCostCalculation',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehousePartImportCodesRoute =
  AuthenticatedShellWarehousePartImportCodesRouteImport.update({
    id: '/warehouse/partImportCodes',
    path: '/warehouse/partImportCodes',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehousePartsRoute =
  AuthenticatedShellWarehousePartsRouteImport.update({
    id: '/warehouse/parts',
    path: '/warehouse/parts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseTransferJobQueueRoute =
  AuthenticatedShellWarehouseTransferJobQueueRouteImport.update({
    id: '/warehouse/transferJobQueue',
    path: '/warehouse/transferJobQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseUnverifiedPartsRoute =
  AuthenticatedShellWarehouseUnverifiedPartsRouteImport.update({
    id: '/warehouse/unverifiedParts',
    path: '/warehouse/unverifiedParts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseWarehouseLocationPartsRoute =
  AuthenticatedShellWarehouseWarehouseLocationPartsRouteImport.update({
    id: '/warehouse/warehouseLocationParts',
    path: '/warehouse/warehouseLocationParts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseWarehouseLocationsRoute =
  AuthenticatedShellWarehouseWarehouseLocationsRouteImport.update({
    id: '/warehouse/warehouseLocations',
    path: '/warehouse/warehouseLocations',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseWarehouseTransfersRoute =
  AuthenticatedShellWarehouseWarehouseTransfersRouteImport.update({
    id: '/warehouse/warehouseTransfers',
    path: '/warehouse/warehouseTransfers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWorkspaceCategoriesRoute =
  AuthenticatedShellWorkspaceCategoriesRouteImport.update({
    id: '/workspace/categories',
    path: '/workspace/categories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWorkspaceWorkspacesRoute =
  AuthenticatedShellWorkspaceWorkspacesRouteImport.update({
    id: '/workspace/workspaces',
    path: '/workspace/workspaces',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonAccountingAccountsRoute =
  AuthenticatedShellCommonAccountingAccountsRouteImport.update({
    id: '/common/accounting/accounts',
    path: '/common/accounting/accounts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellCommonAccountingDimensionsRoute =
  AuthenticatedShellCommonAccountingDimensionsRouteImport.update({
    id: '/common/accounting/dimensions',
    path: '/common/accounting/dimensions',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpCommonAddCostEventRoute =
  AuthenticatedShellErpCommonAddCostEventRouteImport.update({
    id: '/erp/common/addCostEvent',
    path: '/erp/common/addCostEvent',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute =
  AuthenticatedShellErpCommonCostEventObjectTypeSettingsRouteImport.update({
    id: '/erp/common/costEventObjectTypeSettings',
    path: '/erp/common/costEventObjectTypeSettings',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpCommonCostEventPriceListsRoute =
  AuthenticatedShellErpCommonCostEventPriceListsRouteImport.update({
    id: '/erp/common/costEventPriceLists',
    path: '/erp/common/costEventPriceLists',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpCommonCostEventsRoute =
  AuthenticatedShellErpCommonCostEventsRouteImport.update({
    id: '/erp/common/costEvents',
    path: '/erp/common/costEvents',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpConfiguratorLogSearchRoute =
  AuthenticatedShellErpConfiguratorLogSearchRouteImport.update({
    id: '/erp/configurator/logSearch',
    path: '/erp/configurator/logSearch',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpDeliveryTransportEquipmentRoute =
  AuthenticatedShellErpDeliveryTransportEquipmentRouteImport.update({
    id: '/erp/delivery/transportEquipment',
    path: '/erp/delivery/transportEquipment',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpInventoryForecastRoute =
  AuthenticatedShellErpInventoryForecastRouteImport.update({
    id: '/erp/inventory/forecast',
    path: '/erp/inventory/forecast',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProductionCapacityRoute =
  AuthenticatedShellErpProductionCapacityRouteImport.update({
    id: '/erp/production/capacity',
    path: '/erp/production/capacity',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProductionCompletedQuantityRoute =
  AuthenticatedShellErpProductionCompletedQuantityRouteImport.update({
    id: '/erp/production/completedQuantity',
    path: '/erp/production/completedQuantity',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProductionLoadChartRoute =
  AuthenticatedShellErpProductionLoadChartRouteImport.update({
    id: '/erp/production/loadChart',
    path: '/erp/production/loadChart',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProductionProductionPlanningRoute =
  AuthenticatedShellErpProductionProductionPlanningRouteImport.update({
    id: '/erp/production/productionPlanning',
    path: '/erp/production/productionPlanning',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProductionSalesProductionBacklogRoute =
  AuthenticatedShellErpProductionSalesProductionBacklogRouteImport.update({
    id: '/erp/production/salesProductionBacklog',
    path: '/erp/production/salesProductionBacklog',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpPurchaseSupplierGroupsRoute =
  AuthenticatedShellErpPurchaseSupplierGroupsRouteImport.update({
    id: '/erp/purchase/supplierGroups',
    path: '/erp/purchase/supplierGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpPurchaseSuppliersRoute =
  AuthenticatedShellErpPurchaseSuppliersRouteImport.update({
    id: '/erp/purchase/suppliers',
    path: '/erp/purchase/suppliers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsReclamationCategoryRoute =
  AuthenticatedShellErpReclamationsReclamationCategoryRouteImport.update({
    id: '/erp/reclamations/reclamationCategory',
    path: '/erp/reclamations/reclamationCategory',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsReclamationCauseRoute =
  AuthenticatedShellErpReclamationsReclamationCauseRouteImport.update({
    id: '/erp/reclamations/reclamationCause',
    path: '/erp/reclamations/reclamationCause',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute =
  AuthenticatedShellErpReclamationsReclamationHandlingMethodRouteImport.update({
    id: '/erp/reclamations/reclamationHandlingMethod',
    path: '/erp/reclamations/reclamationHandlingMethod',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsReclamationLocationRoute =
  AuthenticatedShellErpReclamationsReclamationLocationRouteImport.update({
    id: '/erp/reclamations/reclamationLocation',
    path: '/erp/reclamations/reclamationLocation',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsReclamationsRoute =
  AuthenticatedShellErpReclamationsReclamationsRouteImport.update({
    id: '/erp/reclamations/reclamations',
    path: '/erp/reclamations/reclamations',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsRoundsRoute =
  AuthenticatedShellErpReclamationsRoundsRouteImport.update({
    id: '/erp/reclamations/rounds',
    path: '/erp/reclamations/rounds',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsWeekPlanningRoute =
  AuthenticatedShellErpReclamationsWeekPlanningRouteImport.update({
    id: '/erp/reclamations/weekPlanning',
    path: '/erp/reclamations/weekPlanning',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpReclamationsWorkQueueRoute =
  AuthenticatedShellErpReclamationsWorkQueueRouteImport.update({
    id: '/erp/reclamations/workQueue',
    path: '/erp/reclamations/workQueue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute =
  AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRouteImport.update({
    id: '/erp/safetyControlSurvey/noteCategories',
    path: '/erp/safetyControlSurvey/noteCategories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSafetyControlSurveySummaryRoute =
  AuthenticatedShellErpSafetyControlSurveySummaryRouteImport.update({
    id: '/erp/safetyControlSurvey/summary',
    path: '/erp/safetyControlSurvey/summary',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSafetyControlSurveySurveysRoute =
  AuthenticatedShellErpSafetyControlSurveySurveysRouteImport.update({
    id: '/erp/safetyControlSurvey/surveys',
    path: '/erp/safetyControlSurvey/surveys',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSafetyControlSurveyTeamsRoute =
  AuthenticatedShellErpSafetyControlSurveyTeamsRouteImport.update({
    id: '/erp/safetyControlSurvey/teams',
    path: '/erp/safetyControlSurvey/teams',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesCustomerOrderImportRoute =
  AuthenticatedShellErpSalesCustomerOrderImportRouteImport.update({
    id: '/erp/sales/customerOrderImport',
    path: '/erp/sales/customerOrderImport',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpVertexIndConfigRoute =
  AuthenticatedShellErpVertexIndConfigRouteImport.update({
    id: '/erp/vertexInd/config',
    path: '/erp/vertexInd/config',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseCargoDriversRoute =
  AuthenticatedShellErpWarehouseCargoDriversRouteImport.update({
    id: '/erp/warehouse/cargoDrivers',
    path: '/erp/warehouse/cargoDrivers',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseDeliveryMethodsRoute =
  AuthenticatedShellErpWarehouseDeliveryMethodsRouteImport.update({
    id: '/erp/warehouse/deliveryMethods',
    path: '/erp/warehouse/deliveryMethods',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseDeliveryTermsRoute =
  AuthenticatedShellErpWarehouseDeliveryTermsRouteImport.update({
    id: '/erp/warehouse/deliveryTerms',
    path: '/erp/warehouse/deliveryTerms',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute =
  AuthenticatedShellErpWarehouseWarehousePickerGroupsRouteImport.update({
    id: '/erp/warehouse/warehousePickerGroups',
    path: '/erp/warehouse/warehousePickerGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute =
  AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRouteImport.update({
    id: '/erp/warehouse/warehouseReplenishmentGroups',
    path: '/erp/warehouse/warehouseReplenishmentGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuCapacityRoute =
  AuthenticatedShellMellanoLuukkuCapacityRouteImport.update({
    id: '/mellano/luukku/capacity',
    path: '/mellano/luukku/capacity',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuDataCollectionRoute =
  AuthenticatedShellMellanoLuukkuDataCollectionRouteImport.update({
    id: '/mellano/luukku/dataCollection',
    path: '/mellano/luukku/dataCollection',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuDispatchSlottingRoute =
  AuthenticatedShellMellanoLuukkuDispatchSlottingRouteImport.update({
    id: '/mellano/luukku/dispatchSlotting',
    path: '/mellano/luukku/dispatchSlotting',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuDrillStampsRoute =
  AuthenticatedShellMellanoLuukkuDrillStampsRouteImport.update({
    id: '/mellano/luukku/drillStamps',
    path: '/mellano/luukku/drillStamps',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute =
  AuthenticatedShellMellanoLuukkuHandPaintingPlanRouteImport.update({
    id: '/mellano/luukku/handPaintingPlan',
    path: '/mellano/luukku/handPaintingPlan',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuKetMetricsRoute =
  AuthenticatedShellMellanoLuukkuKetMetricsRouteImport.update({
    id: '/mellano/luukku/ketMetrics',
    path: '/mellano/luukku/ketMetrics',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute =
  AuthenticatedShellMellanoLuukkuMelamineStockForecastRouteImport.update({
    id: '/mellano/luukku/melamineStockForecast',
    path: '/mellano/luukku/melamineStockForecast',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuOrderStatusRoute =
  AuthenticatedShellMellanoLuukkuOrderStatusRouteImport.update({
    id: '/mellano/luukku/orderStatus',
    path: '/mellano/luukku/orderStatus',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPackagedAmountRoute =
  AuthenticatedShellMellanoLuukkuPackagedAmountRouteImport.update({
    id: '/mellano/luukku/packagedAmount',
    path: '/mellano/luukku/packagedAmount',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPaintStockForecastRoute =
  AuthenticatedShellMellanoLuukkuPaintStockForecastRouteImport.update({
    id: '/mellano/luukku/paintStockForecast',
    path: '/mellano/luukku/paintStockForecast',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPaintingPlanRoute =
  AuthenticatedShellMellanoLuukkuPaintingPlanRouteImport.update({
    id: '/mellano/luukku/paintingPlan',
    path: '/mellano/luukku/paintingPlan',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute =
  AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRouteImport.update({
    id: '/mellano/luukku/paintingRoundDefects',
    path: '/mellano/luukku/paintingRoundDefects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPaintingRoundsRoute =
  AuthenticatedShellMellanoLuukkuPaintingRoundsRouteImport.update({
    id: '/mellano/luukku/paintingRounds',
    path: '/mellano/luukku/paintingRounds',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuProductionPlanningRoute =
  AuthenticatedShellMellanoLuukkuProductionPlanningRouteImport.update({
    id: '/mellano/luukku/productionPlanning',
    path: '/mellano/luukku/productionPlanning',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuProductionStatusRoute =
  AuthenticatedShellMellanoLuukkuProductionStatusRouteImport.update({
    id: '/mellano/luukku/productionStatus',
    path: '/mellano/luukku/productionStatus',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute =
  AuthenticatedShellMellanoLuukkuPurchaseOrderImportRouteImport.update({
    id: '/mellano/luukku/purchaseOrderImport',
    path: '/mellano/luukku/purchaseOrderImport',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute =
  AuthenticatedShellMellanoLuukkuPurchaseSuggestionRouteImport.update({
    id: '/mellano/luukku/purchaseSuggestion',
    path: '/mellano/luukku/purchaseSuggestion',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuShiftDefectsRoute =
  AuthenticatedShellMellanoLuukkuShiftDefectsRouteImport.update({
    id: '/mellano/luukku/shiftDefects',
    path: '/mellano/luukku/shiftDefects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute =
  AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRouteImport.update({
    id: '/mellano/luukku/unpackagedDeliveryBatches',
    path: '/mellano/luukku/unpackagedDeliveryBatches',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute =
  AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRouteImport.update({
    id: '/mellano/luukku/unsentDeliveriesByAddress',
    path: '/mellano/luukku/unsentDeliveriesByAddress',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute =
  AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRouteImport.update({
    id: '/mellano/luukku/unsentRonkkoDeliveries',
    path: '/mellano/luukku/unsentRonkkoDeliveries',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute =
  AuthenticatedShellMellanoLuukkuWorkOrderSlottingRouteImport.update({
    id: '/mellano/luukku/workOrderSlotting',
    path: '/mellano/luukku/workOrderSlotting',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMellanoWinnerDesignsRoute =
  AuthenticatedShellMellanoWinnerDesignsRouteImport.update({
    id: '/mellano/winner/designs',
    path: '/mellano/winner/designs',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute =
  AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRouteImport.update(
    {
      id: '/production/productionLineGroupStatus/$productionLineGroupId',
      path: '/production/productionLineGroupStatus/$productionLineGroupId',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute =
  AuthenticatedShellProductionProductionLinesStatusProductionLineIdRouteImport.update(
    {
      id: '/production/productionLinesStatus/$productionLineId',
      path: '/production/productionLinesStatus/$productionLineId',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute =
  AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRouteImport.update({
    id: '/production/systemDiagrams/$systemDiagramId',
    path: '/production/systemDiagrams/$systemDiagramId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryAllDeliveriesRoute =
  AuthenticatedShellProjectDeliveryAllDeliveriesRouteImport.update({
    id: '/project/delivery/allDeliveries',
    path: '/project/delivery/allDeliveries',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute =
  AuthenticatedShellProjectDeliveryAllDeliveryPackagesRouteImport.update({
    id: '/project/delivery/allDeliveryPackages',
    path: '/project/delivery/allDeliveryPackages',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute =
  AuthenticatedShellProjectDeliveryDeliverableActivitiesRouteImport.update({
    id: '/project/delivery/deliverableActivities',
    path: '/project/delivery/deliverableActivities',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryDeliverableProjectsRoute =
  AuthenticatedShellProjectDeliveryDeliverableProjectsRouteImport.update({
    id: '/project/delivery/deliverableProjects',
    path: '/project/delivery/deliverableProjects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute =
  AuthenticatedShellProjectDeliveryDeliverableSubProjectsRouteImport.update({
    id: '/project/delivery/deliverableSubProjects',
    path: '/project/delivery/deliverableSubProjects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryPickableProjectsRoute =
  AuthenticatedShellProjectDeliveryPickableProjectsRouteImport.update({
    id: '/project/delivery/pickableProjects',
    path: '/project/delivery/pickableProjects',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute =
  AuthenticatedShellProjectDeliveryUndeliveredPackagesRouteImport.update({
    id: '/project/delivery/undeliveredPackages',
    path: '/project/delivery/undeliveredPackages',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute =
  AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRouteImport.update({
    id: '/sales/delivery/allCustomerOrderDeliveries',
    path: '/sales/delivery/allCustomerOrderDeliveries',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute =
  AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRouteImport.update({
    id: '/sales/delivery/deliverableCustomerOrders',
    path: '/sales/delivery/deliverableCustomerOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesDeliveryOwnTransportsRoute =
  AuthenticatedShellSalesDeliveryOwnTransportsRouteImport.update({
    id: '/sales/delivery/ownTransports',
    path: '/sales/delivery/ownTransports',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesDeliveryTransportPlanningRoute =
  AuthenticatedShellSalesDeliveryTransportPlanningRouteImport.update({
    id: '/sales/delivery/transportPlanning',
    path: '/sales/delivery/transportPlanning',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesDeliveryTransportsRoute =
  AuthenticatedShellSalesDeliveryTransportsRouteImport.update({
    id: '/sales/delivery/transports',
    path: '/sales/delivery/transports',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesPickingAllDeliveryPackagesRoute =
  AuthenticatedShellSalesPickingAllDeliveryPackagesRouteImport.update({
    id: '/sales/picking/allDeliveryPackages',
    path: '/sales/picking/allDeliveryPackages',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesPickingPickableCustomerOrdersRoute =
  AuthenticatedShellSalesPickingPickableCustomerOrdersRouteImport.update({
    id: '/sales/picking/pickableCustomerOrders',
    path: '/sales/picking/pickableCustomerOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesPickingUndeliveredPackagesRoute =
  AuthenticatedShellSalesPickingUndeliveredPackagesRouteImport.update({
    id: '/sales/picking/undeliveredPackages',
    path: '/sales/picking/undeliveredPackages',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesPricingPriceListsRoute =
  AuthenticatedShellSalesPricingPriceListsRouteImport.update({
    id: '/sales/pricing/priceLists',
    path: '/sales/pricing/priceLists',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute =
  AuthenticatedShellSalesSalesCommissionsCreatePaymentRouteImport.update({
    id: '/sales/salesCommissions/createPayment',
    path: '/sales/salesCommissions/createPayment',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesCommissionsLineNamesRoute =
  AuthenticatedShellSalesSalesCommissionsLineNamesRouteImport.update({
    id: '/sales/salesCommissions/lineNames',
    path: '/sales/salesCommissions/lineNames',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesCommissionsPaymentsRoute =
  AuthenticatedShellSalesSalesCommissionsPaymentsRouteImport.update({
    id: '/sales/salesCommissions/payments',
    path: '/sales/salesCommissions/payments',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute =
  AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRouteImport.update(
    {
      id: '/sales/salesCommissions/unapprovedSalesCommissionLines',
      path: '/sales/salesCommissions/unapprovedSalesCommissionLines',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute =
  AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRouteImport.update({
    id: '/sales/systemDiagrams/$systemDiagramId',
    path: '/sales/systemDiagrams/$systemDiagramId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcCChartEventsSearchRoute =
  AuthenticatedShellSpcCChartEventsSearchRouteImport.update({
    id: '/spc/cChartEvents/search',
    path: '/spc/cChartEvents/search',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcControlChartCollectionsManagementRoute =
  AuthenticatedShellSpcControlChartCollectionsManagementRouteImport.update({
    id: '/spc/controlChartCollections/management',
    path: '/spc/controlChartCollections/management',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute =
  AuthenticatedShellSpcControlChartParentGroupParentGroupIdRouteImport.update({
    id: '/spc/controlChartParentGroup/$parentGroupId',
    path: '/spc/controlChartParentGroup/$parentGroupId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcDefectGroupsParentGroupIdRoute =
  AuthenticatedShellSpcDefectGroupsParentGroupIdRouteImport.update({
    id: '/spc/defectGroups/$parentGroupId',
    path: '/spc/defectGroups/$parentGroupId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcMasterDataYieldChartsRoute =
  AuthenticatedShellSpcMasterDataYieldChartsRouteImport.update({
    id: '/spc/masterData/yieldCharts',
    path: '/spc/masterData/yieldCharts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSpecialCausesChartGroupsRoute =
  AuthenticatedShellSpcSpecialCausesChartGroupsRouteImport.update({
    id: '/spc/specialCauses/chartGroups',
    path: '/spc/specialCauses/chartGroups',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSpecialCausesResourcesRoute =
  AuthenticatedShellSpcSpecialCausesResourcesRouteImport.update({
    id: '/spc/specialCauses/resources',
    path: '/spc/specialCauses/resources',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSummaryViewsIndexRoute =
  AuthenticatedShellSpcSummaryViewsIndexRouteImport.update({
    id: '/spc/summaryViews/',
    path: '/spc/summaryViews/',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute =
  AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRouteImport.update({
    id: '/spc/systemDiagrams/$systemDiagramId',
    path: '/spc/systemDiagrams/$systemDiagramId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSurveysSubmissionsAuditRoute =
  AuthenticatedShellSurveysSubmissionsAuditRouteImport.update({
    id: '/surveys/submissions/audit',
    path: '/surveys/submissions/audit',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute =
  AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRouteImport.update(
    {
      id: '/warehouse/inventory/allInventoryLevelEvents',
      path: '/warehouse/inventory/allInventoryLevelEvents',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellWarehouseInventoryManualEventsRoute =
  AuthenticatedShellWarehouseInventoryManualEventsRouteImport.update({
    id: '/warehouse/inventory/manualEvents',
    path: '/warehouse/inventory/manualEvents',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellWarehouseInventoryStockCountsRoute =
  AuthenticatedShellWarehouseInventoryStockCountsRouteImport.update({
    id: '/warehouse/inventory/stockCounts',
    path: '/warehouse/inventory/stockCounts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute =
  AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRouteImport.update(
    {
      id: '/erp/parts/costCalculation/configurableCustomerOrderLines',
      path: '/erp/parts/costCalculation/configurableCustomerOrderLines',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellErpProjectDeliveryBundlingRoute =
  AuthenticatedShellErpProjectDeliveryBundlingRouteImport.update({
    id: '/erp/project/delivery/bundling',
    path: '/erp/project/delivery/bundling',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProjectDeliveryLoadingRoute =
  AuthenticatedShellErpProjectDeliveryLoadingRouteImport.update({
    id: '/erp/project/delivery/loading',
    path: '/erp/project/delivery/loading',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute =
  AuthenticatedShellErpProjectDeliveryOutboundWarehouseRouteImport.update({
    id: '/erp/project/delivery/outboundWarehouse',
    path: '/erp/project/delivery/outboundWarehouse',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesDeliveryBundlingRoute =
  AuthenticatedShellErpSalesDeliveryBundlingRouteImport.update({
    id: '/erp/sales/delivery/bundling',
    path: '/erp/sales/delivery/bundling',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesDeliveryLoadingRoute =
  AuthenticatedShellErpSalesDeliveryLoadingRouteImport.update({
    id: '/erp/sales/delivery/loading',
    path: '/erp/sales/delivery/loading',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute =
  AuthenticatedShellErpSalesDeliveryOutboundWarehouseRouteImport.update({
    id: '/erp/sales/delivery/outboundWarehouse',
    path: '/erp/sales/delivery/outboundWarehouse',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesInvoicingAllInvoicesRoute =
  AuthenticatedShellErpSalesInvoicingAllInvoicesRouteImport.update({
    id: '/erp/sales/invoicing/allInvoices',
    path: '/erp/sales/invoicing/allInvoices',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute =
  AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRouteImport.update({
    id: '/erp/sales/invoicing/billableCustomerOrders',
    path: '/erp/sales/invoicing/billableCustomerOrders',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute =
  AuthenticatedShellErpSalesReportsCustomerOrderBacklogRouteImport.update({
    id: '/erp/sales/reports/customerOrderBacklog',
    path: '/erp/sales/reports/customerOrderBacklog',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute =
  AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRouteImport.update({
    id: '/erp/sales/reports/customerOrderOfferBacklog',
    path: '/erp/sales/reports/customerOrderOfferBacklog',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute =
  AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRouteImport.update(
    {
      id: '/erp/warehouse/reports/shippingWarehouseInventoryValue',
      path: '/erp/warehouse/reports/shippingWarehouseInventoryValue',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellErpWarehouseReportsWarehouseValueRoute =
  AuthenticatedShellErpWarehouseReportsWarehouseValueRouteImport.update({
    id: '/erp/warehouse/reports/warehouseValue',
    path: '/erp/warehouse/reports/warehouseValue',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute =
  AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRouteImport.update(
    {
      id: '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId',
      path: '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute =
  AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRouteImport.update(
    {
      id: '/spc/controlChartCollections/view/$collectionId',
      path: '/spc/controlChartCollections/view/$collectionId',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute =
  AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRouteImport.update(
    {
      id: '/spc/processDiagrams/chartGroups/$chartGroupId',
      path: '/spc/processDiagrams/chartGroups/$chartGroupId',
      getParentRoute: () => AuthenticatedShellRoute,
    } as any,
  )
const AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute =
  AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRouteImport.update({
    id: '/spc/processDiagrams/resources/$resourceId',
    path: '/spc/processDiagrams/resources/$resourceId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute =
  AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRouteImport.update({
    id: '/spc/summaryViews/diagram/$summaryViewId',
    path: '/spc/summaryViews/diagram/$summaryViewId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute =
  AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRouteImport.update({
    id: '/spc/summaryViews/grid/$summaryViewId',
    path: '/spc/summaryViews/grid/$summaryViewId',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute =
  AuthenticatedShellErpSalesInvoicingReportsInvoicesRouteImport.update({
    id: '/erp/sales/invoicing/reports/invoices',
    path: '/erp/sales/invoicing/reports/invoices',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedShellIndexRoute
  '/emailVerified': typeof EmailVerifiedRoute
  '/index.html': typeof IndexDothtmlRoute
  '/insufficientPermissions': typeof InsufficientPermissionsRoute
  '/loggedOut': typeof LoggedOutRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/customAppWindow/$windowId': typeof CustomAppWindowWindowIdRoute
  '/views/$': typeof ViewsSplatRoute
  '/bi': typeof AuthenticatedShellBiRoute
  '/devTest': typeof AuthenticatedShellDevTestRoute
  '/connection/oauth/callback': typeof ConnectionOauthCallbackRoute
  '/wopi/$action/$fileId': typeof WopiActionFileIdRoute
  '/ai/costs': typeof AuthenticatedShellAiCostsRoute
  '/ai/management': typeof AuthenticatedShellAiManagementRoute
  '/apps/$customAppId': typeof AuthenticatedShellAppsCustomAppIdRoute
  '/common/companies': typeof AuthenticatedShellCommonCompaniesRoute
  '/common/currencies': typeof AuthenticatedShellCommonCurrenciesRoute
  '/common/documentTemplates': typeof AuthenticatedShellCommonDocumentTemplatesRoute
  '/common/emailTemplates': typeof AuthenticatedShellCommonEmailTemplatesRoute
  '/common/numberSequences': typeof AuthenticatedShellCommonNumberSequencesRoute
  '/common/objectAttributeFields': typeof AuthenticatedShellCommonObjectAttributeFieldsRoute
  '/common/sites': typeof AuthenticatedShellCommonSitesRoute
  '/common/systemDiagrams': typeof AuthenticatedShellCommonSystemDiagramsRoute
  '/configurator/libraries': typeof AuthenticatedShellConfiguratorLibrariesRoute
  '/configurator/optionLists': typeof AuthenticatedShellConfiguratorOptionListsRoute
  '/configurator/productFamilies': typeof AuthenticatedShellConfiguratorProductFamiliesRoute
  '/configurator/productFamilyCategories': typeof AuthenticatedShellConfiguratorProductFamilyCategoriesRoute
  '/configurator/tables': typeof AuthenticatedShellConfiguratorTablesRoute
  '/crm/contacts': typeof AuthenticatedShellCrmContactsRoute
  '/crm/customers': typeof AuthenticatedShellCrmCustomersRoute
  '/crm/incomingLeads': typeof AuthenticatedShellCrmIncomingLeadsRoute
  '/crm/salesAreas': typeof AuthenticatedShellCrmSalesAreasRoute
  '/crm/salesLeadActivities': typeof AuthenticatedShellCrmSalesLeadActivitiesRoute
  '/crm/salesLeadActivityCategories': typeof AuthenticatedShellCrmSalesLeadActivityCategoriesRoute
  '/crm/salesLeadSources': typeof AuthenticatedShellCrmSalesLeadSourcesRoute
  '/crm/salesLeads': typeof AuthenticatedShellCrmSalesLeadsRoute
  '/crm/salesPipeline': typeof AuthenticatedShellCrmSalesPipelineRoute
  '/crm/salesPipelineBoard': typeof AuthenticatedShellCrmSalesPipelineBoardRoute
  '/customizations/api-connections': typeof AuthenticatedShellCustomizationsApiConnectionsRoute
  '/customizations/api-keys': typeof AuthenticatedShellCustomizationsApiKeysRoute
  '/customizations/custom-apps': typeof AuthenticatedShellCustomizationsCustomAppsRoute
  '/customizations/custom-functions': typeof AuthenticatedShellCustomizationsCustomFunctionsRoute
  '/customizations/sent-emails': typeof AuthenticatedShellCustomizationsSentEmailsRoute
  '/documents/documentCategories': typeof AuthenticatedShellDocumentsDocumentCategoriesRoute
  '/documents/search': typeof AuthenticatedShellDocumentsSearchRoute
  '/mellano/lisToLsb': typeof AuthenticatedShellMellanoLisToLsbRoute
  '/mellano/paintingControlCharts': typeof AuthenticatedShellMellanoPaintingControlChartsRoute
  '/productDesign/bomLineGroups': typeof AuthenticatedShellProductDesignBomLineGroupsRoute
  '/productManagement/catalogParts': typeof AuthenticatedShellProductManagementCatalogPartsRoute
  '/productManagement/partCategories': typeof AuthenticatedShellProductManagementPartCategoriesRoute
  '/productManagement/productChangeCategories': typeof AuthenticatedShellProductManagementProductChangeCategoriesRoute
  '/productManagement/productChangePackages': typeof AuthenticatedShellProductManagementProductChangePackagesRoute
  '/productManagement/productChangeRequests': typeof AuthenticatedShellProductManagementProductChangeRequestsRoute
  '/productManagement/productChanges': typeof AuthenticatedShellProductManagementProductChangesRoute
  '/productManagement/searchPartsByAttributes': typeof AuthenticatedShellProductManagementSearchPartsByAttributesRoute
  '/productManagement/units': typeof AuthenticatedShellProductManagementUnitsRoute
  '/production/onProductionLine': typeof AuthenticatedShellProductionOnProductionLineRoute
  '/production/operations': typeof AuthenticatedShellProductionOperationsRoute
  '/production/productionLineGroupJobQueue': typeof AuthenticatedShellProductionProductionLineGroupJobQueueRoute
  '/production/productionLineJobQueue': typeof AuthenticatedShellProductionProductionLineJobQueueRoute
  '/production/productionLines': typeof AuthenticatedShellProductionProductionLinesRoute
  '/production/shopOrderBatchJobQueue': typeof AuthenticatedShellProductionShopOrderBatchJobQueueRoute
  '/production/shopOrderBatches': typeof AuthenticatedShellProductionShopOrderBatchesRoute
  '/production/shopOrderPackaging': typeof AuthenticatedShellProductionShopOrderPackagingRoute
  '/production/shopOrders': typeof AuthenticatedShellProductionShopOrdersRoute
  '/production/subcontractingJobQueue': typeof AuthenticatedShellProductionSubcontractingJobQueueRoute
  '/production/supplementShopOrder': typeof AuthenticatedShellProductionSupplementShopOrderRoute
  '/production/workCenterIncompleteOperations': typeof AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute
  '/production/workCenterJobQueue': typeof AuthenticatedShellProductionWorkCenterJobQueueRoute
  '/production/workCenters': typeof AuthenticatedShellProductionWorkCentersRoute
  '/project/activityResources': typeof AuthenticatedShellProjectActivityResourcesRoute
  '/project/activityTypes': typeof AuthenticatedShellProjectActivityTypesRoute
  '/project/costEvents': typeof AuthenticatedShellProjectCostEventsRoute
  '/project/jobQueue': typeof AuthenticatedShellProjectJobQueueRoute
  '/project/projectTypes': typeof AuthenticatedShellProjectProjectTypesRoute
  '/project/projects': typeof AuthenticatedShellProjectProjectsRoute
  '/project/resourcesGantt': typeof AuthenticatedShellProjectResourcesGanttRoute
  '/project/scheduling': typeof AuthenticatedShellProjectSchedulingRoute
  '/project/subProjectTypes': typeof AuthenticatedShellProjectSubProjectTypesRoute
  '/project/tree': typeof AuthenticatedShellProjectTreeRoute
  '/purchase/allPurchaseOrderLines': typeof AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute
  '/purchase/deliveryNotices': typeof AuthenticatedShellPurchaseDeliveryNoticesRoute
  '/purchase/processView': typeof AuthenticatedShellPurchaseProcessViewRoute
  '/purchase/purchaseOrderConfirmations': typeof AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute
  '/purchase/purchaseOrders': typeof AuthenticatedShellPurchasePurchaseOrdersRoute
  '/purchase/purchaseOrdersToReceive': typeof AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute
  '/purchase/purchaseRequests': typeof AuthenticatedShellPurchasePurchaseRequestsRoute
  '/sales/accounting': typeof AuthenticatedShellSalesAccountingRoute
  '/sales/allCustomerOrderLines': typeof AuthenticatedShellSalesAllCustomerOrderLinesRoute
  '/sales/billingPlanLinesToApprove': typeof AuthenticatedShellSalesBillingPlanLinesToApproveRoute
  '/sales/billingPlanModels': typeof AuthenticatedShellSalesBillingPlanModelsRoute
  '/sales/billingPlanParts': typeof AuthenticatedShellSalesBillingPlanPartsRoute
  '/sales/contractualTerms': typeof AuthenticatedShellSalesContractualTermsRoute
  '/sales/customerGroups': typeof AuthenticatedShellSalesCustomerGroupsRoute
  '/sales/customerOfferTypes': typeof AuthenticatedShellSalesCustomerOfferTypesRoute
  '/sales/customerOrderSalesConditions': typeof AuthenticatedShellSalesCustomerOrderSalesConditionsRoute
  '/sales/customerOrderTypes': typeof AuthenticatedShellSalesCustomerOrderTypesRoute
  '/sales/customerOrders': typeof AuthenticatedShellSalesCustomerOrdersRoute
  '/sales/customerPriceGroups': typeof AuthenticatedShellSalesCustomerPriceGroupsRoute
  '/sales/customers': typeof AuthenticatedShellSalesCustomersRoute
  '/sales/eInvoiceOperators': typeof AuthenticatedShellSalesEInvoiceOperatorsRoute
  '/sales/offers': typeof AuthenticatedShellSalesOffersRoute
  '/sales/orderDeliveryProcessView': typeof AuthenticatedShellSalesOrderDeliveryProcessViewRoute
  '/sales/paymentTerm': typeof AuthenticatedShellSalesPaymentTermRoute
  '/sales/receivedCustomerOrders': typeof AuthenticatedShellSalesReceivedCustomerOrdersRoute
  '/sales/salesConditions': typeof AuthenticatedShellSalesSalesConditionsRoute
  '/sales/salesPartCategories': typeof AuthenticatedShellSalesSalesPartCategoriesRoute
  '/sales/salesPartPriceGroups': typeof AuthenticatedShellSalesSalesPartPriceGroupsRoute
  '/sales/salesParts': typeof AuthenticatedShellSalesSalesPartsRoute
  '/sales/salespersons': typeof AuthenticatedShellSalesSalespersonsRoute
  '/sales/transportRoutes': typeof AuthenticatedShellSalesTransportRoutesRoute
  '/sales/vatCodes': typeof AuthenticatedShellSalesVatCodesRoute
  '/sales/vatHandlingTypes': typeof AuthenticatedShellSalesVatHandlingTypesRoute
  '/salvos/salesCommissionLimits': typeof AuthenticatedShellSalvosSalesCommissionLimitsRoute
  '/spc/calendars': typeof AuthenticatedShellSpcCalendarsRoute
  '/spc/controlCharts': typeof AuthenticatedShellSpcControlChartsRoute
  '/spc/cycleTimeMeasurement': typeof AuthenticatedShellSpcCycleTimeMeasurementRoute
  '/spc/dimensionSearch': typeof AuthenticatedShellSpcDimensionSearchRoute
  '/spc/importData': typeof AuthenticatedShellSpcImportDataRoute
  '/spc/processImprovementCategories': typeof AuthenticatedShellSpcProcessImprovementCategoriesRoute
  '/spc/processImprovements': typeof AuthenticatedShellSpcProcessImprovementsRoute
  '/spc/resources': typeof AuthenticatedShellSpcResourcesRoute
  '/spc/timeMeasurement': typeof AuthenticatedShellSpcTimeMeasurementRoute
  '/spc/yieldCharts': typeof AuthenticatedShellSpcYieldChartsRoute
  '/surveys/surveyCategories': typeof AuthenticatedShellSurveysSurveyCategoriesRoute
  '/surveys/surveyForms': typeof AuthenticatedShellSurveysSurveyFormsRoute
  '/tasks/allTasks': typeof AuthenticatedShellTasksAllTasksRoute
  '/tasks/my': typeof AuthenticatedShellTasksMyRoute
  '/tasks/onMyResponsibility': typeof AuthenticatedShellTasksOnMyResponsibilityRoute
  '/tasks/taskTemplates': typeof AuthenticatedShellTasksTaskTemplatesRoute
  '/users/management': typeof AuthenticatedShellUsersManagementRoute
  '/users/roles': typeof AuthenticatedShellUsersRolesRoute
  '/warehouse/dataCollection': typeof AuthenticatedShellWarehouseDataCollectionRoute
  '/warehouse/deliveryPackageTypes': typeof AuthenticatedShellWarehouseDeliveryPackageTypesRoute
  '/warehouse/inventoryLevelProfile': typeof AuthenticatedShellWarehouseInventoryLevelProfileRoute
  '/warehouse/partCostCalculation': typeof AuthenticatedShellWarehousePartCostCalculationRoute
  '/warehouse/partImportCodes': typeof AuthenticatedShellWarehousePartImportCodesRoute
  '/warehouse/parts': typeof AuthenticatedShellWarehousePartsRoute
  '/warehouse/transferJobQueue': typeof AuthenticatedShellWarehouseTransferJobQueueRoute
  '/warehouse/unverifiedParts': typeof AuthenticatedShellWarehouseUnverifiedPartsRoute
  '/warehouse/warehouseLocationParts': typeof AuthenticatedShellWarehouseWarehouseLocationPartsRoute
  '/warehouse/warehouseLocations': typeof AuthenticatedShellWarehouseWarehouseLocationsRoute
  '/warehouse/warehouseTransfers': typeof AuthenticatedShellWarehouseWarehouseTransfersRoute
  '/workspace/categories': typeof AuthenticatedShellWorkspaceCategoriesRoute
  '/workspace/workspaces': typeof AuthenticatedShellWorkspaceWorkspacesRoute
  '/common/accounting/accounts': typeof AuthenticatedShellCommonAccountingAccountsRoute
  '/common/accounting/dimensions': typeof AuthenticatedShellCommonAccountingDimensionsRoute
  '/erp/common/addCostEvent': typeof AuthenticatedShellErpCommonAddCostEventRoute
  '/erp/common/costEventObjectTypeSettings': typeof AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute
  '/erp/common/costEventPriceLists': typeof AuthenticatedShellErpCommonCostEventPriceListsRoute
  '/erp/common/costEvents': typeof AuthenticatedShellErpCommonCostEventsRoute
  '/erp/configurator/logSearch': typeof AuthenticatedShellErpConfiguratorLogSearchRoute
  '/erp/delivery/transportEquipment': typeof AuthenticatedShellErpDeliveryTransportEquipmentRoute
  '/erp/inventory/forecast': typeof AuthenticatedShellErpInventoryForecastRoute
  '/erp/production/capacity': typeof AuthenticatedShellErpProductionCapacityRoute
  '/erp/production/completedQuantity': typeof AuthenticatedShellErpProductionCompletedQuantityRoute
  '/erp/production/loadChart': typeof AuthenticatedShellErpProductionLoadChartRoute
  '/erp/production/productionPlanning': typeof AuthenticatedShellErpProductionProductionPlanningRoute
  '/erp/production/salesProductionBacklog': typeof AuthenticatedShellErpProductionSalesProductionBacklogRoute
  '/erp/purchase/supplierGroups': typeof AuthenticatedShellErpPurchaseSupplierGroupsRoute
  '/erp/purchase/suppliers': typeof AuthenticatedShellErpPurchaseSuppliersRoute
  '/erp/reclamations/reclamationCategory': typeof AuthenticatedShellErpReclamationsReclamationCategoryRoute
  '/erp/reclamations/reclamationCause': typeof AuthenticatedShellErpReclamationsReclamationCauseRoute
  '/erp/reclamations/reclamationHandlingMethod': typeof AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute
  '/erp/reclamations/reclamationLocation': typeof AuthenticatedShellErpReclamationsReclamationLocationRoute
  '/erp/reclamations/reclamations': typeof AuthenticatedShellErpReclamationsReclamationsRoute
  '/erp/reclamations/rounds': typeof AuthenticatedShellErpReclamationsRoundsRoute
  '/erp/reclamations/weekPlanning': typeof AuthenticatedShellErpReclamationsWeekPlanningRoute
  '/erp/reclamations/workQueue': typeof AuthenticatedShellErpReclamationsWorkQueueRoute
  '/erp/safetyControlSurvey/noteCategories': typeof AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute
  '/erp/safetyControlSurvey/summary': typeof AuthenticatedShellErpSafetyControlSurveySummaryRoute
  '/erp/safetyControlSurvey/surveys': typeof AuthenticatedShellErpSafetyControlSurveySurveysRoute
  '/erp/safetyControlSurvey/teams': typeof AuthenticatedShellErpSafetyControlSurveyTeamsRoute
  '/erp/sales/customerOrderImport': typeof AuthenticatedShellErpSalesCustomerOrderImportRoute
  '/erp/vertexInd/config': typeof AuthenticatedShellErpVertexIndConfigRoute
  '/erp/warehouse/cargoDrivers': typeof AuthenticatedShellErpWarehouseCargoDriversRoute
  '/erp/warehouse/deliveryMethods': typeof AuthenticatedShellErpWarehouseDeliveryMethodsRoute
  '/erp/warehouse/deliveryTerms': typeof AuthenticatedShellErpWarehouseDeliveryTermsRoute
  '/erp/warehouse/warehousePickerGroups': typeof AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute
  '/erp/warehouse/warehouseReplenishmentGroups': typeof AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute
  '/mellano/luukku/capacity': typeof AuthenticatedShellMellanoLuukkuCapacityRoute
  '/mellano/luukku/dataCollection': typeof AuthenticatedShellMellanoLuukkuDataCollectionRoute
  '/mellano/luukku/dispatchSlotting': typeof AuthenticatedShellMellanoLuukkuDispatchSlottingRoute
  '/mellano/luukku/drillStamps': typeof AuthenticatedShellMellanoLuukkuDrillStampsRoute
  '/mellano/luukku/handPaintingPlan': typeof AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute
  '/mellano/luukku/ketMetrics': typeof AuthenticatedShellMellanoLuukkuKetMetricsRoute
  '/mellano/luukku/melamineStockForecast': typeof AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute
  '/mellano/luukku/orderStatus': typeof AuthenticatedShellMellanoLuukkuOrderStatusRoute
  '/mellano/luukku/packagedAmount': typeof AuthenticatedShellMellanoLuukkuPackagedAmountRoute
  '/mellano/luukku/paintStockForecast': typeof AuthenticatedShellMellanoLuukkuPaintStockForecastRoute
  '/mellano/luukku/paintingPlan': typeof AuthenticatedShellMellanoLuukkuPaintingPlanRoute
  '/mellano/luukku/paintingRoundDefects': typeof AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute
  '/mellano/luukku/paintingRounds': typeof AuthenticatedShellMellanoLuukkuPaintingRoundsRoute
  '/mellano/luukku/productionPlanning': typeof AuthenticatedShellMellanoLuukkuProductionPlanningRoute
  '/mellano/luukku/productionStatus': typeof AuthenticatedShellMellanoLuukkuProductionStatusRoute
  '/mellano/luukku/purchaseOrderImport': typeof AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute
  '/mellano/luukku/purchaseSuggestion': typeof AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute
  '/mellano/luukku/shiftDefects': typeof AuthenticatedShellMellanoLuukkuShiftDefectsRoute
  '/mellano/luukku/unpackagedDeliveryBatches': typeof AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute
  '/mellano/luukku/unsentDeliveriesByAddress': typeof AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute
  '/mellano/luukku/unsentRonkkoDeliveries': typeof AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute
  '/mellano/luukku/workOrderSlotting': typeof AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute
  '/mellano/winner/designs': typeof AuthenticatedShellMellanoWinnerDesignsRoute
  '/production/productionLineGroupStatus/$productionLineGroupId': typeof AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute
  '/production/productionLinesStatus/$productionLineId': typeof AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute
  '/production/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute
  '/project/delivery/allDeliveries': typeof AuthenticatedShellProjectDeliveryAllDeliveriesRoute
  '/project/delivery/allDeliveryPackages': typeof AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute
  '/project/delivery/deliverableActivities': typeof AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute
  '/project/delivery/deliverableProjects': typeof AuthenticatedShellProjectDeliveryDeliverableProjectsRoute
  '/project/delivery/deliverableSubProjects': typeof AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute
  '/project/delivery/pickableProjects': typeof AuthenticatedShellProjectDeliveryPickableProjectsRoute
  '/project/delivery/undeliveredPackages': typeof AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute
  '/sales/delivery/allCustomerOrderDeliveries': typeof AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute
  '/sales/delivery/deliverableCustomerOrders': typeof AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute
  '/sales/delivery/ownTransports': typeof AuthenticatedShellSalesDeliveryOwnTransportsRoute
  '/sales/delivery/transportPlanning': typeof AuthenticatedShellSalesDeliveryTransportPlanningRoute
  '/sales/delivery/transports': typeof AuthenticatedShellSalesDeliveryTransportsRoute
  '/sales/picking/allDeliveryPackages': typeof AuthenticatedShellSalesPickingAllDeliveryPackagesRoute
  '/sales/picking/pickableCustomerOrders': typeof AuthenticatedShellSalesPickingPickableCustomerOrdersRoute
  '/sales/picking/undeliveredPackages': typeof AuthenticatedShellSalesPickingUndeliveredPackagesRoute
  '/sales/pricing/priceLists': typeof AuthenticatedShellSalesPricingPriceListsRoute
  '/sales/salesCommissions/createPayment': typeof AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute
  '/sales/salesCommissions/lineNames': typeof AuthenticatedShellSalesSalesCommissionsLineNamesRoute
  '/sales/salesCommissions/payments': typeof AuthenticatedShellSalesSalesCommissionsPaymentsRoute
  '/sales/salesCommissions/unapprovedSalesCommissionLines': typeof AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute
  '/sales/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute
  '/spc/cChartEvents/search': typeof AuthenticatedShellSpcCChartEventsSearchRoute
  '/spc/controlChartCollections/management': typeof AuthenticatedShellSpcControlChartCollectionsManagementRoute
  '/spc/controlChartParentGroup/$parentGroupId': typeof AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute
  '/spc/defectGroups/$parentGroupId': typeof AuthenticatedShellSpcDefectGroupsParentGroupIdRoute
  '/spc/masterData/yieldCharts': typeof AuthenticatedShellSpcMasterDataYieldChartsRoute
  '/spc/specialCauses/chartGroups': typeof AuthenticatedShellSpcSpecialCausesChartGroupsRoute
  '/spc/specialCauses/resources': typeof AuthenticatedShellSpcSpecialCausesResourcesRoute
  '/spc/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute
  '/surveys/submissions/audit': typeof AuthenticatedShellSurveysSubmissionsAuditRoute
  '/warehouse/inventory/allInventoryLevelEvents': typeof AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute
  '/warehouse/inventory/manualEvents': typeof AuthenticatedShellWarehouseInventoryManualEventsRoute
  '/warehouse/inventory/stockCounts': typeof AuthenticatedShellWarehouseInventoryStockCountsRoute
  '/spc/summaryViews/': typeof AuthenticatedShellSpcSummaryViewsIndexRoute
  '/erp/parts/costCalculation/configurableCustomerOrderLines': typeof AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute
  '/erp/project/delivery/bundling': typeof AuthenticatedShellErpProjectDeliveryBundlingRoute
  '/erp/project/delivery/loading': typeof AuthenticatedShellErpProjectDeliveryLoadingRoute
  '/erp/project/delivery/outboundWarehouse': typeof AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute
  '/erp/sales/delivery/bundling': typeof AuthenticatedShellErpSalesDeliveryBundlingRoute
  '/erp/sales/delivery/loading': typeof AuthenticatedShellErpSalesDeliveryLoadingRoute
  '/erp/sales/delivery/outboundWarehouse': typeof AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute
  '/erp/sales/invoicing/allInvoices': typeof AuthenticatedShellErpSalesInvoicingAllInvoicesRoute
  '/erp/sales/invoicing/billableCustomerOrders': typeof AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute
  '/erp/sales/reports/customerOrderBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute
  '/erp/sales/reports/customerOrderOfferBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute
  '/erp/warehouse/reports/shippingWarehouseInventoryValue': typeof AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute
  '/erp/warehouse/reports/warehouseValue': typeof AuthenticatedShellErpWarehouseReportsWarehouseValueRoute
  '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId': typeof AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute
  '/spc/controlChartCollections/view/$collectionId': typeof AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute
  '/spc/processDiagrams/chartGroups/$chartGroupId': typeof AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute
  '/spc/processDiagrams/resources/$resourceId': typeof AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute
  '/spc/summaryViews/diagram/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute
  '/spc/summaryViews/grid/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute
  '/erp/sales/invoicing/reports/invoices': typeof AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedShellIndexRoute
  '/emailVerified': typeof EmailVerifiedRoute
  '/index.html': typeof IndexDothtmlRoute
  '/insufficientPermissions': typeof InsufficientPermissionsRoute
  '/loggedOut': typeof LoggedOutRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/customAppWindow/$windowId': typeof CustomAppWindowWindowIdRoute
  '/views/$': typeof ViewsSplatRoute
  '/bi': typeof AuthenticatedShellBiRoute
  '/devTest': typeof AuthenticatedShellDevTestRoute
  '/connection/oauth/callback': typeof ConnectionOauthCallbackRoute
  '/wopi/$action/$fileId': typeof WopiActionFileIdRoute
  '/ai/costs': typeof AuthenticatedShellAiCostsRoute
  '/ai/management': typeof AuthenticatedShellAiManagementRoute
  '/apps/$customAppId': typeof AuthenticatedShellAppsCustomAppIdRoute
  '/common/companies': typeof AuthenticatedShellCommonCompaniesRoute
  '/common/currencies': typeof AuthenticatedShellCommonCurrenciesRoute
  '/common/documentTemplates': typeof AuthenticatedShellCommonDocumentTemplatesRoute
  '/common/emailTemplates': typeof AuthenticatedShellCommonEmailTemplatesRoute
  '/common/numberSequences': typeof AuthenticatedShellCommonNumberSequencesRoute
  '/common/objectAttributeFields': typeof AuthenticatedShellCommonObjectAttributeFieldsRoute
  '/common/sites': typeof AuthenticatedShellCommonSitesRoute
  '/common/systemDiagrams': typeof AuthenticatedShellCommonSystemDiagramsRoute
  '/configurator/libraries': typeof AuthenticatedShellConfiguratorLibrariesRoute
  '/configurator/optionLists': typeof AuthenticatedShellConfiguratorOptionListsRoute
  '/configurator/productFamilies': typeof AuthenticatedShellConfiguratorProductFamiliesRoute
  '/configurator/productFamilyCategories': typeof AuthenticatedShellConfiguratorProductFamilyCategoriesRoute
  '/configurator/tables': typeof AuthenticatedShellConfiguratorTablesRoute
  '/crm/contacts': typeof AuthenticatedShellCrmContactsRoute
  '/crm/customers': typeof AuthenticatedShellCrmCustomersRoute
  '/crm/incomingLeads': typeof AuthenticatedShellCrmIncomingLeadsRoute
  '/crm/salesAreas': typeof AuthenticatedShellCrmSalesAreasRoute
  '/crm/salesLeadActivities': typeof AuthenticatedShellCrmSalesLeadActivitiesRoute
  '/crm/salesLeadActivityCategories': typeof AuthenticatedShellCrmSalesLeadActivityCategoriesRoute
  '/crm/salesLeadSources': typeof AuthenticatedShellCrmSalesLeadSourcesRoute
  '/crm/salesLeads': typeof AuthenticatedShellCrmSalesLeadsRoute
  '/crm/salesPipeline': typeof AuthenticatedShellCrmSalesPipelineRoute
  '/crm/salesPipelineBoard': typeof AuthenticatedShellCrmSalesPipelineBoardRoute
  '/customizations/api-connections': typeof AuthenticatedShellCustomizationsApiConnectionsRoute
  '/customizations/api-keys': typeof AuthenticatedShellCustomizationsApiKeysRoute
  '/customizations/custom-apps': typeof AuthenticatedShellCustomizationsCustomAppsRoute
  '/customizations/custom-functions': typeof AuthenticatedShellCustomizationsCustomFunctionsRoute
  '/customizations/sent-emails': typeof AuthenticatedShellCustomizationsSentEmailsRoute
  '/documents/documentCategories': typeof AuthenticatedShellDocumentsDocumentCategoriesRoute
  '/documents/search': typeof AuthenticatedShellDocumentsSearchRoute
  '/mellano/lisToLsb': typeof AuthenticatedShellMellanoLisToLsbRoute
  '/mellano/paintingControlCharts': typeof AuthenticatedShellMellanoPaintingControlChartsRoute
  '/productDesign/bomLineGroups': typeof AuthenticatedShellProductDesignBomLineGroupsRoute
  '/productManagement/catalogParts': typeof AuthenticatedShellProductManagementCatalogPartsRoute
  '/productManagement/partCategories': typeof AuthenticatedShellProductManagementPartCategoriesRoute
  '/productManagement/productChangeCategories': typeof AuthenticatedShellProductManagementProductChangeCategoriesRoute
  '/productManagement/productChangePackages': typeof AuthenticatedShellProductManagementProductChangePackagesRoute
  '/productManagement/productChangeRequests': typeof AuthenticatedShellProductManagementProductChangeRequestsRoute
  '/productManagement/productChanges': typeof AuthenticatedShellProductManagementProductChangesRoute
  '/productManagement/searchPartsByAttributes': typeof AuthenticatedShellProductManagementSearchPartsByAttributesRoute
  '/productManagement/units': typeof AuthenticatedShellProductManagementUnitsRoute
  '/production/onProductionLine': typeof AuthenticatedShellProductionOnProductionLineRoute
  '/production/operations': typeof AuthenticatedShellProductionOperationsRoute
  '/production/productionLineGroupJobQueue': typeof AuthenticatedShellProductionProductionLineGroupJobQueueRoute
  '/production/productionLineJobQueue': typeof AuthenticatedShellProductionProductionLineJobQueueRoute
  '/production/productionLines': typeof AuthenticatedShellProductionProductionLinesRoute
  '/production/shopOrderBatchJobQueue': typeof AuthenticatedShellProductionShopOrderBatchJobQueueRoute
  '/production/shopOrderBatches': typeof AuthenticatedShellProductionShopOrderBatchesRoute
  '/production/shopOrderPackaging': typeof AuthenticatedShellProductionShopOrderPackagingRoute
  '/production/shopOrders': typeof AuthenticatedShellProductionShopOrdersRoute
  '/production/subcontractingJobQueue': typeof AuthenticatedShellProductionSubcontractingJobQueueRoute
  '/production/supplementShopOrder': typeof AuthenticatedShellProductionSupplementShopOrderRoute
  '/production/workCenterIncompleteOperations': typeof AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute
  '/production/workCenterJobQueue': typeof AuthenticatedShellProductionWorkCenterJobQueueRoute
  '/production/workCenters': typeof AuthenticatedShellProductionWorkCentersRoute
  '/project/activityResources': typeof AuthenticatedShellProjectActivityResourcesRoute
  '/project/activityTypes': typeof AuthenticatedShellProjectActivityTypesRoute
  '/project/costEvents': typeof AuthenticatedShellProjectCostEventsRoute
  '/project/jobQueue': typeof AuthenticatedShellProjectJobQueueRoute
  '/project/projectTypes': typeof AuthenticatedShellProjectProjectTypesRoute
  '/project/projects': typeof AuthenticatedShellProjectProjectsRoute
  '/project/resourcesGantt': typeof AuthenticatedShellProjectResourcesGanttRoute
  '/project/scheduling': typeof AuthenticatedShellProjectSchedulingRoute
  '/project/subProjectTypes': typeof AuthenticatedShellProjectSubProjectTypesRoute
  '/project/tree': typeof AuthenticatedShellProjectTreeRoute
  '/purchase/allPurchaseOrderLines': typeof AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute
  '/purchase/deliveryNotices': typeof AuthenticatedShellPurchaseDeliveryNoticesRoute
  '/purchase/processView': typeof AuthenticatedShellPurchaseProcessViewRoute
  '/purchase/purchaseOrderConfirmations': typeof AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute
  '/purchase/purchaseOrders': typeof AuthenticatedShellPurchasePurchaseOrdersRoute
  '/purchase/purchaseOrdersToReceive': typeof AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute
  '/purchase/purchaseRequests': typeof AuthenticatedShellPurchasePurchaseRequestsRoute
  '/sales/accounting': typeof AuthenticatedShellSalesAccountingRoute
  '/sales/allCustomerOrderLines': typeof AuthenticatedShellSalesAllCustomerOrderLinesRoute
  '/sales/billingPlanLinesToApprove': typeof AuthenticatedShellSalesBillingPlanLinesToApproveRoute
  '/sales/billingPlanModels': typeof AuthenticatedShellSalesBillingPlanModelsRoute
  '/sales/billingPlanParts': typeof AuthenticatedShellSalesBillingPlanPartsRoute
  '/sales/contractualTerms': typeof AuthenticatedShellSalesContractualTermsRoute
  '/sales/customerGroups': typeof AuthenticatedShellSalesCustomerGroupsRoute
  '/sales/customerOfferTypes': typeof AuthenticatedShellSalesCustomerOfferTypesRoute
  '/sales/customerOrderSalesConditions': typeof AuthenticatedShellSalesCustomerOrderSalesConditionsRoute
  '/sales/customerOrderTypes': typeof AuthenticatedShellSalesCustomerOrderTypesRoute
  '/sales/customerOrders': typeof AuthenticatedShellSalesCustomerOrdersRoute
  '/sales/customerPriceGroups': typeof AuthenticatedShellSalesCustomerPriceGroupsRoute
  '/sales/customers': typeof AuthenticatedShellSalesCustomersRoute
  '/sales/eInvoiceOperators': typeof AuthenticatedShellSalesEInvoiceOperatorsRoute
  '/sales/offers': typeof AuthenticatedShellSalesOffersRoute
  '/sales/orderDeliveryProcessView': typeof AuthenticatedShellSalesOrderDeliveryProcessViewRoute
  '/sales/paymentTerm': typeof AuthenticatedShellSalesPaymentTermRoute
  '/sales/receivedCustomerOrders': typeof AuthenticatedShellSalesReceivedCustomerOrdersRoute
  '/sales/salesConditions': typeof AuthenticatedShellSalesSalesConditionsRoute
  '/sales/salesPartCategories': typeof AuthenticatedShellSalesSalesPartCategoriesRoute
  '/sales/salesPartPriceGroups': typeof AuthenticatedShellSalesSalesPartPriceGroupsRoute
  '/sales/salesParts': typeof AuthenticatedShellSalesSalesPartsRoute
  '/sales/salespersons': typeof AuthenticatedShellSalesSalespersonsRoute
  '/sales/transportRoutes': typeof AuthenticatedShellSalesTransportRoutesRoute
  '/sales/vatCodes': typeof AuthenticatedShellSalesVatCodesRoute
  '/sales/vatHandlingTypes': typeof AuthenticatedShellSalesVatHandlingTypesRoute
  '/salvos/salesCommissionLimits': typeof AuthenticatedShellSalvosSalesCommissionLimitsRoute
  '/spc/calendars': typeof AuthenticatedShellSpcCalendarsRoute
  '/spc/controlCharts': typeof AuthenticatedShellSpcControlChartsRoute
  '/spc/cycleTimeMeasurement': typeof AuthenticatedShellSpcCycleTimeMeasurementRoute
  '/spc/dimensionSearch': typeof AuthenticatedShellSpcDimensionSearchRoute
  '/spc/importData': typeof AuthenticatedShellSpcImportDataRoute
  '/spc/processImprovementCategories': typeof AuthenticatedShellSpcProcessImprovementCategoriesRoute
  '/spc/processImprovements': typeof AuthenticatedShellSpcProcessImprovementsRoute
  '/spc/resources': typeof AuthenticatedShellSpcResourcesRoute
  '/spc/timeMeasurement': typeof AuthenticatedShellSpcTimeMeasurementRoute
  '/spc/yieldCharts': typeof AuthenticatedShellSpcYieldChartsRoute
  '/surveys/surveyCategories': typeof AuthenticatedShellSurveysSurveyCategoriesRoute
  '/surveys/surveyForms': typeof AuthenticatedShellSurveysSurveyFormsRoute
  '/tasks/allTasks': typeof AuthenticatedShellTasksAllTasksRoute
  '/tasks/my': typeof AuthenticatedShellTasksMyRoute
  '/tasks/onMyResponsibility': typeof AuthenticatedShellTasksOnMyResponsibilityRoute
  '/tasks/taskTemplates': typeof AuthenticatedShellTasksTaskTemplatesRoute
  '/users/management': typeof AuthenticatedShellUsersManagementRoute
  '/users/roles': typeof AuthenticatedShellUsersRolesRoute
  '/warehouse/dataCollection': typeof AuthenticatedShellWarehouseDataCollectionRoute
  '/warehouse/deliveryPackageTypes': typeof AuthenticatedShellWarehouseDeliveryPackageTypesRoute
  '/warehouse/inventoryLevelProfile': typeof AuthenticatedShellWarehouseInventoryLevelProfileRoute
  '/warehouse/partCostCalculation': typeof AuthenticatedShellWarehousePartCostCalculationRoute
  '/warehouse/partImportCodes': typeof AuthenticatedShellWarehousePartImportCodesRoute
  '/warehouse/parts': typeof AuthenticatedShellWarehousePartsRoute
  '/warehouse/transferJobQueue': typeof AuthenticatedShellWarehouseTransferJobQueueRoute
  '/warehouse/unverifiedParts': typeof AuthenticatedShellWarehouseUnverifiedPartsRoute
  '/warehouse/warehouseLocationParts': typeof AuthenticatedShellWarehouseWarehouseLocationPartsRoute
  '/warehouse/warehouseLocations': typeof AuthenticatedShellWarehouseWarehouseLocationsRoute
  '/warehouse/warehouseTransfers': typeof AuthenticatedShellWarehouseWarehouseTransfersRoute
  '/workspace/categories': typeof AuthenticatedShellWorkspaceCategoriesRoute
  '/workspace/workspaces': typeof AuthenticatedShellWorkspaceWorkspacesRoute
  '/common/accounting/accounts': typeof AuthenticatedShellCommonAccountingAccountsRoute
  '/common/accounting/dimensions': typeof AuthenticatedShellCommonAccountingDimensionsRoute
  '/erp/common/addCostEvent': typeof AuthenticatedShellErpCommonAddCostEventRoute
  '/erp/common/costEventObjectTypeSettings': typeof AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute
  '/erp/common/costEventPriceLists': typeof AuthenticatedShellErpCommonCostEventPriceListsRoute
  '/erp/common/costEvents': typeof AuthenticatedShellErpCommonCostEventsRoute
  '/erp/configurator/logSearch': typeof AuthenticatedShellErpConfiguratorLogSearchRoute
  '/erp/delivery/transportEquipment': typeof AuthenticatedShellErpDeliveryTransportEquipmentRoute
  '/erp/inventory/forecast': typeof AuthenticatedShellErpInventoryForecastRoute
  '/erp/production/capacity': typeof AuthenticatedShellErpProductionCapacityRoute
  '/erp/production/completedQuantity': typeof AuthenticatedShellErpProductionCompletedQuantityRoute
  '/erp/production/loadChart': typeof AuthenticatedShellErpProductionLoadChartRoute
  '/erp/production/productionPlanning': typeof AuthenticatedShellErpProductionProductionPlanningRoute
  '/erp/production/salesProductionBacklog': typeof AuthenticatedShellErpProductionSalesProductionBacklogRoute
  '/erp/purchase/supplierGroups': typeof AuthenticatedShellErpPurchaseSupplierGroupsRoute
  '/erp/purchase/suppliers': typeof AuthenticatedShellErpPurchaseSuppliersRoute
  '/erp/reclamations/reclamationCategory': typeof AuthenticatedShellErpReclamationsReclamationCategoryRoute
  '/erp/reclamations/reclamationCause': typeof AuthenticatedShellErpReclamationsReclamationCauseRoute
  '/erp/reclamations/reclamationHandlingMethod': typeof AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute
  '/erp/reclamations/reclamationLocation': typeof AuthenticatedShellErpReclamationsReclamationLocationRoute
  '/erp/reclamations/reclamations': typeof AuthenticatedShellErpReclamationsReclamationsRoute
  '/erp/reclamations/rounds': typeof AuthenticatedShellErpReclamationsRoundsRoute
  '/erp/reclamations/weekPlanning': typeof AuthenticatedShellErpReclamationsWeekPlanningRoute
  '/erp/reclamations/workQueue': typeof AuthenticatedShellErpReclamationsWorkQueueRoute
  '/erp/safetyControlSurvey/noteCategories': typeof AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute
  '/erp/safetyControlSurvey/summary': typeof AuthenticatedShellErpSafetyControlSurveySummaryRoute
  '/erp/safetyControlSurvey/surveys': typeof AuthenticatedShellErpSafetyControlSurveySurveysRoute
  '/erp/safetyControlSurvey/teams': typeof AuthenticatedShellErpSafetyControlSurveyTeamsRoute
  '/erp/sales/customerOrderImport': typeof AuthenticatedShellErpSalesCustomerOrderImportRoute
  '/erp/vertexInd/config': typeof AuthenticatedShellErpVertexIndConfigRoute
  '/erp/warehouse/cargoDrivers': typeof AuthenticatedShellErpWarehouseCargoDriversRoute
  '/erp/warehouse/deliveryMethods': typeof AuthenticatedShellErpWarehouseDeliveryMethodsRoute
  '/erp/warehouse/deliveryTerms': typeof AuthenticatedShellErpWarehouseDeliveryTermsRoute
  '/erp/warehouse/warehousePickerGroups': typeof AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute
  '/erp/warehouse/warehouseReplenishmentGroups': typeof AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute
  '/mellano/luukku/capacity': typeof AuthenticatedShellMellanoLuukkuCapacityRoute
  '/mellano/luukku/dataCollection': typeof AuthenticatedShellMellanoLuukkuDataCollectionRoute
  '/mellano/luukku/dispatchSlotting': typeof AuthenticatedShellMellanoLuukkuDispatchSlottingRoute
  '/mellano/luukku/drillStamps': typeof AuthenticatedShellMellanoLuukkuDrillStampsRoute
  '/mellano/luukku/handPaintingPlan': typeof AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute
  '/mellano/luukku/ketMetrics': typeof AuthenticatedShellMellanoLuukkuKetMetricsRoute
  '/mellano/luukku/melamineStockForecast': typeof AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute
  '/mellano/luukku/orderStatus': typeof AuthenticatedShellMellanoLuukkuOrderStatusRoute
  '/mellano/luukku/packagedAmount': typeof AuthenticatedShellMellanoLuukkuPackagedAmountRoute
  '/mellano/luukku/paintStockForecast': typeof AuthenticatedShellMellanoLuukkuPaintStockForecastRoute
  '/mellano/luukku/paintingPlan': typeof AuthenticatedShellMellanoLuukkuPaintingPlanRoute
  '/mellano/luukku/paintingRoundDefects': typeof AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute
  '/mellano/luukku/paintingRounds': typeof AuthenticatedShellMellanoLuukkuPaintingRoundsRoute
  '/mellano/luukku/productionPlanning': typeof AuthenticatedShellMellanoLuukkuProductionPlanningRoute
  '/mellano/luukku/productionStatus': typeof AuthenticatedShellMellanoLuukkuProductionStatusRoute
  '/mellano/luukku/purchaseOrderImport': typeof AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute
  '/mellano/luukku/purchaseSuggestion': typeof AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute
  '/mellano/luukku/shiftDefects': typeof AuthenticatedShellMellanoLuukkuShiftDefectsRoute
  '/mellano/luukku/unpackagedDeliveryBatches': typeof AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute
  '/mellano/luukku/unsentDeliveriesByAddress': typeof AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute
  '/mellano/luukku/unsentRonkkoDeliveries': typeof AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute
  '/mellano/luukku/workOrderSlotting': typeof AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute
  '/mellano/winner/designs': typeof AuthenticatedShellMellanoWinnerDesignsRoute
  '/production/productionLineGroupStatus/$productionLineGroupId': typeof AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute
  '/production/productionLinesStatus/$productionLineId': typeof AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute
  '/production/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute
  '/project/delivery/allDeliveries': typeof AuthenticatedShellProjectDeliveryAllDeliveriesRoute
  '/project/delivery/allDeliveryPackages': typeof AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute
  '/project/delivery/deliverableActivities': typeof AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute
  '/project/delivery/deliverableProjects': typeof AuthenticatedShellProjectDeliveryDeliverableProjectsRoute
  '/project/delivery/deliverableSubProjects': typeof AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute
  '/project/delivery/pickableProjects': typeof AuthenticatedShellProjectDeliveryPickableProjectsRoute
  '/project/delivery/undeliveredPackages': typeof AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute
  '/sales/delivery/allCustomerOrderDeliveries': typeof AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute
  '/sales/delivery/deliverableCustomerOrders': typeof AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute
  '/sales/delivery/ownTransports': typeof AuthenticatedShellSalesDeliveryOwnTransportsRoute
  '/sales/delivery/transportPlanning': typeof AuthenticatedShellSalesDeliveryTransportPlanningRoute
  '/sales/delivery/transports': typeof AuthenticatedShellSalesDeliveryTransportsRoute
  '/sales/picking/allDeliveryPackages': typeof AuthenticatedShellSalesPickingAllDeliveryPackagesRoute
  '/sales/picking/pickableCustomerOrders': typeof AuthenticatedShellSalesPickingPickableCustomerOrdersRoute
  '/sales/picking/undeliveredPackages': typeof AuthenticatedShellSalesPickingUndeliveredPackagesRoute
  '/sales/pricing/priceLists': typeof AuthenticatedShellSalesPricingPriceListsRoute
  '/sales/salesCommissions/createPayment': typeof AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute
  '/sales/salesCommissions/lineNames': typeof AuthenticatedShellSalesSalesCommissionsLineNamesRoute
  '/sales/salesCommissions/payments': typeof AuthenticatedShellSalesSalesCommissionsPaymentsRoute
  '/sales/salesCommissions/unapprovedSalesCommissionLines': typeof AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute
  '/sales/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute
  '/spc/cChartEvents/search': typeof AuthenticatedShellSpcCChartEventsSearchRoute
  '/spc/controlChartCollections/management': typeof AuthenticatedShellSpcControlChartCollectionsManagementRoute
  '/spc/controlChartParentGroup/$parentGroupId': typeof AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute
  '/spc/defectGroups/$parentGroupId': typeof AuthenticatedShellSpcDefectGroupsParentGroupIdRoute
  '/spc/masterData/yieldCharts': typeof AuthenticatedShellSpcMasterDataYieldChartsRoute
  '/spc/specialCauses/chartGroups': typeof AuthenticatedShellSpcSpecialCausesChartGroupsRoute
  '/spc/specialCauses/resources': typeof AuthenticatedShellSpcSpecialCausesResourcesRoute
  '/spc/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute
  '/surveys/submissions/audit': typeof AuthenticatedShellSurveysSubmissionsAuditRoute
  '/warehouse/inventory/allInventoryLevelEvents': typeof AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute
  '/warehouse/inventory/manualEvents': typeof AuthenticatedShellWarehouseInventoryManualEventsRoute
  '/warehouse/inventory/stockCounts': typeof AuthenticatedShellWarehouseInventoryStockCountsRoute
  '/spc/summaryViews': typeof AuthenticatedShellSpcSummaryViewsIndexRoute
  '/erp/parts/costCalculation/configurableCustomerOrderLines': typeof AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute
  '/erp/project/delivery/bundling': typeof AuthenticatedShellErpProjectDeliveryBundlingRoute
  '/erp/project/delivery/loading': typeof AuthenticatedShellErpProjectDeliveryLoadingRoute
  '/erp/project/delivery/outboundWarehouse': typeof AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute
  '/erp/sales/delivery/bundling': typeof AuthenticatedShellErpSalesDeliveryBundlingRoute
  '/erp/sales/delivery/loading': typeof AuthenticatedShellErpSalesDeliveryLoadingRoute
  '/erp/sales/delivery/outboundWarehouse': typeof AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute
  '/erp/sales/invoicing/allInvoices': typeof AuthenticatedShellErpSalesInvoicingAllInvoicesRoute
  '/erp/sales/invoicing/billableCustomerOrders': typeof AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute
  '/erp/sales/reports/customerOrderBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute
  '/erp/sales/reports/customerOrderOfferBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute
  '/erp/warehouse/reports/shippingWarehouseInventoryValue': typeof AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute
  '/erp/warehouse/reports/warehouseValue': typeof AuthenticatedShellErpWarehouseReportsWarehouseValueRoute
  '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId': typeof AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute
  '/spc/controlChartCollections/view/$collectionId': typeof AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute
  '/spc/processDiagrams/chartGroups/$chartGroupId': typeof AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute
  '/spc/processDiagrams/resources/$resourceId': typeof AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute
  '/spc/summaryViews/diagram/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute
  '/spc/summaryViews/grid/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute
  '/erp/sales/invoicing/reports/invoices': typeof AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/emailVerified': typeof EmailVerifiedRoute
  '/index.html': typeof IndexDothtmlRoute
  '/insufficientPermissions': typeof InsufficientPermissionsRoute
  '/loggedOut': typeof LoggedOutRoute
  '/_authenticated/_shell': typeof AuthenticatedShellRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/customAppWindow/$windowId': typeof CustomAppWindowWindowIdRoute
  '/views/$': typeof ViewsSplatRoute
  '/_authenticated/_shell/bi': typeof AuthenticatedShellBiRoute
  '/_authenticated/_shell/devTest': typeof AuthenticatedShellDevTestRoute
  '/connection/oauth/callback': typeof ConnectionOauthCallbackRoute
  '/wopi/$action/$fileId': typeof WopiActionFileIdRoute
  '/_authenticated/_shell/': typeof AuthenticatedShellIndexRoute
  '/_authenticated/_shell/ai/costs': typeof AuthenticatedShellAiCostsRoute
  '/_authenticated/_shell/ai/management': typeof AuthenticatedShellAiManagementRoute
  '/_authenticated/_shell/apps/$customAppId': typeof AuthenticatedShellAppsCustomAppIdRoute
  '/_authenticated/_shell/common/companies': typeof AuthenticatedShellCommonCompaniesRoute
  '/_authenticated/_shell/common/currencies': typeof AuthenticatedShellCommonCurrenciesRoute
  '/_authenticated/_shell/common/documentTemplates': typeof AuthenticatedShellCommonDocumentTemplatesRoute
  '/_authenticated/_shell/common/emailTemplates': typeof AuthenticatedShellCommonEmailTemplatesRoute
  '/_authenticated/_shell/common/numberSequences': typeof AuthenticatedShellCommonNumberSequencesRoute
  '/_authenticated/_shell/common/objectAttributeFields': typeof AuthenticatedShellCommonObjectAttributeFieldsRoute
  '/_authenticated/_shell/common/sites': typeof AuthenticatedShellCommonSitesRoute
  '/_authenticated/_shell/common/systemDiagrams': typeof AuthenticatedShellCommonSystemDiagramsRoute
  '/_authenticated/_shell/configurator/libraries': typeof AuthenticatedShellConfiguratorLibrariesRoute
  '/_authenticated/_shell/configurator/optionLists': typeof AuthenticatedShellConfiguratorOptionListsRoute
  '/_authenticated/_shell/configurator/productFamilies': typeof AuthenticatedShellConfiguratorProductFamiliesRoute
  '/_authenticated/_shell/configurator/productFamilyCategories': typeof AuthenticatedShellConfiguratorProductFamilyCategoriesRoute
  '/_authenticated/_shell/configurator/tables': typeof AuthenticatedShellConfiguratorTablesRoute
  '/_authenticated/_shell/crm/contacts': typeof AuthenticatedShellCrmContactsRoute
  '/_authenticated/_shell/crm/customers': typeof AuthenticatedShellCrmCustomersRoute
  '/_authenticated/_shell/crm/incomingLeads': typeof AuthenticatedShellCrmIncomingLeadsRoute
  '/_authenticated/_shell/crm/salesAreas': typeof AuthenticatedShellCrmSalesAreasRoute
  '/_authenticated/_shell/crm/salesLeadActivities': typeof AuthenticatedShellCrmSalesLeadActivitiesRoute
  '/_authenticated/_shell/crm/salesLeadActivityCategories': typeof AuthenticatedShellCrmSalesLeadActivityCategoriesRoute
  '/_authenticated/_shell/crm/salesLeadSources': typeof AuthenticatedShellCrmSalesLeadSourcesRoute
  '/_authenticated/_shell/crm/salesLeads': typeof AuthenticatedShellCrmSalesLeadsRoute
  '/_authenticated/_shell/crm/salesPipeline': typeof AuthenticatedShellCrmSalesPipelineRoute
  '/_authenticated/_shell/crm/salesPipelineBoard': typeof AuthenticatedShellCrmSalesPipelineBoardRoute
  '/_authenticated/_shell/customizations/api-connections': typeof AuthenticatedShellCustomizationsApiConnectionsRoute
  '/_authenticated/_shell/customizations/api-keys': typeof AuthenticatedShellCustomizationsApiKeysRoute
  '/_authenticated/_shell/customizations/custom-apps': typeof AuthenticatedShellCustomizationsCustomAppsRoute
  '/_authenticated/_shell/customizations/custom-functions': typeof AuthenticatedShellCustomizationsCustomFunctionsRoute
  '/_authenticated/_shell/customizations/sent-emails': typeof AuthenticatedShellCustomizationsSentEmailsRoute
  '/_authenticated/_shell/documents/documentCategories': typeof AuthenticatedShellDocumentsDocumentCategoriesRoute
  '/_authenticated/_shell/documents/search': typeof AuthenticatedShellDocumentsSearchRoute
  '/_authenticated/_shell/mellano/lisToLsb': typeof AuthenticatedShellMellanoLisToLsbRoute
  '/_authenticated/_shell/mellano/paintingControlCharts': typeof AuthenticatedShellMellanoPaintingControlChartsRoute
  '/_authenticated/_shell/productDesign/bomLineGroups': typeof AuthenticatedShellProductDesignBomLineGroupsRoute
  '/_authenticated/_shell/productManagement/catalogParts': typeof AuthenticatedShellProductManagementCatalogPartsRoute
  '/_authenticated/_shell/productManagement/partCategories': typeof AuthenticatedShellProductManagementPartCategoriesRoute
  '/_authenticated/_shell/productManagement/productChangeCategories': typeof AuthenticatedShellProductManagementProductChangeCategoriesRoute
  '/_authenticated/_shell/productManagement/productChangePackages': typeof AuthenticatedShellProductManagementProductChangePackagesRoute
  '/_authenticated/_shell/productManagement/productChangeRequests': typeof AuthenticatedShellProductManagementProductChangeRequestsRoute
  '/_authenticated/_shell/productManagement/productChanges': typeof AuthenticatedShellProductManagementProductChangesRoute
  '/_authenticated/_shell/productManagement/searchPartsByAttributes': typeof AuthenticatedShellProductManagementSearchPartsByAttributesRoute
  '/_authenticated/_shell/productManagement/units': typeof AuthenticatedShellProductManagementUnitsRoute
  '/_authenticated/_shell/production/onProductionLine': typeof AuthenticatedShellProductionOnProductionLineRoute
  '/_authenticated/_shell/production/operations': typeof AuthenticatedShellProductionOperationsRoute
  '/_authenticated/_shell/production/productionLineGroupJobQueue': typeof AuthenticatedShellProductionProductionLineGroupJobQueueRoute
  '/_authenticated/_shell/production/productionLineJobQueue': typeof AuthenticatedShellProductionProductionLineJobQueueRoute
  '/_authenticated/_shell/production/productionLines': typeof AuthenticatedShellProductionProductionLinesRoute
  '/_authenticated/_shell/production/shopOrderBatchJobQueue': typeof AuthenticatedShellProductionShopOrderBatchJobQueueRoute
  '/_authenticated/_shell/production/shopOrderBatches': typeof AuthenticatedShellProductionShopOrderBatchesRoute
  '/_authenticated/_shell/production/shopOrderPackaging': typeof AuthenticatedShellProductionShopOrderPackagingRoute
  '/_authenticated/_shell/production/shopOrders': typeof AuthenticatedShellProductionShopOrdersRoute
  '/_authenticated/_shell/production/subcontractingJobQueue': typeof AuthenticatedShellProductionSubcontractingJobQueueRoute
  '/_authenticated/_shell/production/supplementShopOrder': typeof AuthenticatedShellProductionSupplementShopOrderRoute
  '/_authenticated/_shell/production/workCenterIncompleteOperations': typeof AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute
  '/_authenticated/_shell/production/workCenterJobQueue': typeof AuthenticatedShellProductionWorkCenterJobQueueRoute
  '/_authenticated/_shell/production/workCenters': typeof AuthenticatedShellProductionWorkCentersRoute
  '/_authenticated/_shell/project/activityResources': typeof AuthenticatedShellProjectActivityResourcesRoute
  '/_authenticated/_shell/project/activityTypes': typeof AuthenticatedShellProjectActivityTypesRoute
  '/_authenticated/_shell/project/costEvents': typeof AuthenticatedShellProjectCostEventsRoute
  '/_authenticated/_shell/project/jobQueue': typeof AuthenticatedShellProjectJobQueueRoute
  '/_authenticated/_shell/project/projectTypes': typeof AuthenticatedShellProjectProjectTypesRoute
  '/_authenticated/_shell/project/projects': typeof AuthenticatedShellProjectProjectsRoute
  '/_authenticated/_shell/project/resourcesGantt': typeof AuthenticatedShellProjectResourcesGanttRoute
  '/_authenticated/_shell/project/scheduling': typeof AuthenticatedShellProjectSchedulingRoute
  '/_authenticated/_shell/project/subProjectTypes': typeof AuthenticatedShellProjectSubProjectTypesRoute
  '/_authenticated/_shell/project/tree': typeof AuthenticatedShellProjectTreeRoute
  '/_authenticated/_shell/purchase/allPurchaseOrderLines': typeof AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute
  '/_authenticated/_shell/purchase/deliveryNotices': typeof AuthenticatedShellPurchaseDeliveryNoticesRoute
  '/_authenticated/_shell/purchase/processView': typeof AuthenticatedShellPurchaseProcessViewRoute
  '/_authenticated/_shell/purchase/purchaseOrderConfirmations': typeof AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute
  '/_authenticated/_shell/purchase/purchaseOrders': typeof AuthenticatedShellPurchasePurchaseOrdersRoute
  '/_authenticated/_shell/purchase/purchaseOrdersToReceive': typeof AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute
  '/_authenticated/_shell/purchase/purchaseRequests': typeof AuthenticatedShellPurchasePurchaseRequestsRoute
  '/_authenticated/_shell/sales/accounting': typeof AuthenticatedShellSalesAccountingRoute
  '/_authenticated/_shell/sales/allCustomerOrderLines': typeof AuthenticatedShellSalesAllCustomerOrderLinesRoute
  '/_authenticated/_shell/sales/billingPlanLinesToApprove': typeof AuthenticatedShellSalesBillingPlanLinesToApproveRoute
  '/_authenticated/_shell/sales/billingPlanModels': typeof AuthenticatedShellSalesBillingPlanModelsRoute
  '/_authenticated/_shell/sales/billingPlanParts': typeof AuthenticatedShellSalesBillingPlanPartsRoute
  '/_authenticated/_shell/sales/contractualTerms': typeof AuthenticatedShellSalesContractualTermsRoute
  '/_authenticated/_shell/sales/customerGroups': typeof AuthenticatedShellSalesCustomerGroupsRoute
  '/_authenticated/_shell/sales/customerOfferTypes': typeof AuthenticatedShellSalesCustomerOfferTypesRoute
  '/_authenticated/_shell/sales/customerOrderSalesConditions': typeof AuthenticatedShellSalesCustomerOrderSalesConditionsRoute
  '/_authenticated/_shell/sales/customerOrderTypes': typeof AuthenticatedShellSalesCustomerOrderTypesRoute
  '/_authenticated/_shell/sales/customerOrders': typeof AuthenticatedShellSalesCustomerOrdersRoute
  '/_authenticated/_shell/sales/customerPriceGroups': typeof AuthenticatedShellSalesCustomerPriceGroupsRoute
  '/_authenticated/_shell/sales/customers': typeof AuthenticatedShellSalesCustomersRoute
  '/_authenticated/_shell/sales/eInvoiceOperators': typeof AuthenticatedShellSalesEInvoiceOperatorsRoute
  '/_authenticated/_shell/sales/offers': typeof AuthenticatedShellSalesOffersRoute
  '/_authenticated/_shell/sales/orderDeliveryProcessView': typeof AuthenticatedShellSalesOrderDeliveryProcessViewRoute
  '/_authenticated/_shell/sales/paymentTerm': typeof AuthenticatedShellSalesPaymentTermRoute
  '/_authenticated/_shell/sales/receivedCustomerOrders': typeof AuthenticatedShellSalesReceivedCustomerOrdersRoute
  '/_authenticated/_shell/sales/salesConditions': typeof AuthenticatedShellSalesSalesConditionsRoute
  '/_authenticated/_shell/sales/salesPartCategories': typeof AuthenticatedShellSalesSalesPartCategoriesRoute
  '/_authenticated/_shell/sales/salesPartPriceGroups': typeof AuthenticatedShellSalesSalesPartPriceGroupsRoute
  '/_authenticated/_shell/sales/salesParts': typeof AuthenticatedShellSalesSalesPartsRoute
  '/_authenticated/_shell/sales/salespersons': typeof AuthenticatedShellSalesSalespersonsRoute
  '/_authenticated/_shell/sales/transportRoutes': typeof AuthenticatedShellSalesTransportRoutesRoute
  '/_authenticated/_shell/sales/vatCodes': typeof AuthenticatedShellSalesVatCodesRoute
  '/_authenticated/_shell/sales/vatHandlingTypes': typeof AuthenticatedShellSalesVatHandlingTypesRoute
  '/_authenticated/_shell/salvos/salesCommissionLimits': typeof AuthenticatedShellSalvosSalesCommissionLimitsRoute
  '/_authenticated/_shell/spc/calendars': typeof AuthenticatedShellSpcCalendarsRoute
  '/_authenticated/_shell/spc/controlCharts': typeof AuthenticatedShellSpcControlChartsRoute
  '/_authenticated/_shell/spc/cycleTimeMeasurement': typeof AuthenticatedShellSpcCycleTimeMeasurementRoute
  '/_authenticated/_shell/spc/dimensionSearch': typeof AuthenticatedShellSpcDimensionSearchRoute
  '/_authenticated/_shell/spc/importData': typeof AuthenticatedShellSpcImportDataRoute
  '/_authenticated/_shell/spc/processImprovementCategories': typeof AuthenticatedShellSpcProcessImprovementCategoriesRoute
  '/_authenticated/_shell/spc/processImprovements': typeof AuthenticatedShellSpcProcessImprovementsRoute
  '/_authenticated/_shell/spc/resources': typeof AuthenticatedShellSpcResourcesRoute
  '/_authenticated/_shell/spc/timeMeasurement': typeof AuthenticatedShellSpcTimeMeasurementRoute
  '/_authenticated/_shell/spc/yieldCharts': typeof AuthenticatedShellSpcYieldChartsRoute
  '/_authenticated/_shell/surveys/surveyCategories': typeof AuthenticatedShellSurveysSurveyCategoriesRoute
  '/_authenticated/_shell/surveys/surveyForms': typeof AuthenticatedShellSurveysSurveyFormsRoute
  '/_authenticated/_shell/tasks/allTasks': typeof AuthenticatedShellTasksAllTasksRoute
  '/_authenticated/_shell/tasks/my': typeof AuthenticatedShellTasksMyRoute
  '/_authenticated/_shell/tasks/onMyResponsibility': typeof AuthenticatedShellTasksOnMyResponsibilityRoute
  '/_authenticated/_shell/tasks/taskTemplates': typeof AuthenticatedShellTasksTaskTemplatesRoute
  '/_authenticated/_shell/users/management': typeof AuthenticatedShellUsersManagementRoute
  '/_authenticated/_shell/users/roles': typeof AuthenticatedShellUsersRolesRoute
  '/_authenticated/_shell/warehouse/dataCollection': typeof AuthenticatedShellWarehouseDataCollectionRoute
  '/_authenticated/_shell/warehouse/deliveryPackageTypes': typeof AuthenticatedShellWarehouseDeliveryPackageTypesRoute
  '/_authenticated/_shell/warehouse/inventoryLevelProfile': typeof AuthenticatedShellWarehouseInventoryLevelProfileRoute
  '/_authenticated/_shell/warehouse/partCostCalculation': typeof AuthenticatedShellWarehousePartCostCalculationRoute
  '/_authenticated/_shell/warehouse/partImportCodes': typeof AuthenticatedShellWarehousePartImportCodesRoute
  '/_authenticated/_shell/warehouse/parts': typeof AuthenticatedShellWarehousePartsRoute
  '/_authenticated/_shell/warehouse/transferJobQueue': typeof AuthenticatedShellWarehouseTransferJobQueueRoute
  '/_authenticated/_shell/warehouse/unverifiedParts': typeof AuthenticatedShellWarehouseUnverifiedPartsRoute
  '/_authenticated/_shell/warehouse/warehouseLocationParts': typeof AuthenticatedShellWarehouseWarehouseLocationPartsRoute
  '/_authenticated/_shell/warehouse/warehouseLocations': typeof AuthenticatedShellWarehouseWarehouseLocationsRoute
  '/_authenticated/_shell/warehouse/warehouseTransfers': typeof AuthenticatedShellWarehouseWarehouseTransfersRoute
  '/_authenticated/_shell/workspace/categories': typeof AuthenticatedShellWorkspaceCategoriesRoute
  '/_authenticated/_shell/workspace/workspaces': typeof AuthenticatedShellWorkspaceWorkspacesRoute
  '/_authenticated/_shell/common/accounting/accounts': typeof AuthenticatedShellCommonAccountingAccountsRoute
  '/_authenticated/_shell/common/accounting/dimensions': typeof AuthenticatedShellCommonAccountingDimensionsRoute
  '/_authenticated/_shell/erp/common/addCostEvent': typeof AuthenticatedShellErpCommonAddCostEventRoute
  '/_authenticated/_shell/erp/common/costEventObjectTypeSettings': typeof AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute
  '/_authenticated/_shell/erp/common/costEventPriceLists': typeof AuthenticatedShellErpCommonCostEventPriceListsRoute
  '/_authenticated/_shell/erp/common/costEvents': typeof AuthenticatedShellErpCommonCostEventsRoute
  '/_authenticated/_shell/erp/configurator/logSearch': typeof AuthenticatedShellErpConfiguratorLogSearchRoute
  '/_authenticated/_shell/erp/delivery/transportEquipment': typeof AuthenticatedShellErpDeliveryTransportEquipmentRoute
  '/_authenticated/_shell/erp/inventory/forecast': typeof AuthenticatedShellErpInventoryForecastRoute
  '/_authenticated/_shell/erp/production/capacity': typeof AuthenticatedShellErpProductionCapacityRoute
  '/_authenticated/_shell/erp/production/completedQuantity': typeof AuthenticatedShellErpProductionCompletedQuantityRoute
  '/_authenticated/_shell/erp/production/loadChart': typeof AuthenticatedShellErpProductionLoadChartRoute
  '/_authenticated/_shell/erp/production/productionPlanning': typeof AuthenticatedShellErpProductionProductionPlanningRoute
  '/_authenticated/_shell/erp/production/salesProductionBacklog': typeof AuthenticatedShellErpProductionSalesProductionBacklogRoute
  '/_authenticated/_shell/erp/purchase/supplierGroups': typeof AuthenticatedShellErpPurchaseSupplierGroupsRoute
  '/_authenticated/_shell/erp/purchase/suppliers': typeof AuthenticatedShellErpPurchaseSuppliersRoute
  '/_authenticated/_shell/erp/reclamations/reclamationCategory': typeof AuthenticatedShellErpReclamationsReclamationCategoryRoute
  '/_authenticated/_shell/erp/reclamations/reclamationCause': typeof AuthenticatedShellErpReclamationsReclamationCauseRoute
  '/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod': typeof AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute
  '/_authenticated/_shell/erp/reclamations/reclamationLocation': typeof AuthenticatedShellErpReclamationsReclamationLocationRoute
  '/_authenticated/_shell/erp/reclamations/reclamations': typeof AuthenticatedShellErpReclamationsReclamationsRoute
  '/_authenticated/_shell/erp/reclamations/rounds': typeof AuthenticatedShellErpReclamationsRoundsRoute
  '/_authenticated/_shell/erp/reclamations/weekPlanning': typeof AuthenticatedShellErpReclamationsWeekPlanningRoute
  '/_authenticated/_shell/erp/reclamations/workQueue': typeof AuthenticatedShellErpReclamationsWorkQueueRoute
  '/_authenticated/_shell/erp/safetyControlSurvey/noteCategories': typeof AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute
  '/_authenticated/_shell/erp/safetyControlSurvey/summary': typeof AuthenticatedShellErpSafetyControlSurveySummaryRoute
  '/_authenticated/_shell/erp/safetyControlSurvey/surveys': typeof AuthenticatedShellErpSafetyControlSurveySurveysRoute
  '/_authenticated/_shell/erp/safetyControlSurvey/teams': typeof AuthenticatedShellErpSafetyControlSurveyTeamsRoute
  '/_authenticated/_shell/erp/sales/customerOrderImport': typeof AuthenticatedShellErpSalesCustomerOrderImportRoute
  '/_authenticated/_shell/erp/vertexInd/config': typeof AuthenticatedShellErpVertexIndConfigRoute
  '/_authenticated/_shell/erp/warehouse/cargoDrivers': typeof AuthenticatedShellErpWarehouseCargoDriversRoute
  '/_authenticated/_shell/erp/warehouse/deliveryMethods': typeof AuthenticatedShellErpWarehouseDeliveryMethodsRoute
  '/_authenticated/_shell/erp/warehouse/deliveryTerms': typeof AuthenticatedShellErpWarehouseDeliveryTermsRoute
  '/_authenticated/_shell/erp/warehouse/warehousePickerGroups': typeof AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute
  '/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups': typeof AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute
  '/_authenticated/_shell/mellano/luukku/capacity': typeof AuthenticatedShellMellanoLuukkuCapacityRoute
  '/_authenticated/_shell/mellano/luukku/dataCollection': typeof AuthenticatedShellMellanoLuukkuDataCollectionRoute
  '/_authenticated/_shell/mellano/luukku/dispatchSlotting': typeof AuthenticatedShellMellanoLuukkuDispatchSlottingRoute
  '/_authenticated/_shell/mellano/luukku/drillStamps': typeof AuthenticatedShellMellanoLuukkuDrillStampsRoute
  '/_authenticated/_shell/mellano/luukku/handPaintingPlan': typeof AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute
  '/_authenticated/_shell/mellano/luukku/ketMetrics': typeof AuthenticatedShellMellanoLuukkuKetMetricsRoute
  '/_authenticated/_shell/mellano/luukku/melamineStockForecast': typeof AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute
  '/_authenticated/_shell/mellano/luukku/orderStatus': typeof AuthenticatedShellMellanoLuukkuOrderStatusRoute
  '/_authenticated/_shell/mellano/luukku/packagedAmount': typeof AuthenticatedShellMellanoLuukkuPackagedAmountRoute
  '/_authenticated/_shell/mellano/luukku/paintStockForecast': typeof AuthenticatedShellMellanoLuukkuPaintStockForecastRoute
  '/_authenticated/_shell/mellano/luukku/paintingPlan': typeof AuthenticatedShellMellanoLuukkuPaintingPlanRoute
  '/_authenticated/_shell/mellano/luukku/paintingRoundDefects': typeof AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute
  '/_authenticated/_shell/mellano/luukku/paintingRounds': typeof AuthenticatedShellMellanoLuukkuPaintingRoundsRoute
  '/_authenticated/_shell/mellano/luukku/productionPlanning': typeof AuthenticatedShellMellanoLuukkuProductionPlanningRoute
  '/_authenticated/_shell/mellano/luukku/productionStatus': typeof AuthenticatedShellMellanoLuukkuProductionStatusRoute
  '/_authenticated/_shell/mellano/luukku/purchaseOrderImport': typeof AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute
  '/_authenticated/_shell/mellano/luukku/purchaseSuggestion': typeof AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute
  '/_authenticated/_shell/mellano/luukku/shiftDefects': typeof AuthenticatedShellMellanoLuukkuShiftDefectsRoute
  '/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches': typeof AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute
  '/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress': typeof AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute
  '/_authenticated/_shell/mellano/luukku/unsentRonkkoDeliveries': typeof AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute
  '/_authenticated/_shell/mellano/luukku/workOrderSlotting': typeof AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute
  '/_authenticated/_shell/mellano/winner/designs': typeof AuthenticatedShellMellanoWinnerDesignsRoute
  '/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId': typeof AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute
  '/_authenticated/_shell/production/productionLinesStatus/$productionLineId': typeof AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute
  '/_authenticated/_shell/production/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute
  '/_authenticated/_shell/project/delivery/allDeliveries': typeof AuthenticatedShellProjectDeliveryAllDeliveriesRoute
  '/_authenticated/_shell/project/delivery/allDeliveryPackages': typeof AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute
  '/_authenticated/_shell/project/delivery/deliverableActivities': typeof AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute
  '/_authenticated/_shell/project/delivery/deliverableProjects': typeof AuthenticatedShellProjectDeliveryDeliverableProjectsRoute
  '/_authenticated/_shell/project/delivery/deliverableSubProjects': typeof AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute
  '/_authenticated/_shell/project/delivery/pickableProjects': typeof AuthenticatedShellProjectDeliveryPickableProjectsRoute
  '/_authenticated/_shell/project/delivery/undeliveredPackages': typeof AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute
  '/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries': typeof AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute
  '/_authenticated/_shell/sales/delivery/deliverableCustomerOrders': typeof AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute
  '/_authenticated/_shell/sales/delivery/ownTransports': typeof AuthenticatedShellSalesDeliveryOwnTransportsRoute
  '/_authenticated/_shell/sales/delivery/transportPlanning': typeof AuthenticatedShellSalesDeliveryTransportPlanningRoute
  '/_authenticated/_shell/sales/delivery/transports': typeof AuthenticatedShellSalesDeliveryTransportsRoute
  '/_authenticated/_shell/sales/picking/allDeliveryPackages': typeof AuthenticatedShellSalesPickingAllDeliveryPackagesRoute
  '/_authenticated/_shell/sales/picking/pickableCustomerOrders': typeof AuthenticatedShellSalesPickingPickableCustomerOrdersRoute
  '/_authenticated/_shell/sales/picking/undeliveredPackages': typeof AuthenticatedShellSalesPickingUndeliveredPackagesRoute
  '/_authenticated/_shell/sales/pricing/priceLists': typeof AuthenticatedShellSalesPricingPriceListsRoute
  '/_authenticated/_shell/sales/salesCommissions/createPayment': typeof AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute
  '/_authenticated/_shell/sales/salesCommissions/lineNames': typeof AuthenticatedShellSalesSalesCommissionsLineNamesRoute
  '/_authenticated/_shell/sales/salesCommissions/payments': typeof AuthenticatedShellSalesSalesCommissionsPaymentsRoute
  '/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines': typeof AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute
  '/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute
  '/_authenticated/_shell/spc/cChartEvents/search': typeof AuthenticatedShellSpcCChartEventsSearchRoute
  '/_authenticated/_shell/spc/controlChartCollections/management': typeof AuthenticatedShellSpcControlChartCollectionsManagementRoute
  '/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId': typeof AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute
  '/_authenticated/_shell/spc/defectGroups/$parentGroupId': typeof AuthenticatedShellSpcDefectGroupsParentGroupIdRoute
  '/_authenticated/_shell/spc/masterData/yieldCharts': typeof AuthenticatedShellSpcMasterDataYieldChartsRoute
  '/_authenticated/_shell/spc/specialCauses/chartGroups': typeof AuthenticatedShellSpcSpecialCausesChartGroupsRoute
  '/_authenticated/_shell/spc/specialCauses/resources': typeof AuthenticatedShellSpcSpecialCausesResourcesRoute
  '/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId': typeof AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute
  '/_authenticated/_shell/surveys/submissions/audit': typeof AuthenticatedShellSurveysSubmissionsAuditRoute
  '/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents': typeof AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute
  '/_authenticated/_shell/warehouse/inventory/manualEvents': typeof AuthenticatedShellWarehouseInventoryManualEventsRoute
  '/_authenticated/_shell/warehouse/inventory/stockCounts': typeof AuthenticatedShellWarehouseInventoryStockCountsRoute
  '/_authenticated/_shell/spc/summaryViews/': typeof AuthenticatedShellSpcSummaryViewsIndexRoute
  '/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines': typeof AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute
  '/_authenticated/_shell/erp/project/delivery/bundling': typeof AuthenticatedShellErpProjectDeliveryBundlingRoute
  '/_authenticated/_shell/erp/project/delivery/loading': typeof AuthenticatedShellErpProjectDeliveryLoadingRoute
  '/_authenticated/_shell/erp/project/delivery/outboundWarehouse': typeof AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute
  '/_authenticated/_shell/erp/sales/delivery/bundling': typeof AuthenticatedShellErpSalesDeliveryBundlingRoute
  '/_authenticated/_shell/erp/sales/delivery/loading': typeof AuthenticatedShellErpSalesDeliveryLoadingRoute
  '/_authenticated/_shell/erp/sales/delivery/outboundWarehouse': typeof AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute
  '/_authenticated/_shell/erp/sales/invoicing/allInvoices': typeof AuthenticatedShellErpSalesInvoicingAllInvoicesRoute
  '/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders': typeof AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute
  '/_authenticated/_shell/erp/sales/reports/customerOrderBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute
  '/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog': typeof AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute
  '/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue': typeof AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute
  '/_authenticated/_shell/erp/warehouse/reports/warehouseValue': typeof AuthenticatedShellErpWarehouseReportsWarehouseValueRoute
  '/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId': typeof AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute
  '/_authenticated/_shell/spc/controlChartCollections/view/$collectionId': typeof AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute
  '/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId': typeof AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute
  '/_authenticated/_shell/spc/processDiagrams/resources/$resourceId': typeof AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute
  '/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute
  '/_authenticated/_shell/spc/summaryViews/grid/$summaryViewId': typeof AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute
  '/_authenticated/_shell/erp/sales/invoicing/reports/invoices': typeof AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/emailVerified'
    | '/index.html'
    | '/insufficientPermissions'
    | '/loggedOut'
    | '/settings'
    | '/customAppWindow/$windowId'
    | '/views/$'
    | '/bi'
    | '/devTest'
    | '/connection/oauth/callback'
    | '/wopi/$action/$fileId'
    | '/ai/costs'
    | '/ai/management'
    | '/apps/$customAppId'
    | '/common/companies'
    | '/common/currencies'
    | '/common/documentTemplates'
    | '/common/emailTemplates'
    | '/common/numberSequences'
    | '/common/objectAttributeFields'
    | '/common/sites'
    | '/common/systemDiagrams'
    | '/configurator/libraries'
    | '/configurator/optionLists'
    | '/configurator/productFamilies'
    | '/configurator/productFamilyCategories'
    | '/configurator/tables'
    | '/crm/contacts'
    | '/crm/customers'
    | '/crm/incomingLeads'
    | '/crm/salesAreas'
    | '/crm/salesLeadActivities'
    | '/crm/salesLeadActivityCategories'
    | '/crm/salesLeadSources'
    | '/crm/salesLeads'
    | '/crm/salesPipeline'
    | '/crm/salesPipelineBoard'
    | '/customizations/api-connections'
    | '/customizations/api-keys'
    | '/customizations/custom-apps'
    | '/customizations/custom-functions'
    | '/customizations/sent-emails'
    | '/documents/documentCategories'
    | '/documents/search'
    | '/mellano/lisToLsb'
    | '/mellano/paintingControlCharts'
    | '/productDesign/bomLineGroups'
    | '/productManagement/catalogParts'
    | '/productManagement/partCategories'
    | '/productManagement/productChangeCategories'
    | '/productManagement/productChangePackages'
    | '/productManagement/productChangeRequests'
    | '/productManagement/productChanges'
    | '/productManagement/searchPartsByAttributes'
    | '/productManagement/units'
    | '/production/onProductionLine'
    | '/production/operations'
    | '/production/productionLineGroupJobQueue'
    | '/production/productionLineJobQueue'
    | '/production/productionLines'
    | '/production/shopOrderBatchJobQueue'
    | '/production/shopOrderBatches'
    | '/production/shopOrderPackaging'
    | '/production/shopOrders'
    | '/production/subcontractingJobQueue'
    | '/production/supplementShopOrder'
    | '/production/workCenterIncompleteOperations'
    | '/production/workCenterJobQueue'
    | '/production/workCenters'
    | '/project/activityResources'
    | '/project/activityTypes'
    | '/project/costEvents'
    | '/project/jobQueue'
    | '/project/projectTypes'
    | '/project/projects'
    | '/project/resourcesGantt'
    | '/project/scheduling'
    | '/project/subProjectTypes'
    | '/project/tree'
    | '/purchase/allPurchaseOrderLines'
    | '/purchase/deliveryNotices'
    | '/purchase/processView'
    | '/purchase/purchaseOrderConfirmations'
    | '/purchase/purchaseOrders'
    | '/purchase/purchaseOrdersToReceive'
    | '/purchase/purchaseRequests'
    | '/sales/accounting'
    | '/sales/allCustomerOrderLines'
    | '/sales/billingPlanLinesToApprove'
    | '/sales/billingPlanModels'
    | '/sales/billingPlanParts'
    | '/sales/contractualTerms'
    | '/sales/customerGroups'
    | '/sales/customerOfferTypes'
    | '/sales/customerOrderSalesConditions'
    | '/sales/customerOrderTypes'
    | '/sales/customerOrders'
    | '/sales/customerPriceGroups'
    | '/sales/customers'
    | '/sales/eInvoiceOperators'
    | '/sales/offers'
    | '/sales/orderDeliveryProcessView'
    | '/sales/paymentTerm'
    | '/sales/receivedCustomerOrders'
    | '/sales/salesConditions'
    | '/sales/salesPartCategories'
    | '/sales/salesPartPriceGroups'
    | '/sales/salesParts'
    | '/sales/salespersons'
    | '/sales/transportRoutes'
    | '/sales/vatCodes'
    | '/sales/vatHandlingTypes'
    | '/salvos/salesCommissionLimits'
    | '/spc/calendars'
    | '/spc/controlCharts'
    | '/spc/cycleTimeMeasurement'
    | '/spc/dimensionSearch'
    | '/spc/importData'
    | '/spc/processImprovementCategories'
    | '/spc/processImprovements'
    | '/spc/resources'
    | '/spc/timeMeasurement'
    | '/spc/yieldCharts'
    | '/surveys/surveyCategories'
    | '/surveys/surveyForms'
    | '/tasks/allTasks'
    | '/tasks/my'
    | '/tasks/onMyResponsibility'
    | '/tasks/taskTemplates'
    | '/users/management'
    | '/users/roles'
    | '/warehouse/dataCollection'
    | '/warehouse/deliveryPackageTypes'
    | '/warehouse/inventoryLevelProfile'
    | '/warehouse/partCostCalculation'
    | '/warehouse/partImportCodes'
    | '/warehouse/parts'
    | '/warehouse/transferJobQueue'
    | '/warehouse/unverifiedParts'
    | '/warehouse/warehouseLocationParts'
    | '/warehouse/warehouseLocations'
    | '/warehouse/warehouseTransfers'
    | '/workspace/categories'
    | '/workspace/workspaces'
    | '/common/accounting/accounts'
    | '/common/accounting/dimensions'
    | '/erp/common/addCostEvent'
    | '/erp/common/costEventObjectTypeSettings'
    | '/erp/common/costEventPriceLists'
    | '/erp/common/costEvents'
    | '/erp/configurator/logSearch'
    | '/erp/delivery/transportEquipment'
    | '/erp/inventory/forecast'
    | '/erp/production/capacity'
    | '/erp/production/completedQuantity'
    | '/erp/production/loadChart'
    | '/erp/production/productionPlanning'
    | '/erp/production/salesProductionBacklog'
    | '/erp/purchase/supplierGroups'
    | '/erp/purchase/suppliers'
    | '/erp/reclamations/reclamationCategory'
    | '/erp/reclamations/reclamationCause'
    | '/erp/reclamations/reclamationHandlingMethod'
    | '/erp/reclamations/reclamationLocation'
    | '/erp/reclamations/reclamations'
    | '/erp/reclamations/rounds'
    | '/erp/reclamations/weekPlanning'
    | '/erp/reclamations/workQueue'
    | '/erp/safetyControlSurvey/noteCategories'
    | '/erp/safetyControlSurvey/summary'
    | '/erp/safetyControlSurvey/surveys'
    | '/erp/safetyControlSurvey/teams'
    | '/erp/sales/customerOrderImport'
    | '/erp/vertexInd/config'
    | '/erp/warehouse/cargoDrivers'
    | '/erp/warehouse/deliveryMethods'
    | '/erp/warehouse/deliveryTerms'
    | '/erp/warehouse/warehousePickerGroups'
    | '/erp/warehouse/warehouseReplenishmentGroups'
    | '/mellano/luukku/capacity'
    | '/mellano/luukku/dataCollection'
    | '/mellano/luukku/dispatchSlotting'
    | '/mellano/luukku/drillStamps'
    | '/mellano/luukku/handPaintingPlan'
    | '/mellano/luukku/ketMetrics'
    | '/mellano/luukku/melamineStockForecast'
    | '/mellano/luukku/orderStatus'
    | '/mellano/luukku/packagedAmount'
    | '/mellano/luukku/paintStockForecast'
    | '/mellano/luukku/paintingPlan'
    | '/mellano/luukku/paintingRoundDefects'
    | '/mellano/luukku/paintingRounds'
    | '/mellano/luukku/productionPlanning'
    | '/mellano/luukku/productionStatus'
    | '/mellano/luukku/purchaseOrderImport'
    | '/mellano/luukku/purchaseSuggestion'
    | '/mellano/luukku/shiftDefects'
    | '/mellano/luukku/unpackagedDeliveryBatches'
    | '/mellano/luukku/unsentDeliveriesByAddress'
    | '/mellano/luukku/unsentRonkkoDeliveries'
    | '/mellano/luukku/workOrderSlotting'
    | '/mellano/winner/designs'
    | '/production/productionLineGroupStatus/$productionLineGroupId'
    | '/production/productionLinesStatus/$productionLineId'
    | '/production/systemDiagrams/$systemDiagramId'
    | '/project/delivery/allDeliveries'
    | '/project/delivery/allDeliveryPackages'
    | '/project/delivery/deliverableActivities'
    | '/project/delivery/deliverableProjects'
    | '/project/delivery/deliverableSubProjects'
    | '/project/delivery/pickableProjects'
    | '/project/delivery/undeliveredPackages'
    | '/sales/delivery/allCustomerOrderDeliveries'
    | '/sales/delivery/deliverableCustomerOrders'
    | '/sales/delivery/ownTransports'
    | '/sales/delivery/transportPlanning'
    | '/sales/delivery/transports'
    | '/sales/picking/allDeliveryPackages'
    | '/sales/picking/pickableCustomerOrders'
    | '/sales/picking/undeliveredPackages'
    | '/sales/pricing/priceLists'
    | '/sales/salesCommissions/createPayment'
    | '/sales/salesCommissions/lineNames'
    | '/sales/salesCommissions/payments'
    | '/sales/salesCommissions/unapprovedSalesCommissionLines'
    | '/sales/systemDiagrams/$systemDiagramId'
    | '/spc/cChartEvents/search'
    | '/spc/controlChartCollections/management'
    | '/spc/controlChartParentGroup/$parentGroupId'
    | '/spc/defectGroups/$parentGroupId'
    | '/spc/masterData/yieldCharts'
    | '/spc/specialCauses/chartGroups'
    | '/spc/specialCauses/resources'
    | '/spc/systemDiagrams/$systemDiagramId'
    | '/surveys/submissions/audit'
    | '/warehouse/inventory/allInventoryLevelEvents'
    | '/warehouse/inventory/manualEvents'
    | '/warehouse/inventory/stockCounts'
    | '/spc/summaryViews/'
    | '/erp/parts/costCalculation/configurableCustomerOrderLines'
    | '/erp/project/delivery/bundling'
    | '/erp/project/delivery/loading'
    | '/erp/project/delivery/outboundWarehouse'
    | '/erp/sales/delivery/bundling'
    | '/erp/sales/delivery/loading'
    | '/erp/sales/delivery/outboundWarehouse'
    | '/erp/sales/invoicing/allInvoices'
    | '/erp/sales/invoicing/billableCustomerOrders'
    | '/erp/sales/reports/customerOrderBacklog'
    | '/erp/sales/reports/customerOrderOfferBacklog'
    | '/erp/warehouse/reports/shippingWarehouseInventoryValue'
    | '/erp/warehouse/reports/warehouseValue'
    | '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
    | '/spc/controlChartCollections/view/$collectionId'
    | '/spc/processDiagrams/chartGroups/$chartGroupId'
    | '/spc/processDiagrams/resources/$resourceId'
    | '/spc/summaryViews/diagram/$summaryViewId'
    | '/spc/summaryViews/grid/$summaryViewId'
    | '/erp/sales/invoicing/reports/invoices'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/emailVerified'
    | '/index.html'
    | '/insufficientPermissions'
    | '/loggedOut'
    | '/settings'
    | '/customAppWindow/$windowId'
    | '/views/$'
    | '/bi'
    | '/devTest'
    | '/connection/oauth/callback'
    | '/wopi/$action/$fileId'
    | '/ai/costs'
    | '/ai/management'
    | '/apps/$customAppId'
    | '/common/companies'
    | '/common/currencies'
    | '/common/documentTemplates'
    | '/common/emailTemplates'
    | '/common/numberSequences'
    | '/common/objectAttributeFields'
    | '/common/sites'
    | '/common/systemDiagrams'
    | '/configurator/libraries'
    | '/configurator/optionLists'
    | '/configurator/productFamilies'
    | '/configurator/productFamilyCategories'
    | '/configurator/tables'
    | '/crm/contacts'
    | '/crm/customers'
    | '/crm/incomingLeads'
    | '/crm/salesAreas'
    | '/crm/salesLeadActivities'
    | '/crm/salesLeadActivityCategories'
    | '/crm/salesLeadSources'
    | '/crm/salesLeads'
    | '/crm/salesPipeline'
    | '/crm/salesPipelineBoard'
    | '/customizations/api-connections'
    | '/customizations/api-keys'
    | '/customizations/custom-apps'
    | '/customizations/custom-functions'
    | '/customizations/sent-emails'
    | '/documents/documentCategories'
    | '/documents/search'
    | '/mellano/lisToLsb'
    | '/mellano/paintingControlCharts'
    | '/productDesign/bomLineGroups'
    | '/productManagement/catalogParts'
    | '/productManagement/partCategories'
    | '/productManagement/productChangeCategories'
    | '/productManagement/productChangePackages'
    | '/productManagement/productChangeRequests'
    | '/productManagement/productChanges'
    | '/productManagement/searchPartsByAttributes'
    | '/productManagement/units'
    | '/production/onProductionLine'
    | '/production/operations'
    | '/production/productionLineGroupJobQueue'
    | '/production/productionLineJobQueue'
    | '/production/productionLines'
    | '/production/shopOrderBatchJobQueue'
    | '/production/shopOrderBatches'
    | '/production/shopOrderPackaging'
    | '/production/shopOrders'
    | '/production/subcontractingJobQueue'
    | '/production/supplementShopOrder'
    | '/production/workCenterIncompleteOperations'
    | '/production/workCenterJobQueue'
    | '/production/workCenters'
    | '/project/activityResources'
    | '/project/activityTypes'
    | '/project/costEvents'
    | '/project/jobQueue'
    | '/project/projectTypes'
    | '/project/projects'
    | '/project/resourcesGantt'
    | '/project/scheduling'
    | '/project/subProjectTypes'
    | '/project/tree'
    | '/purchase/allPurchaseOrderLines'
    | '/purchase/deliveryNotices'
    | '/purchase/processView'
    | '/purchase/purchaseOrderConfirmations'
    | '/purchase/purchaseOrders'
    | '/purchase/purchaseOrdersToReceive'
    | '/purchase/purchaseRequests'
    | '/sales/accounting'
    | '/sales/allCustomerOrderLines'
    | '/sales/billingPlanLinesToApprove'
    | '/sales/billingPlanModels'
    | '/sales/billingPlanParts'
    | '/sales/contractualTerms'
    | '/sales/customerGroups'
    | '/sales/customerOfferTypes'
    | '/sales/customerOrderSalesConditions'
    | '/sales/customerOrderTypes'
    | '/sales/customerOrders'
    | '/sales/customerPriceGroups'
    | '/sales/customers'
    | '/sales/eInvoiceOperators'
    | '/sales/offers'
    | '/sales/orderDeliveryProcessView'
    | '/sales/paymentTerm'
    | '/sales/receivedCustomerOrders'
    | '/sales/salesConditions'
    | '/sales/salesPartCategories'
    | '/sales/salesPartPriceGroups'
    | '/sales/salesParts'
    | '/sales/salespersons'
    | '/sales/transportRoutes'
    | '/sales/vatCodes'
    | '/sales/vatHandlingTypes'
    | '/salvos/salesCommissionLimits'
    | '/spc/calendars'
    | '/spc/controlCharts'
    | '/spc/cycleTimeMeasurement'
    | '/spc/dimensionSearch'
    | '/spc/importData'
    | '/spc/processImprovementCategories'
    | '/spc/processImprovements'
    | '/spc/resources'
    | '/spc/timeMeasurement'
    | '/spc/yieldCharts'
    | '/surveys/surveyCategories'
    | '/surveys/surveyForms'
    | '/tasks/allTasks'
    | '/tasks/my'
    | '/tasks/onMyResponsibility'
    | '/tasks/taskTemplates'
    | '/users/management'
    | '/users/roles'
    | '/warehouse/dataCollection'
    | '/warehouse/deliveryPackageTypes'
    | '/warehouse/inventoryLevelProfile'
    | '/warehouse/partCostCalculation'
    | '/warehouse/partImportCodes'
    | '/warehouse/parts'
    | '/warehouse/transferJobQueue'
    | '/warehouse/unverifiedParts'
    | '/warehouse/warehouseLocationParts'
    | '/warehouse/warehouseLocations'
    | '/warehouse/warehouseTransfers'
    | '/workspace/categories'
    | '/workspace/workspaces'
    | '/common/accounting/accounts'
    | '/common/accounting/dimensions'
    | '/erp/common/addCostEvent'
    | '/erp/common/costEventObjectTypeSettings'
    | '/erp/common/costEventPriceLists'
    | '/erp/common/costEvents'
    | '/erp/configurator/logSearch'
    | '/erp/delivery/transportEquipment'
    | '/erp/inventory/forecast'
    | '/erp/production/capacity'
    | '/erp/production/completedQuantity'
    | '/erp/production/loadChart'
    | '/erp/production/productionPlanning'
    | '/erp/production/salesProductionBacklog'
    | '/erp/purchase/supplierGroups'
    | '/erp/purchase/suppliers'
    | '/erp/reclamations/reclamationCategory'
    | '/erp/reclamations/reclamationCause'
    | '/erp/reclamations/reclamationHandlingMethod'
    | '/erp/reclamations/reclamationLocation'
    | '/erp/reclamations/reclamations'
    | '/erp/reclamations/rounds'
    | '/erp/reclamations/weekPlanning'
    | '/erp/reclamations/workQueue'
    | '/erp/safetyControlSurvey/noteCategories'
    | '/erp/safetyControlSurvey/summary'
    | '/erp/safetyControlSurvey/surveys'
    | '/erp/safetyControlSurvey/teams'
    | '/erp/sales/customerOrderImport'
    | '/erp/vertexInd/config'
    | '/erp/warehouse/cargoDrivers'
    | '/erp/warehouse/deliveryMethods'
    | '/erp/warehouse/deliveryTerms'
    | '/erp/warehouse/warehousePickerGroups'
    | '/erp/warehouse/warehouseReplenishmentGroups'
    | '/mellano/luukku/capacity'
    | '/mellano/luukku/dataCollection'
    | '/mellano/luukku/dispatchSlotting'
    | '/mellano/luukku/drillStamps'
    | '/mellano/luukku/handPaintingPlan'
    | '/mellano/luukku/ketMetrics'
    | '/mellano/luukku/melamineStockForecast'
    | '/mellano/luukku/orderStatus'
    | '/mellano/luukku/packagedAmount'
    | '/mellano/luukku/paintStockForecast'
    | '/mellano/luukku/paintingPlan'
    | '/mellano/luukku/paintingRoundDefects'
    | '/mellano/luukku/paintingRounds'
    | '/mellano/luukku/productionPlanning'
    | '/mellano/luukku/productionStatus'
    | '/mellano/luukku/purchaseOrderImport'
    | '/mellano/luukku/purchaseSuggestion'
    | '/mellano/luukku/shiftDefects'
    | '/mellano/luukku/unpackagedDeliveryBatches'
    | '/mellano/luukku/unsentDeliveriesByAddress'
    | '/mellano/luukku/unsentRonkkoDeliveries'
    | '/mellano/luukku/workOrderSlotting'
    | '/mellano/winner/designs'
    | '/production/productionLineGroupStatus/$productionLineGroupId'
    | '/production/productionLinesStatus/$productionLineId'
    | '/production/systemDiagrams/$systemDiagramId'
    | '/project/delivery/allDeliveries'
    | '/project/delivery/allDeliveryPackages'
    | '/project/delivery/deliverableActivities'
    | '/project/delivery/deliverableProjects'
    | '/project/delivery/deliverableSubProjects'
    | '/project/delivery/pickableProjects'
    | '/project/delivery/undeliveredPackages'
    | '/sales/delivery/allCustomerOrderDeliveries'
    | '/sales/delivery/deliverableCustomerOrders'
    | '/sales/delivery/ownTransports'
    | '/sales/delivery/transportPlanning'
    | '/sales/delivery/transports'
    | '/sales/picking/allDeliveryPackages'
    | '/sales/picking/pickableCustomerOrders'
    | '/sales/picking/undeliveredPackages'
    | '/sales/pricing/priceLists'
    | '/sales/salesCommissions/createPayment'
    | '/sales/salesCommissions/lineNames'
    | '/sales/salesCommissions/payments'
    | '/sales/salesCommissions/unapprovedSalesCommissionLines'
    | '/sales/systemDiagrams/$systemDiagramId'
    | '/spc/cChartEvents/search'
    | '/spc/controlChartCollections/management'
    | '/spc/controlChartParentGroup/$parentGroupId'
    | '/spc/defectGroups/$parentGroupId'
    | '/spc/masterData/yieldCharts'
    | '/spc/specialCauses/chartGroups'
    | '/spc/specialCauses/resources'
    | '/spc/systemDiagrams/$systemDiagramId'
    | '/surveys/submissions/audit'
    | '/warehouse/inventory/allInventoryLevelEvents'
    | '/warehouse/inventory/manualEvents'
    | '/warehouse/inventory/stockCounts'
    | '/spc/summaryViews'
    | '/erp/parts/costCalculation/configurableCustomerOrderLines'
    | '/erp/project/delivery/bundling'
    | '/erp/project/delivery/loading'
    | '/erp/project/delivery/outboundWarehouse'
    | '/erp/sales/delivery/bundling'
    | '/erp/sales/delivery/loading'
    | '/erp/sales/delivery/outboundWarehouse'
    | '/erp/sales/invoicing/allInvoices'
    | '/erp/sales/invoicing/billableCustomerOrders'
    | '/erp/sales/reports/customerOrderBacklog'
    | '/erp/sales/reports/customerOrderOfferBacklog'
    | '/erp/warehouse/reports/shippingWarehouseInventoryValue'
    | '/erp/warehouse/reports/warehouseValue'
    | '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
    | '/spc/controlChartCollections/view/$collectionId'
    | '/spc/processDiagrams/chartGroups/$chartGroupId'
    | '/spc/processDiagrams/resources/$resourceId'
    | '/spc/summaryViews/diagram/$summaryViewId'
    | '/spc/summaryViews/grid/$summaryViewId'
    | '/erp/sales/invoicing/reports/invoices'
  id:
    | '__root__'
    | '/_authenticated'
    | '/emailVerified'
    | '/index.html'
    | '/insufficientPermissions'
    | '/loggedOut'
    | '/_authenticated/_shell'
    | '/_authenticated/settings'
    | '/customAppWindow/$windowId'
    | '/views/$'
    | '/_authenticated/_shell/bi'
    | '/_authenticated/_shell/devTest'
    | '/connection/oauth/callback'
    | '/wopi/$action/$fileId'
    | '/_authenticated/_shell/'
    | '/_authenticated/_shell/ai/costs'
    | '/_authenticated/_shell/ai/management'
    | '/_authenticated/_shell/apps/$customAppId'
    | '/_authenticated/_shell/common/companies'
    | '/_authenticated/_shell/common/currencies'
    | '/_authenticated/_shell/common/documentTemplates'
    | '/_authenticated/_shell/common/emailTemplates'
    | '/_authenticated/_shell/common/numberSequences'
    | '/_authenticated/_shell/common/objectAttributeFields'
    | '/_authenticated/_shell/common/sites'
    | '/_authenticated/_shell/common/systemDiagrams'
    | '/_authenticated/_shell/configurator/libraries'
    | '/_authenticated/_shell/configurator/optionLists'
    | '/_authenticated/_shell/configurator/productFamilies'
    | '/_authenticated/_shell/configurator/productFamilyCategories'
    | '/_authenticated/_shell/configurator/tables'
    | '/_authenticated/_shell/crm/contacts'
    | '/_authenticated/_shell/crm/customers'
    | '/_authenticated/_shell/crm/incomingLeads'
    | '/_authenticated/_shell/crm/salesAreas'
    | '/_authenticated/_shell/crm/salesLeadActivities'
    | '/_authenticated/_shell/crm/salesLeadActivityCategories'
    | '/_authenticated/_shell/crm/salesLeadSources'
    | '/_authenticated/_shell/crm/salesLeads'
    | '/_authenticated/_shell/crm/salesPipeline'
    | '/_authenticated/_shell/crm/salesPipelineBoard'
    | '/_authenticated/_shell/customizations/api-connections'
    | '/_authenticated/_shell/customizations/api-keys'
    | '/_authenticated/_shell/customizations/custom-apps'
    | '/_authenticated/_shell/customizations/custom-functions'
    | '/_authenticated/_shell/customizations/sent-emails'
    | '/_authenticated/_shell/documents/documentCategories'
    | '/_authenticated/_shell/documents/search'
    | '/_authenticated/_shell/mellano/lisToLsb'
    | '/_authenticated/_shell/mellano/paintingControlCharts'
    | '/_authenticated/_shell/productDesign/bomLineGroups'
    | '/_authenticated/_shell/productManagement/catalogParts'
    | '/_authenticated/_shell/productManagement/partCategories'
    | '/_authenticated/_shell/productManagement/productChangeCategories'
    | '/_authenticated/_shell/productManagement/productChangePackages'
    | '/_authenticated/_shell/productManagement/productChangeRequests'
    | '/_authenticated/_shell/productManagement/productChanges'
    | '/_authenticated/_shell/productManagement/searchPartsByAttributes'
    | '/_authenticated/_shell/productManagement/units'
    | '/_authenticated/_shell/production/onProductionLine'
    | '/_authenticated/_shell/production/operations'
    | '/_authenticated/_shell/production/productionLineGroupJobQueue'
    | '/_authenticated/_shell/production/productionLineJobQueue'
    | '/_authenticated/_shell/production/productionLines'
    | '/_authenticated/_shell/production/shopOrderBatchJobQueue'
    | '/_authenticated/_shell/production/shopOrderBatches'
    | '/_authenticated/_shell/production/shopOrderPackaging'
    | '/_authenticated/_shell/production/shopOrders'
    | '/_authenticated/_shell/production/subcontractingJobQueue'
    | '/_authenticated/_shell/production/supplementShopOrder'
    | '/_authenticated/_shell/production/workCenterIncompleteOperations'
    | '/_authenticated/_shell/production/workCenterJobQueue'
    | '/_authenticated/_shell/production/workCenters'
    | '/_authenticated/_shell/project/activityResources'
    | '/_authenticated/_shell/project/activityTypes'
    | '/_authenticated/_shell/project/costEvents'
    | '/_authenticated/_shell/project/jobQueue'
    | '/_authenticated/_shell/project/projectTypes'
    | '/_authenticated/_shell/project/projects'
    | '/_authenticated/_shell/project/resourcesGantt'
    | '/_authenticated/_shell/project/scheduling'
    | '/_authenticated/_shell/project/subProjectTypes'
    | '/_authenticated/_shell/project/tree'
    | '/_authenticated/_shell/purchase/allPurchaseOrderLines'
    | '/_authenticated/_shell/purchase/deliveryNotices'
    | '/_authenticated/_shell/purchase/processView'
    | '/_authenticated/_shell/purchase/purchaseOrderConfirmations'
    | '/_authenticated/_shell/purchase/purchaseOrders'
    | '/_authenticated/_shell/purchase/purchaseOrdersToReceive'
    | '/_authenticated/_shell/purchase/purchaseRequests'
    | '/_authenticated/_shell/sales/accounting'
    | '/_authenticated/_shell/sales/allCustomerOrderLines'
    | '/_authenticated/_shell/sales/billingPlanLinesToApprove'
    | '/_authenticated/_shell/sales/billingPlanModels'
    | '/_authenticated/_shell/sales/billingPlanParts'
    | '/_authenticated/_shell/sales/contractualTerms'
    | '/_authenticated/_shell/sales/customerGroups'
    | '/_authenticated/_shell/sales/customerOfferTypes'
    | '/_authenticated/_shell/sales/customerOrderSalesConditions'
    | '/_authenticated/_shell/sales/customerOrderTypes'
    | '/_authenticated/_shell/sales/customerOrders'
    | '/_authenticated/_shell/sales/customerPriceGroups'
    | '/_authenticated/_shell/sales/customers'
    | '/_authenticated/_shell/sales/eInvoiceOperators'
    | '/_authenticated/_shell/sales/offers'
    | '/_authenticated/_shell/sales/orderDeliveryProcessView'
    | '/_authenticated/_shell/sales/paymentTerm'
    | '/_authenticated/_shell/sales/receivedCustomerOrders'
    | '/_authenticated/_shell/sales/salesConditions'
    | '/_authenticated/_shell/sales/salesPartCategories'
    | '/_authenticated/_shell/sales/salesPartPriceGroups'
    | '/_authenticated/_shell/sales/salesParts'
    | '/_authenticated/_shell/sales/salespersons'
    | '/_authenticated/_shell/sales/transportRoutes'
    | '/_authenticated/_shell/sales/vatCodes'
    | '/_authenticated/_shell/sales/vatHandlingTypes'
    | '/_authenticated/_shell/salvos/salesCommissionLimits'
    | '/_authenticated/_shell/spc/calendars'
    | '/_authenticated/_shell/spc/controlCharts'
    | '/_authenticated/_shell/spc/cycleTimeMeasurement'
    | '/_authenticated/_shell/spc/dimensionSearch'
    | '/_authenticated/_shell/spc/importData'
    | '/_authenticated/_shell/spc/processImprovementCategories'
    | '/_authenticated/_shell/spc/processImprovements'
    | '/_authenticated/_shell/spc/resources'
    | '/_authenticated/_shell/spc/timeMeasurement'
    | '/_authenticated/_shell/spc/yieldCharts'
    | '/_authenticated/_shell/surveys/surveyCategories'
    | '/_authenticated/_shell/surveys/surveyForms'
    | '/_authenticated/_shell/tasks/allTasks'
    | '/_authenticated/_shell/tasks/my'
    | '/_authenticated/_shell/tasks/onMyResponsibility'
    | '/_authenticated/_shell/tasks/taskTemplates'
    | '/_authenticated/_shell/users/management'
    | '/_authenticated/_shell/users/roles'
    | '/_authenticated/_shell/warehouse/dataCollection'
    | '/_authenticated/_shell/warehouse/deliveryPackageTypes'
    | '/_authenticated/_shell/warehouse/inventoryLevelProfile'
    | '/_authenticated/_shell/warehouse/partCostCalculation'
    | '/_authenticated/_shell/warehouse/partImportCodes'
    | '/_authenticated/_shell/warehouse/parts'
    | '/_authenticated/_shell/warehouse/transferJobQueue'
    | '/_authenticated/_shell/warehouse/unverifiedParts'
    | '/_authenticated/_shell/warehouse/warehouseLocationParts'
    | '/_authenticated/_shell/warehouse/warehouseLocations'
    | '/_authenticated/_shell/warehouse/warehouseTransfers'
    | '/_authenticated/_shell/workspace/categories'
    | '/_authenticated/_shell/workspace/workspaces'
    | '/_authenticated/_shell/common/accounting/accounts'
    | '/_authenticated/_shell/common/accounting/dimensions'
    | '/_authenticated/_shell/erp/common/addCostEvent'
    | '/_authenticated/_shell/erp/common/costEventObjectTypeSettings'
    | '/_authenticated/_shell/erp/common/costEventPriceLists'
    | '/_authenticated/_shell/erp/common/costEvents'
    | '/_authenticated/_shell/erp/configurator/logSearch'
    | '/_authenticated/_shell/erp/delivery/transportEquipment'
    | '/_authenticated/_shell/erp/inventory/forecast'
    | '/_authenticated/_shell/erp/production/capacity'
    | '/_authenticated/_shell/erp/production/completedQuantity'
    | '/_authenticated/_shell/erp/production/loadChart'
    | '/_authenticated/_shell/erp/production/productionPlanning'
    | '/_authenticated/_shell/erp/production/salesProductionBacklog'
    | '/_authenticated/_shell/erp/purchase/supplierGroups'
    | '/_authenticated/_shell/erp/purchase/suppliers'
    | '/_authenticated/_shell/erp/reclamations/reclamationCategory'
    | '/_authenticated/_shell/erp/reclamations/reclamationCause'
    | '/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod'
    | '/_authenticated/_shell/erp/reclamations/reclamationLocation'
    | '/_authenticated/_shell/erp/reclamations/reclamations'
    | '/_authenticated/_shell/erp/reclamations/rounds'
    | '/_authenticated/_shell/erp/reclamations/weekPlanning'
    | '/_authenticated/_shell/erp/reclamations/workQueue'
    | '/_authenticated/_shell/erp/safetyControlSurvey/noteCategories'
    | '/_authenticated/_shell/erp/safetyControlSurvey/summary'
    | '/_authenticated/_shell/erp/safetyControlSurvey/surveys'
    | '/_authenticated/_shell/erp/safetyControlSurvey/teams'
    | '/_authenticated/_shell/erp/sales/customerOrderImport'
    | '/_authenticated/_shell/erp/vertexInd/config'
    | '/_authenticated/_shell/erp/warehouse/cargoDrivers'
    | '/_authenticated/_shell/erp/warehouse/deliveryMethods'
    | '/_authenticated/_shell/erp/warehouse/deliveryTerms'
    | '/_authenticated/_shell/erp/warehouse/warehousePickerGroups'
    | '/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups'
    | '/_authenticated/_shell/mellano/luukku/capacity'
    | '/_authenticated/_shell/mellano/luukku/dataCollection'
    | '/_authenticated/_shell/mellano/luukku/dispatchSlotting'
    | '/_authenticated/_shell/mellano/luukku/drillStamps'
    | '/_authenticated/_shell/mellano/luukku/handPaintingPlan'
    | '/_authenticated/_shell/mellano/luukku/ketMetrics'
    | '/_authenticated/_shell/mellano/luukku/melamineStockForecast'
    | '/_authenticated/_shell/mellano/luukku/orderStatus'
    | '/_authenticated/_shell/mellano/luukku/packagedAmount'
    | '/_authenticated/_shell/mellano/luukku/paintStockForecast'
    | '/_authenticated/_shell/mellano/luukku/paintingPlan'
    | '/_authenticated/_shell/mellano/luukku/paintingRoundDefects'
    | '/_authenticated/_shell/mellano/luukku/paintingRounds'
    | '/_authenticated/_shell/mellano/luukku/productionPlanning'
    | '/_authenticated/_shell/mellano/luukku/productionStatus'
    | '/_authenticated/_shell/mellano/luukku/purchaseOrderImport'
    | '/_authenticated/_shell/mellano/luukku/purchaseSuggestion'
    | '/_authenticated/_shell/mellano/luukku/shiftDefects'
    | '/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches'
    | '/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress'
    | '/_authenticated/_shell/mellano/luukku/unsentRonkkoDeliveries'
    | '/_authenticated/_shell/mellano/luukku/workOrderSlotting'
    | '/_authenticated/_shell/mellano/winner/designs'
    | '/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId'
    | '/_authenticated/_shell/production/productionLinesStatus/$productionLineId'
    | '/_authenticated/_shell/production/systemDiagrams/$systemDiagramId'
    | '/_authenticated/_shell/project/delivery/allDeliveries'
    | '/_authenticated/_shell/project/delivery/allDeliveryPackages'
    | '/_authenticated/_shell/project/delivery/deliverableActivities'
    | '/_authenticated/_shell/project/delivery/deliverableProjects'
    | '/_authenticated/_shell/project/delivery/deliverableSubProjects'
    | '/_authenticated/_shell/project/delivery/pickableProjects'
    | '/_authenticated/_shell/project/delivery/undeliveredPackages'
    | '/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries'
    | '/_authenticated/_shell/sales/delivery/deliverableCustomerOrders'
    | '/_authenticated/_shell/sales/delivery/ownTransports'
    | '/_authenticated/_shell/sales/delivery/transportPlanning'
    | '/_authenticated/_shell/sales/delivery/transports'
    | '/_authenticated/_shell/sales/picking/allDeliveryPackages'
    | '/_authenticated/_shell/sales/picking/pickableCustomerOrders'
    | '/_authenticated/_shell/sales/picking/undeliveredPackages'
    | '/_authenticated/_shell/sales/pricing/priceLists'
    | '/_authenticated/_shell/sales/salesCommissions/createPayment'
    | '/_authenticated/_shell/sales/salesCommissions/lineNames'
    | '/_authenticated/_shell/sales/salesCommissions/payments'
    | '/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines'
    | '/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId'
    | '/_authenticated/_shell/spc/cChartEvents/search'
    | '/_authenticated/_shell/spc/controlChartCollections/management'
    | '/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId'
    | '/_authenticated/_shell/spc/defectGroups/$parentGroupId'
    | '/_authenticated/_shell/spc/masterData/yieldCharts'
    | '/_authenticated/_shell/spc/specialCauses/chartGroups'
    | '/_authenticated/_shell/spc/specialCauses/resources'
    | '/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId'
    | '/_authenticated/_shell/surveys/submissions/audit'
    | '/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents'
    | '/_authenticated/_shell/warehouse/inventory/manualEvents'
    | '/_authenticated/_shell/warehouse/inventory/stockCounts'
    | '/_authenticated/_shell/spc/summaryViews/'
    | '/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines'
    | '/_authenticated/_shell/erp/project/delivery/bundling'
    | '/_authenticated/_shell/erp/project/delivery/loading'
    | '/_authenticated/_shell/erp/project/delivery/outboundWarehouse'
    | '/_authenticated/_shell/erp/sales/delivery/bundling'
    | '/_authenticated/_shell/erp/sales/delivery/loading'
    | '/_authenticated/_shell/erp/sales/delivery/outboundWarehouse'
    | '/_authenticated/_shell/erp/sales/invoicing/allInvoices'
    | '/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders'
    | '/_authenticated/_shell/erp/sales/reports/customerOrderBacklog'
    | '/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog'
    | '/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue'
    | '/_authenticated/_shell/erp/warehouse/reports/warehouseValue'
    | '/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
    | '/_authenticated/_shell/spc/controlChartCollections/view/$collectionId'
    | '/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId'
    | '/_authenticated/_shell/spc/processDiagrams/resources/$resourceId'
    | '/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId'
    | '/_authenticated/_shell/spc/summaryViews/grid/$summaryViewId'
    | '/_authenticated/_shell/erp/sales/invoicing/reports/invoices'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  EmailVerifiedRoute: typeof EmailVerifiedRoute
  IndexDothtmlRoute: typeof IndexDothtmlRoute
  InsufficientPermissionsRoute: typeof InsufficientPermissionsRoute
  LoggedOutRoute: typeof LoggedOutRoute
  CustomAppWindowWindowIdRoute: typeof CustomAppWindowWindowIdRoute
  ViewsSplatRoute: typeof ViewsSplatRoute
  ConnectionOauthCallbackRoute: typeof ConnectionOauthCallbackRoute
  WopiActionFileIdRoute: typeof WopiActionFileIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emailVerified': {
      id: '/emailVerified'
      path: '/emailVerified'
      fullPath: '/emailVerified'
      preLoaderRoute: typeof EmailVerifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/index.html': {
      id: '/index.html'
      path: '/index.html'
      fullPath: '/index.html'
      preLoaderRoute: typeof IndexDothtmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insufficientPermissions': {
      id: '/insufficientPermissions'
      path: '/insufficientPermissions'
      fullPath: '/insufficientPermissions'
      preLoaderRoute: typeof InsufficientPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loggedOut': {
      id: '/loggedOut'
      path: '/loggedOut'
      fullPath: '/loggedOut'
      preLoaderRoute: typeof LoggedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell': {
      id: '/_authenticated/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/customAppWindow/$windowId': {
      id: '/customAppWindow/$windowId'
      path: '/customAppWindow/$windowId'
      fullPath: '/customAppWindow/$windowId'
      preLoaderRoute: typeof CustomAppWindowWindowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/views/$': {
      id: '/views/$'
      path: '/views/$'
      fullPath: '/views/$'
      preLoaderRoute: typeof ViewsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell/': {
      id: '/_authenticated/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellIndexRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/bi': {
      id: '/_authenticated/_shell/bi'
      path: '/bi'
      fullPath: '/bi'
      preLoaderRoute: typeof AuthenticatedShellBiRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/devTest': {
      id: '/_authenticated/_shell/devTest'
      path: '/devTest'
      fullPath: '/devTest'
      preLoaderRoute: typeof AuthenticatedShellDevTestRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/connection/oauth/callback': {
      id: '/connection/oauth/callback'
      path: '/connection/oauth/callback'
      fullPath: '/connection/oauth/callback'
      preLoaderRoute: typeof ConnectionOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wopi/$action/$fileId': {
      id: '/wopi/$action/$fileId'
      path: '/wopi/$action/$fileId'
      fullPath: '/wopi/$action/$fileId'
      preLoaderRoute: typeof WopiActionFileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell/ai/costs': {
      id: '/_authenticated/_shell/ai/costs'
      path: '/ai/costs'
      fullPath: '/ai/costs'
      preLoaderRoute: typeof AuthenticatedShellAiCostsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/ai/management': {
      id: '/_authenticated/_shell/ai/management'
      path: '/ai/management'
      fullPath: '/ai/management'
      preLoaderRoute: typeof AuthenticatedShellAiManagementRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/apps/$customAppId': {
      id: '/_authenticated/_shell/apps/$customAppId'
      path: '/apps/$customAppId'
      fullPath: '/apps/$customAppId'
      preLoaderRoute: typeof AuthenticatedShellAppsCustomAppIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/companies': {
      id: '/_authenticated/_shell/common/companies'
      path: '/common/companies'
      fullPath: '/common/companies'
      preLoaderRoute: typeof AuthenticatedShellCommonCompaniesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/currencies': {
      id: '/_authenticated/_shell/common/currencies'
      path: '/common/currencies'
      fullPath: '/common/currencies'
      preLoaderRoute: typeof AuthenticatedShellCommonCurrenciesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/documentTemplates': {
      id: '/_authenticated/_shell/common/documentTemplates'
      path: '/common/documentTemplates'
      fullPath: '/common/documentTemplates'
      preLoaderRoute: typeof AuthenticatedShellCommonDocumentTemplatesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/emailTemplates': {
      id: '/_authenticated/_shell/common/emailTemplates'
      path: '/common/emailTemplates'
      fullPath: '/common/emailTemplates'
      preLoaderRoute: typeof AuthenticatedShellCommonEmailTemplatesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/numberSequences': {
      id: '/_authenticated/_shell/common/numberSequences'
      path: '/common/numberSequences'
      fullPath: '/common/numberSequences'
      preLoaderRoute: typeof AuthenticatedShellCommonNumberSequencesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/objectAttributeFields': {
      id: '/_authenticated/_shell/common/objectAttributeFields'
      path: '/common/objectAttributeFields'
      fullPath: '/common/objectAttributeFields'
      preLoaderRoute: typeof AuthenticatedShellCommonObjectAttributeFieldsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/sites': {
      id: '/_authenticated/_shell/common/sites'
      path: '/common/sites'
      fullPath: '/common/sites'
      preLoaderRoute: typeof AuthenticatedShellCommonSitesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/systemDiagrams': {
      id: '/_authenticated/_shell/common/systemDiagrams'
      path: '/common/systemDiagrams'
      fullPath: '/common/systemDiagrams'
      preLoaderRoute: typeof AuthenticatedShellCommonSystemDiagramsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/configurator/libraries': {
      id: '/_authenticated/_shell/configurator/libraries'
      path: '/configurator/libraries'
      fullPath: '/configurator/libraries'
      preLoaderRoute: typeof AuthenticatedShellConfiguratorLibrariesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/configurator/optionLists': {
      id: '/_authenticated/_shell/configurator/optionLists'
      path: '/configurator/optionLists'
      fullPath: '/configurator/optionLists'
      preLoaderRoute: typeof AuthenticatedShellConfiguratorOptionListsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/configurator/productFamilies': {
      id: '/_authenticated/_shell/configurator/productFamilies'
      path: '/configurator/productFamilies'
      fullPath: '/configurator/productFamilies'
      preLoaderRoute: typeof AuthenticatedShellConfiguratorProductFamiliesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/configurator/productFamilyCategories': {
      id: '/_authenticated/_shell/configurator/productFamilyCategories'
      path: '/configurator/productFamilyCategories'
      fullPath: '/configurator/productFamilyCategories'
      preLoaderRoute: typeof AuthenticatedShellConfiguratorProductFamilyCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/configurator/tables': {
      id: '/_authenticated/_shell/configurator/tables'
      path: '/configurator/tables'
      fullPath: '/configurator/tables'
      preLoaderRoute: typeof AuthenticatedShellConfiguratorTablesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/contacts': {
      id: '/_authenticated/_shell/crm/contacts'
      path: '/crm/contacts'
      fullPath: '/crm/contacts'
      preLoaderRoute: typeof AuthenticatedShellCrmContactsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/customers': {
      id: '/_authenticated/_shell/crm/customers'
      path: '/crm/customers'
      fullPath: '/crm/customers'
      preLoaderRoute: typeof AuthenticatedShellCrmCustomersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/incomingLeads': {
      id: '/_authenticated/_shell/crm/incomingLeads'
      path: '/crm/incomingLeads'
      fullPath: '/crm/incomingLeads'
      preLoaderRoute: typeof AuthenticatedShellCrmIncomingLeadsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesAreas': {
      id: '/_authenticated/_shell/crm/salesAreas'
      path: '/crm/salesAreas'
      fullPath: '/crm/salesAreas'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesAreasRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesLeadActivities': {
      id: '/_authenticated/_shell/crm/salesLeadActivities'
      path: '/crm/salesLeadActivities'
      fullPath: '/crm/salesLeadActivities'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesLeadActivitiesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesLeadActivityCategories': {
      id: '/_authenticated/_shell/crm/salesLeadActivityCategories'
      path: '/crm/salesLeadActivityCategories'
      fullPath: '/crm/salesLeadActivityCategories'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesLeadActivityCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesLeadSources': {
      id: '/_authenticated/_shell/crm/salesLeadSources'
      path: '/crm/salesLeadSources'
      fullPath: '/crm/salesLeadSources'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesLeadSourcesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesLeads': {
      id: '/_authenticated/_shell/crm/salesLeads'
      path: '/crm/salesLeads'
      fullPath: '/crm/salesLeads'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesLeadsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesPipeline': {
      id: '/_authenticated/_shell/crm/salesPipeline'
      path: '/crm/salesPipeline'
      fullPath: '/crm/salesPipeline'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesPipelineRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/crm/salesPipelineBoard': {
      id: '/_authenticated/_shell/crm/salesPipelineBoard'
      path: '/crm/salesPipelineBoard'
      fullPath: '/crm/salesPipelineBoard'
      preLoaderRoute: typeof AuthenticatedShellCrmSalesPipelineBoardRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/customizations/api-connections': {
      id: '/_authenticated/_shell/customizations/api-connections'
      path: '/customizations/api-connections'
      fullPath: '/customizations/api-connections'
      preLoaderRoute: typeof AuthenticatedShellCustomizationsApiConnectionsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/customizations/api-keys': {
      id: '/_authenticated/_shell/customizations/api-keys'
      path: '/customizations/api-keys'
      fullPath: '/customizations/api-keys'
      preLoaderRoute: typeof AuthenticatedShellCustomizationsApiKeysRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/customizations/custom-apps': {
      id: '/_authenticated/_shell/customizations/custom-apps'
      path: '/customizations/custom-apps'
      fullPath: '/customizations/custom-apps'
      preLoaderRoute: typeof AuthenticatedShellCustomizationsCustomAppsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/customizations/custom-functions': {
      id: '/_authenticated/_shell/customizations/custom-functions'
      path: '/customizations/custom-functions'
      fullPath: '/customizations/custom-functions'
      preLoaderRoute: typeof AuthenticatedShellCustomizationsCustomFunctionsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/customizations/sent-emails': {
      id: '/_authenticated/_shell/customizations/sent-emails'
      path: '/customizations/sent-emails'
      fullPath: '/customizations/sent-emails'
      preLoaderRoute: typeof AuthenticatedShellCustomizationsSentEmailsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/documents/documentCategories': {
      id: '/_authenticated/_shell/documents/documentCategories'
      path: '/documents/documentCategories'
      fullPath: '/documents/documentCategories'
      preLoaderRoute: typeof AuthenticatedShellDocumentsDocumentCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/documents/search': {
      id: '/_authenticated/_shell/documents/search'
      path: '/documents/search'
      fullPath: '/documents/search'
      preLoaderRoute: typeof AuthenticatedShellDocumentsSearchRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/lisToLsb': {
      id: '/_authenticated/_shell/mellano/lisToLsb'
      path: '/mellano/lisToLsb'
      fullPath: '/mellano/lisToLsb'
      preLoaderRoute: typeof AuthenticatedShellMellanoLisToLsbRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/paintingControlCharts': {
      id: '/_authenticated/_shell/mellano/paintingControlCharts'
      path: '/mellano/paintingControlCharts'
      fullPath: '/mellano/paintingControlCharts'
      preLoaderRoute: typeof AuthenticatedShellMellanoPaintingControlChartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productDesign/bomLineGroups': {
      id: '/_authenticated/_shell/productDesign/bomLineGroups'
      path: '/productDesign/bomLineGroups'
      fullPath: '/productDesign/bomLineGroups'
      preLoaderRoute: typeof AuthenticatedShellProductDesignBomLineGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/catalogParts': {
      id: '/_authenticated/_shell/productManagement/catalogParts'
      path: '/productManagement/catalogParts'
      fullPath: '/productManagement/catalogParts'
      preLoaderRoute: typeof AuthenticatedShellProductManagementCatalogPartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/partCategories': {
      id: '/_authenticated/_shell/productManagement/partCategories'
      path: '/productManagement/partCategories'
      fullPath: '/productManagement/partCategories'
      preLoaderRoute: typeof AuthenticatedShellProductManagementPartCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/productChangeCategories': {
      id: '/_authenticated/_shell/productManagement/productChangeCategories'
      path: '/productManagement/productChangeCategories'
      fullPath: '/productManagement/productChangeCategories'
      preLoaderRoute: typeof AuthenticatedShellProductManagementProductChangeCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/productChangePackages': {
      id: '/_authenticated/_shell/productManagement/productChangePackages'
      path: '/productManagement/productChangePackages'
      fullPath: '/productManagement/productChangePackages'
      preLoaderRoute: typeof AuthenticatedShellProductManagementProductChangePackagesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/productChangeRequests': {
      id: '/_authenticated/_shell/productManagement/productChangeRequests'
      path: '/productManagement/productChangeRequests'
      fullPath: '/productManagement/productChangeRequests'
      preLoaderRoute: typeof AuthenticatedShellProductManagementProductChangeRequestsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/productChanges': {
      id: '/_authenticated/_shell/productManagement/productChanges'
      path: '/productManagement/productChanges'
      fullPath: '/productManagement/productChanges'
      preLoaderRoute: typeof AuthenticatedShellProductManagementProductChangesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/searchPartsByAttributes': {
      id: '/_authenticated/_shell/productManagement/searchPartsByAttributes'
      path: '/productManagement/searchPartsByAttributes'
      fullPath: '/productManagement/searchPartsByAttributes'
      preLoaderRoute: typeof AuthenticatedShellProductManagementSearchPartsByAttributesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/productManagement/units': {
      id: '/_authenticated/_shell/productManagement/units'
      path: '/productManagement/units'
      fullPath: '/productManagement/units'
      preLoaderRoute: typeof AuthenticatedShellProductManagementUnitsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/onProductionLine': {
      id: '/_authenticated/_shell/production/onProductionLine'
      path: '/production/onProductionLine'
      fullPath: '/production/onProductionLine'
      preLoaderRoute: typeof AuthenticatedShellProductionOnProductionLineRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/operations': {
      id: '/_authenticated/_shell/production/operations'
      path: '/production/operations'
      fullPath: '/production/operations'
      preLoaderRoute: typeof AuthenticatedShellProductionOperationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/productionLineGroupJobQueue': {
      id: '/_authenticated/_shell/production/productionLineGroupJobQueue'
      path: '/production/productionLineGroupJobQueue'
      fullPath: '/production/productionLineGroupJobQueue'
      preLoaderRoute: typeof AuthenticatedShellProductionProductionLineGroupJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/productionLineJobQueue': {
      id: '/_authenticated/_shell/production/productionLineJobQueue'
      path: '/production/productionLineJobQueue'
      fullPath: '/production/productionLineJobQueue'
      preLoaderRoute: typeof AuthenticatedShellProductionProductionLineJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/productionLines': {
      id: '/_authenticated/_shell/production/productionLines'
      path: '/production/productionLines'
      fullPath: '/production/productionLines'
      preLoaderRoute: typeof AuthenticatedShellProductionProductionLinesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/shopOrderBatchJobQueue': {
      id: '/_authenticated/_shell/production/shopOrderBatchJobQueue'
      path: '/production/shopOrderBatchJobQueue'
      fullPath: '/production/shopOrderBatchJobQueue'
      preLoaderRoute: typeof AuthenticatedShellProductionShopOrderBatchJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/shopOrderBatches': {
      id: '/_authenticated/_shell/production/shopOrderBatches'
      path: '/production/shopOrderBatches'
      fullPath: '/production/shopOrderBatches'
      preLoaderRoute: typeof AuthenticatedShellProductionShopOrderBatchesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/shopOrderPackaging': {
      id: '/_authenticated/_shell/production/shopOrderPackaging'
      path: '/production/shopOrderPackaging'
      fullPath: '/production/shopOrderPackaging'
      preLoaderRoute: typeof AuthenticatedShellProductionShopOrderPackagingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/shopOrders': {
      id: '/_authenticated/_shell/production/shopOrders'
      path: '/production/shopOrders'
      fullPath: '/production/shopOrders'
      preLoaderRoute: typeof AuthenticatedShellProductionShopOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/subcontractingJobQueue': {
      id: '/_authenticated/_shell/production/subcontractingJobQueue'
      path: '/production/subcontractingJobQueue'
      fullPath: '/production/subcontractingJobQueue'
      preLoaderRoute: typeof AuthenticatedShellProductionSubcontractingJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/supplementShopOrder': {
      id: '/_authenticated/_shell/production/supplementShopOrder'
      path: '/production/supplementShopOrder'
      fullPath: '/production/supplementShopOrder'
      preLoaderRoute: typeof AuthenticatedShellProductionSupplementShopOrderRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/workCenterIncompleteOperations': {
      id: '/_authenticated/_shell/production/workCenterIncompleteOperations'
      path: '/production/workCenterIncompleteOperations'
      fullPath: '/production/workCenterIncompleteOperations'
      preLoaderRoute: typeof AuthenticatedShellProductionWorkCenterIncompleteOperationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/workCenterJobQueue': {
      id: '/_authenticated/_shell/production/workCenterJobQueue'
      path: '/production/workCenterJobQueue'
      fullPath: '/production/workCenterJobQueue'
      preLoaderRoute: typeof AuthenticatedShellProductionWorkCenterJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/workCenters': {
      id: '/_authenticated/_shell/production/workCenters'
      path: '/production/workCenters'
      fullPath: '/production/workCenters'
      preLoaderRoute: typeof AuthenticatedShellProductionWorkCentersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/activityResources': {
      id: '/_authenticated/_shell/project/activityResources'
      path: '/project/activityResources'
      fullPath: '/project/activityResources'
      preLoaderRoute: typeof AuthenticatedShellProjectActivityResourcesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/activityTypes': {
      id: '/_authenticated/_shell/project/activityTypes'
      path: '/project/activityTypes'
      fullPath: '/project/activityTypes'
      preLoaderRoute: typeof AuthenticatedShellProjectActivityTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/costEvents': {
      id: '/_authenticated/_shell/project/costEvents'
      path: '/project/costEvents'
      fullPath: '/project/costEvents'
      preLoaderRoute: typeof AuthenticatedShellProjectCostEventsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/jobQueue': {
      id: '/_authenticated/_shell/project/jobQueue'
      path: '/project/jobQueue'
      fullPath: '/project/jobQueue'
      preLoaderRoute: typeof AuthenticatedShellProjectJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/projectTypes': {
      id: '/_authenticated/_shell/project/projectTypes'
      path: '/project/projectTypes'
      fullPath: '/project/projectTypes'
      preLoaderRoute: typeof AuthenticatedShellProjectProjectTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/projects': {
      id: '/_authenticated/_shell/project/projects'
      path: '/project/projects'
      fullPath: '/project/projects'
      preLoaderRoute: typeof AuthenticatedShellProjectProjectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/resourcesGantt': {
      id: '/_authenticated/_shell/project/resourcesGantt'
      path: '/project/resourcesGantt'
      fullPath: '/project/resourcesGantt'
      preLoaderRoute: typeof AuthenticatedShellProjectResourcesGanttRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/scheduling': {
      id: '/_authenticated/_shell/project/scheduling'
      path: '/project/scheduling'
      fullPath: '/project/scheduling'
      preLoaderRoute: typeof AuthenticatedShellProjectSchedulingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/subProjectTypes': {
      id: '/_authenticated/_shell/project/subProjectTypes'
      path: '/project/subProjectTypes'
      fullPath: '/project/subProjectTypes'
      preLoaderRoute: typeof AuthenticatedShellProjectSubProjectTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/tree': {
      id: '/_authenticated/_shell/project/tree'
      path: '/project/tree'
      fullPath: '/project/tree'
      preLoaderRoute: typeof AuthenticatedShellProjectTreeRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/allPurchaseOrderLines': {
      id: '/_authenticated/_shell/purchase/allPurchaseOrderLines'
      path: '/purchase/allPurchaseOrderLines'
      fullPath: '/purchase/allPurchaseOrderLines'
      preLoaderRoute: typeof AuthenticatedShellPurchaseAllPurchaseOrderLinesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/deliveryNotices': {
      id: '/_authenticated/_shell/purchase/deliveryNotices'
      path: '/purchase/deliveryNotices'
      fullPath: '/purchase/deliveryNotices'
      preLoaderRoute: typeof AuthenticatedShellPurchaseDeliveryNoticesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/processView': {
      id: '/_authenticated/_shell/purchase/processView'
      path: '/purchase/processView'
      fullPath: '/purchase/processView'
      preLoaderRoute: typeof AuthenticatedShellPurchaseProcessViewRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/purchaseOrderConfirmations': {
      id: '/_authenticated/_shell/purchase/purchaseOrderConfirmations'
      path: '/purchase/purchaseOrderConfirmations'
      fullPath: '/purchase/purchaseOrderConfirmations'
      preLoaderRoute: typeof AuthenticatedShellPurchasePurchaseOrderConfirmationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/purchaseOrders': {
      id: '/_authenticated/_shell/purchase/purchaseOrders'
      path: '/purchase/purchaseOrders'
      fullPath: '/purchase/purchaseOrders'
      preLoaderRoute: typeof AuthenticatedShellPurchasePurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/purchaseOrdersToReceive': {
      id: '/_authenticated/_shell/purchase/purchaseOrdersToReceive'
      path: '/purchase/purchaseOrdersToReceive'
      fullPath: '/purchase/purchaseOrdersToReceive'
      preLoaderRoute: typeof AuthenticatedShellPurchasePurchaseOrdersToReceiveRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/purchase/purchaseRequests': {
      id: '/_authenticated/_shell/purchase/purchaseRequests'
      path: '/purchase/purchaseRequests'
      fullPath: '/purchase/purchaseRequests'
      preLoaderRoute: typeof AuthenticatedShellPurchasePurchaseRequestsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/accounting': {
      id: '/_authenticated/_shell/sales/accounting'
      path: '/sales/accounting'
      fullPath: '/sales/accounting'
      preLoaderRoute: typeof AuthenticatedShellSalesAccountingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/allCustomerOrderLines': {
      id: '/_authenticated/_shell/sales/allCustomerOrderLines'
      path: '/sales/allCustomerOrderLines'
      fullPath: '/sales/allCustomerOrderLines'
      preLoaderRoute: typeof AuthenticatedShellSalesAllCustomerOrderLinesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/billingPlanLinesToApprove': {
      id: '/_authenticated/_shell/sales/billingPlanLinesToApprove'
      path: '/sales/billingPlanLinesToApprove'
      fullPath: '/sales/billingPlanLinesToApprove'
      preLoaderRoute: typeof AuthenticatedShellSalesBillingPlanLinesToApproveRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/billingPlanModels': {
      id: '/_authenticated/_shell/sales/billingPlanModels'
      path: '/sales/billingPlanModels'
      fullPath: '/sales/billingPlanModels'
      preLoaderRoute: typeof AuthenticatedShellSalesBillingPlanModelsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/billingPlanParts': {
      id: '/_authenticated/_shell/sales/billingPlanParts'
      path: '/sales/billingPlanParts'
      fullPath: '/sales/billingPlanParts'
      preLoaderRoute: typeof AuthenticatedShellSalesBillingPlanPartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/contractualTerms': {
      id: '/_authenticated/_shell/sales/contractualTerms'
      path: '/sales/contractualTerms'
      fullPath: '/sales/contractualTerms'
      preLoaderRoute: typeof AuthenticatedShellSalesContractualTermsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerGroups': {
      id: '/_authenticated/_shell/sales/customerGroups'
      path: '/sales/customerGroups'
      fullPath: '/sales/customerGroups'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerOfferTypes': {
      id: '/_authenticated/_shell/sales/customerOfferTypes'
      path: '/sales/customerOfferTypes'
      fullPath: '/sales/customerOfferTypes'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerOfferTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerOrderSalesConditions': {
      id: '/_authenticated/_shell/sales/customerOrderSalesConditions'
      path: '/sales/customerOrderSalesConditions'
      fullPath: '/sales/customerOrderSalesConditions'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerOrderSalesConditionsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerOrderTypes': {
      id: '/_authenticated/_shell/sales/customerOrderTypes'
      path: '/sales/customerOrderTypes'
      fullPath: '/sales/customerOrderTypes'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerOrderTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerOrders': {
      id: '/_authenticated/_shell/sales/customerOrders'
      path: '/sales/customerOrders'
      fullPath: '/sales/customerOrders'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customerPriceGroups': {
      id: '/_authenticated/_shell/sales/customerPriceGroups'
      path: '/sales/customerPriceGroups'
      fullPath: '/sales/customerPriceGroups'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomerPriceGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/customers': {
      id: '/_authenticated/_shell/sales/customers'
      path: '/sales/customers'
      fullPath: '/sales/customers'
      preLoaderRoute: typeof AuthenticatedShellSalesCustomersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/eInvoiceOperators': {
      id: '/_authenticated/_shell/sales/eInvoiceOperators'
      path: '/sales/eInvoiceOperators'
      fullPath: '/sales/eInvoiceOperators'
      preLoaderRoute: typeof AuthenticatedShellSalesEInvoiceOperatorsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/offers': {
      id: '/_authenticated/_shell/sales/offers'
      path: '/sales/offers'
      fullPath: '/sales/offers'
      preLoaderRoute: typeof AuthenticatedShellSalesOffersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/orderDeliveryProcessView': {
      id: '/_authenticated/_shell/sales/orderDeliveryProcessView'
      path: '/sales/orderDeliveryProcessView'
      fullPath: '/sales/orderDeliveryProcessView'
      preLoaderRoute: typeof AuthenticatedShellSalesOrderDeliveryProcessViewRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/paymentTerm': {
      id: '/_authenticated/_shell/sales/paymentTerm'
      path: '/sales/paymentTerm'
      fullPath: '/sales/paymentTerm'
      preLoaderRoute: typeof AuthenticatedShellSalesPaymentTermRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/receivedCustomerOrders': {
      id: '/_authenticated/_shell/sales/receivedCustomerOrders'
      path: '/sales/receivedCustomerOrders'
      fullPath: '/sales/receivedCustomerOrders'
      preLoaderRoute: typeof AuthenticatedShellSalesReceivedCustomerOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesConditions': {
      id: '/_authenticated/_shell/sales/salesConditions'
      path: '/sales/salesConditions'
      fullPath: '/sales/salesConditions'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesConditionsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesPartCategories': {
      id: '/_authenticated/_shell/sales/salesPartCategories'
      path: '/sales/salesPartCategories'
      fullPath: '/sales/salesPartCategories'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesPartCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesPartPriceGroups': {
      id: '/_authenticated/_shell/sales/salesPartPriceGroups'
      path: '/sales/salesPartPriceGroups'
      fullPath: '/sales/salesPartPriceGroups'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesPartPriceGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesParts': {
      id: '/_authenticated/_shell/sales/salesParts'
      path: '/sales/salesParts'
      fullPath: '/sales/salesParts'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesPartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salespersons': {
      id: '/_authenticated/_shell/sales/salespersons'
      path: '/sales/salespersons'
      fullPath: '/sales/salespersons'
      preLoaderRoute: typeof AuthenticatedShellSalesSalespersonsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/transportRoutes': {
      id: '/_authenticated/_shell/sales/transportRoutes'
      path: '/sales/transportRoutes'
      fullPath: '/sales/transportRoutes'
      preLoaderRoute: typeof AuthenticatedShellSalesTransportRoutesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/vatCodes': {
      id: '/_authenticated/_shell/sales/vatCodes'
      path: '/sales/vatCodes'
      fullPath: '/sales/vatCodes'
      preLoaderRoute: typeof AuthenticatedShellSalesVatCodesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/vatHandlingTypes': {
      id: '/_authenticated/_shell/sales/vatHandlingTypes'
      path: '/sales/vatHandlingTypes'
      fullPath: '/sales/vatHandlingTypes'
      preLoaderRoute: typeof AuthenticatedShellSalesVatHandlingTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/salvos/salesCommissionLimits': {
      id: '/_authenticated/_shell/salvos/salesCommissionLimits'
      path: '/salvos/salesCommissionLimits'
      fullPath: '/salvos/salesCommissionLimits'
      preLoaderRoute: typeof AuthenticatedShellSalvosSalesCommissionLimitsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/calendars': {
      id: '/_authenticated/_shell/spc/calendars'
      path: '/spc/calendars'
      fullPath: '/spc/calendars'
      preLoaderRoute: typeof AuthenticatedShellSpcCalendarsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/controlCharts': {
      id: '/_authenticated/_shell/spc/controlCharts'
      path: '/spc/controlCharts'
      fullPath: '/spc/controlCharts'
      preLoaderRoute: typeof AuthenticatedShellSpcControlChartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/cycleTimeMeasurement': {
      id: '/_authenticated/_shell/spc/cycleTimeMeasurement'
      path: '/spc/cycleTimeMeasurement'
      fullPath: '/spc/cycleTimeMeasurement'
      preLoaderRoute: typeof AuthenticatedShellSpcCycleTimeMeasurementRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/dimensionSearch': {
      id: '/_authenticated/_shell/spc/dimensionSearch'
      path: '/spc/dimensionSearch'
      fullPath: '/spc/dimensionSearch'
      preLoaderRoute: typeof AuthenticatedShellSpcDimensionSearchRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/importData': {
      id: '/_authenticated/_shell/spc/importData'
      path: '/spc/importData'
      fullPath: '/spc/importData'
      preLoaderRoute: typeof AuthenticatedShellSpcImportDataRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/processImprovementCategories': {
      id: '/_authenticated/_shell/spc/processImprovementCategories'
      path: '/spc/processImprovementCategories'
      fullPath: '/spc/processImprovementCategories'
      preLoaderRoute: typeof AuthenticatedShellSpcProcessImprovementCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/processImprovements': {
      id: '/_authenticated/_shell/spc/processImprovements'
      path: '/spc/processImprovements'
      fullPath: '/spc/processImprovements'
      preLoaderRoute: typeof AuthenticatedShellSpcProcessImprovementsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/resources': {
      id: '/_authenticated/_shell/spc/resources'
      path: '/spc/resources'
      fullPath: '/spc/resources'
      preLoaderRoute: typeof AuthenticatedShellSpcResourcesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/timeMeasurement': {
      id: '/_authenticated/_shell/spc/timeMeasurement'
      path: '/spc/timeMeasurement'
      fullPath: '/spc/timeMeasurement'
      preLoaderRoute: typeof AuthenticatedShellSpcTimeMeasurementRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/yieldCharts': {
      id: '/_authenticated/_shell/spc/yieldCharts'
      path: '/spc/yieldCharts'
      fullPath: '/spc/yieldCharts'
      preLoaderRoute: typeof AuthenticatedShellSpcYieldChartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/surveys/surveyCategories': {
      id: '/_authenticated/_shell/surveys/surveyCategories'
      path: '/surveys/surveyCategories'
      fullPath: '/surveys/surveyCategories'
      preLoaderRoute: typeof AuthenticatedShellSurveysSurveyCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/surveys/surveyForms': {
      id: '/_authenticated/_shell/surveys/surveyForms'
      path: '/surveys/surveyForms'
      fullPath: '/surveys/surveyForms'
      preLoaderRoute: typeof AuthenticatedShellSurveysSurveyFormsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/tasks/allTasks': {
      id: '/_authenticated/_shell/tasks/allTasks'
      path: '/tasks/allTasks'
      fullPath: '/tasks/allTasks'
      preLoaderRoute: typeof AuthenticatedShellTasksAllTasksRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/tasks/my': {
      id: '/_authenticated/_shell/tasks/my'
      path: '/tasks/my'
      fullPath: '/tasks/my'
      preLoaderRoute: typeof AuthenticatedShellTasksMyRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/tasks/onMyResponsibility': {
      id: '/_authenticated/_shell/tasks/onMyResponsibility'
      path: '/tasks/onMyResponsibility'
      fullPath: '/tasks/onMyResponsibility'
      preLoaderRoute: typeof AuthenticatedShellTasksOnMyResponsibilityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/tasks/taskTemplates': {
      id: '/_authenticated/_shell/tasks/taskTemplates'
      path: '/tasks/taskTemplates'
      fullPath: '/tasks/taskTemplates'
      preLoaderRoute: typeof AuthenticatedShellTasksTaskTemplatesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/users/management': {
      id: '/_authenticated/_shell/users/management'
      path: '/users/management'
      fullPath: '/users/management'
      preLoaderRoute: typeof AuthenticatedShellUsersManagementRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/users/roles': {
      id: '/_authenticated/_shell/users/roles'
      path: '/users/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof AuthenticatedShellUsersRolesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/dataCollection': {
      id: '/_authenticated/_shell/warehouse/dataCollection'
      path: '/warehouse/dataCollection'
      fullPath: '/warehouse/dataCollection'
      preLoaderRoute: typeof AuthenticatedShellWarehouseDataCollectionRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/deliveryPackageTypes': {
      id: '/_authenticated/_shell/warehouse/deliveryPackageTypes'
      path: '/warehouse/deliveryPackageTypes'
      fullPath: '/warehouse/deliveryPackageTypes'
      preLoaderRoute: typeof AuthenticatedShellWarehouseDeliveryPackageTypesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/inventoryLevelProfile': {
      id: '/_authenticated/_shell/warehouse/inventoryLevelProfile'
      path: '/warehouse/inventoryLevelProfile'
      fullPath: '/warehouse/inventoryLevelProfile'
      preLoaderRoute: typeof AuthenticatedShellWarehouseInventoryLevelProfileRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/partCostCalculation': {
      id: '/_authenticated/_shell/warehouse/partCostCalculation'
      path: '/warehouse/partCostCalculation'
      fullPath: '/warehouse/partCostCalculation'
      preLoaderRoute: typeof AuthenticatedShellWarehousePartCostCalculationRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/partImportCodes': {
      id: '/_authenticated/_shell/warehouse/partImportCodes'
      path: '/warehouse/partImportCodes'
      fullPath: '/warehouse/partImportCodes'
      preLoaderRoute: typeof AuthenticatedShellWarehousePartImportCodesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/parts': {
      id: '/_authenticated/_shell/warehouse/parts'
      path: '/warehouse/parts'
      fullPath: '/warehouse/parts'
      preLoaderRoute: typeof AuthenticatedShellWarehousePartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/transferJobQueue': {
      id: '/_authenticated/_shell/warehouse/transferJobQueue'
      path: '/warehouse/transferJobQueue'
      fullPath: '/warehouse/transferJobQueue'
      preLoaderRoute: typeof AuthenticatedShellWarehouseTransferJobQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/unverifiedParts': {
      id: '/_authenticated/_shell/warehouse/unverifiedParts'
      path: '/warehouse/unverifiedParts'
      fullPath: '/warehouse/unverifiedParts'
      preLoaderRoute: typeof AuthenticatedShellWarehouseUnverifiedPartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/warehouseLocationParts': {
      id: '/_authenticated/_shell/warehouse/warehouseLocationParts'
      path: '/warehouse/warehouseLocationParts'
      fullPath: '/warehouse/warehouseLocationParts'
      preLoaderRoute: typeof AuthenticatedShellWarehouseWarehouseLocationPartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/warehouseLocations': {
      id: '/_authenticated/_shell/warehouse/warehouseLocations'
      path: '/warehouse/warehouseLocations'
      fullPath: '/warehouse/warehouseLocations'
      preLoaderRoute: typeof AuthenticatedShellWarehouseWarehouseLocationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/warehouseTransfers': {
      id: '/_authenticated/_shell/warehouse/warehouseTransfers'
      path: '/warehouse/warehouseTransfers'
      fullPath: '/warehouse/warehouseTransfers'
      preLoaderRoute: typeof AuthenticatedShellWarehouseWarehouseTransfersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/workspace/categories': {
      id: '/_authenticated/_shell/workspace/categories'
      path: '/workspace/categories'
      fullPath: '/workspace/categories'
      preLoaderRoute: typeof AuthenticatedShellWorkspaceCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/workspace/workspaces': {
      id: '/_authenticated/_shell/workspace/workspaces'
      path: '/workspace/workspaces'
      fullPath: '/workspace/workspaces'
      preLoaderRoute: typeof AuthenticatedShellWorkspaceWorkspacesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/accounting/accounts': {
      id: '/_authenticated/_shell/common/accounting/accounts'
      path: '/common/accounting/accounts'
      fullPath: '/common/accounting/accounts'
      preLoaderRoute: typeof AuthenticatedShellCommonAccountingAccountsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/common/accounting/dimensions': {
      id: '/_authenticated/_shell/common/accounting/dimensions'
      path: '/common/accounting/dimensions'
      fullPath: '/common/accounting/dimensions'
      preLoaderRoute: typeof AuthenticatedShellCommonAccountingDimensionsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/common/addCostEvent': {
      id: '/_authenticated/_shell/erp/common/addCostEvent'
      path: '/erp/common/addCostEvent'
      fullPath: '/erp/common/addCostEvent'
      preLoaderRoute: typeof AuthenticatedShellErpCommonAddCostEventRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/common/costEventObjectTypeSettings': {
      id: '/_authenticated/_shell/erp/common/costEventObjectTypeSettings'
      path: '/erp/common/costEventObjectTypeSettings'
      fullPath: '/erp/common/costEventObjectTypeSettings'
      preLoaderRoute: typeof AuthenticatedShellErpCommonCostEventObjectTypeSettingsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/common/costEventPriceLists': {
      id: '/_authenticated/_shell/erp/common/costEventPriceLists'
      path: '/erp/common/costEventPriceLists'
      fullPath: '/erp/common/costEventPriceLists'
      preLoaderRoute: typeof AuthenticatedShellErpCommonCostEventPriceListsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/common/costEvents': {
      id: '/_authenticated/_shell/erp/common/costEvents'
      path: '/erp/common/costEvents'
      fullPath: '/erp/common/costEvents'
      preLoaderRoute: typeof AuthenticatedShellErpCommonCostEventsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/configurator/logSearch': {
      id: '/_authenticated/_shell/erp/configurator/logSearch'
      path: '/erp/configurator/logSearch'
      fullPath: '/erp/configurator/logSearch'
      preLoaderRoute: typeof AuthenticatedShellErpConfiguratorLogSearchRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/delivery/transportEquipment': {
      id: '/_authenticated/_shell/erp/delivery/transportEquipment'
      path: '/erp/delivery/transportEquipment'
      fullPath: '/erp/delivery/transportEquipment'
      preLoaderRoute: typeof AuthenticatedShellErpDeliveryTransportEquipmentRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/inventory/forecast': {
      id: '/_authenticated/_shell/erp/inventory/forecast'
      path: '/erp/inventory/forecast'
      fullPath: '/erp/inventory/forecast'
      preLoaderRoute: typeof AuthenticatedShellErpInventoryForecastRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/production/capacity': {
      id: '/_authenticated/_shell/erp/production/capacity'
      path: '/erp/production/capacity'
      fullPath: '/erp/production/capacity'
      preLoaderRoute: typeof AuthenticatedShellErpProductionCapacityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/production/completedQuantity': {
      id: '/_authenticated/_shell/erp/production/completedQuantity'
      path: '/erp/production/completedQuantity'
      fullPath: '/erp/production/completedQuantity'
      preLoaderRoute: typeof AuthenticatedShellErpProductionCompletedQuantityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/production/loadChart': {
      id: '/_authenticated/_shell/erp/production/loadChart'
      path: '/erp/production/loadChart'
      fullPath: '/erp/production/loadChart'
      preLoaderRoute: typeof AuthenticatedShellErpProductionLoadChartRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/production/productionPlanning': {
      id: '/_authenticated/_shell/erp/production/productionPlanning'
      path: '/erp/production/productionPlanning'
      fullPath: '/erp/production/productionPlanning'
      preLoaderRoute: typeof AuthenticatedShellErpProductionProductionPlanningRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/production/salesProductionBacklog': {
      id: '/_authenticated/_shell/erp/production/salesProductionBacklog'
      path: '/erp/production/salesProductionBacklog'
      fullPath: '/erp/production/salesProductionBacklog'
      preLoaderRoute: typeof AuthenticatedShellErpProductionSalesProductionBacklogRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/purchase/supplierGroups': {
      id: '/_authenticated/_shell/erp/purchase/supplierGroups'
      path: '/erp/purchase/supplierGroups'
      fullPath: '/erp/purchase/supplierGroups'
      preLoaderRoute: typeof AuthenticatedShellErpPurchaseSupplierGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/purchase/suppliers': {
      id: '/_authenticated/_shell/erp/purchase/suppliers'
      path: '/erp/purchase/suppliers'
      fullPath: '/erp/purchase/suppliers'
      preLoaderRoute: typeof AuthenticatedShellErpPurchaseSuppliersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/reclamationCategory': {
      id: '/_authenticated/_shell/erp/reclamations/reclamationCategory'
      path: '/erp/reclamations/reclamationCategory'
      fullPath: '/erp/reclamations/reclamationCategory'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsReclamationCategoryRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/reclamationCause': {
      id: '/_authenticated/_shell/erp/reclamations/reclamationCause'
      path: '/erp/reclamations/reclamationCause'
      fullPath: '/erp/reclamations/reclamationCause'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsReclamationCauseRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod': {
      id: '/_authenticated/_shell/erp/reclamations/reclamationHandlingMethod'
      path: '/erp/reclamations/reclamationHandlingMethod'
      fullPath: '/erp/reclamations/reclamationHandlingMethod'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsReclamationHandlingMethodRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/reclamationLocation': {
      id: '/_authenticated/_shell/erp/reclamations/reclamationLocation'
      path: '/erp/reclamations/reclamationLocation'
      fullPath: '/erp/reclamations/reclamationLocation'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsReclamationLocationRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/reclamations': {
      id: '/_authenticated/_shell/erp/reclamations/reclamations'
      path: '/erp/reclamations/reclamations'
      fullPath: '/erp/reclamations/reclamations'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsReclamationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/rounds': {
      id: '/_authenticated/_shell/erp/reclamations/rounds'
      path: '/erp/reclamations/rounds'
      fullPath: '/erp/reclamations/rounds'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsRoundsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/weekPlanning': {
      id: '/_authenticated/_shell/erp/reclamations/weekPlanning'
      path: '/erp/reclamations/weekPlanning'
      fullPath: '/erp/reclamations/weekPlanning'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsWeekPlanningRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/reclamations/workQueue': {
      id: '/_authenticated/_shell/erp/reclamations/workQueue'
      path: '/erp/reclamations/workQueue'
      fullPath: '/erp/reclamations/workQueue'
      preLoaderRoute: typeof AuthenticatedShellErpReclamationsWorkQueueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/safetyControlSurvey/noteCategories': {
      id: '/_authenticated/_shell/erp/safetyControlSurvey/noteCategories'
      path: '/erp/safetyControlSurvey/noteCategories'
      fullPath: '/erp/safetyControlSurvey/noteCategories'
      preLoaderRoute: typeof AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/safetyControlSurvey/summary': {
      id: '/_authenticated/_shell/erp/safetyControlSurvey/summary'
      path: '/erp/safetyControlSurvey/summary'
      fullPath: '/erp/safetyControlSurvey/summary'
      preLoaderRoute: typeof AuthenticatedShellErpSafetyControlSurveySummaryRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/safetyControlSurvey/surveys': {
      id: '/_authenticated/_shell/erp/safetyControlSurvey/surveys'
      path: '/erp/safetyControlSurvey/surveys'
      fullPath: '/erp/safetyControlSurvey/surveys'
      preLoaderRoute: typeof AuthenticatedShellErpSafetyControlSurveySurveysRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/safetyControlSurvey/teams': {
      id: '/_authenticated/_shell/erp/safetyControlSurvey/teams'
      path: '/erp/safetyControlSurvey/teams'
      fullPath: '/erp/safetyControlSurvey/teams'
      preLoaderRoute: typeof AuthenticatedShellErpSafetyControlSurveyTeamsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/customerOrderImport': {
      id: '/_authenticated/_shell/erp/sales/customerOrderImport'
      path: '/erp/sales/customerOrderImport'
      fullPath: '/erp/sales/customerOrderImport'
      preLoaderRoute: typeof AuthenticatedShellErpSalesCustomerOrderImportRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/vertexInd/config': {
      id: '/_authenticated/_shell/erp/vertexInd/config'
      path: '/erp/vertexInd/config'
      fullPath: '/erp/vertexInd/config'
      preLoaderRoute: typeof AuthenticatedShellErpVertexIndConfigRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/cargoDrivers': {
      id: '/_authenticated/_shell/erp/warehouse/cargoDrivers'
      path: '/erp/warehouse/cargoDrivers'
      fullPath: '/erp/warehouse/cargoDrivers'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseCargoDriversRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/deliveryMethods': {
      id: '/_authenticated/_shell/erp/warehouse/deliveryMethods'
      path: '/erp/warehouse/deliveryMethods'
      fullPath: '/erp/warehouse/deliveryMethods'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseDeliveryMethodsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/deliveryTerms': {
      id: '/_authenticated/_shell/erp/warehouse/deliveryTerms'
      path: '/erp/warehouse/deliveryTerms'
      fullPath: '/erp/warehouse/deliveryTerms'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseDeliveryTermsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/warehousePickerGroups': {
      id: '/_authenticated/_shell/erp/warehouse/warehousePickerGroups'
      path: '/erp/warehouse/warehousePickerGroups'
      fullPath: '/erp/warehouse/warehousePickerGroups'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseWarehousePickerGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups': {
      id: '/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups'
      path: '/erp/warehouse/warehouseReplenishmentGroups'
      fullPath: '/erp/warehouse/warehouseReplenishmentGroups'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/capacity': {
      id: '/_authenticated/_shell/mellano/luukku/capacity'
      path: '/mellano/luukku/capacity'
      fullPath: '/mellano/luukku/capacity'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuCapacityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/dataCollection': {
      id: '/_authenticated/_shell/mellano/luukku/dataCollection'
      path: '/mellano/luukku/dataCollection'
      fullPath: '/mellano/luukku/dataCollection'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuDataCollectionRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/dispatchSlotting': {
      id: '/_authenticated/_shell/mellano/luukku/dispatchSlotting'
      path: '/mellano/luukku/dispatchSlotting'
      fullPath: '/mellano/luukku/dispatchSlotting'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuDispatchSlottingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/drillStamps': {
      id: '/_authenticated/_shell/mellano/luukku/drillStamps'
      path: '/mellano/luukku/drillStamps'
      fullPath: '/mellano/luukku/drillStamps'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuDrillStampsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/handPaintingPlan': {
      id: '/_authenticated/_shell/mellano/luukku/handPaintingPlan'
      path: '/mellano/luukku/handPaintingPlan'
      fullPath: '/mellano/luukku/handPaintingPlan'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuHandPaintingPlanRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/ketMetrics': {
      id: '/_authenticated/_shell/mellano/luukku/ketMetrics'
      path: '/mellano/luukku/ketMetrics'
      fullPath: '/mellano/luukku/ketMetrics'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuKetMetricsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/melamineStockForecast': {
      id: '/_authenticated/_shell/mellano/luukku/melamineStockForecast'
      path: '/mellano/luukku/melamineStockForecast'
      fullPath: '/mellano/luukku/melamineStockForecast'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuMelamineStockForecastRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/orderStatus': {
      id: '/_authenticated/_shell/mellano/luukku/orderStatus'
      path: '/mellano/luukku/orderStatus'
      fullPath: '/mellano/luukku/orderStatus'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuOrderStatusRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/packagedAmount': {
      id: '/_authenticated/_shell/mellano/luukku/packagedAmount'
      path: '/mellano/luukku/packagedAmount'
      fullPath: '/mellano/luukku/packagedAmount'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPackagedAmountRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/paintStockForecast': {
      id: '/_authenticated/_shell/mellano/luukku/paintStockForecast'
      path: '/mellano/luukku/paintStockForecast'
      fullPath: '/mellano/luukku/paintStockForecast'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPaintStockForecastRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/paintingPlan': {
      id: '/_authenticated/_shell/mellano/luukku/paintingPlan'
      path: '/mellano/luukku/paintingPlan'
      fullPath: '/mellano/luukku/paintingPlan'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPaintingPlanRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/paintingRoundDefects': {
      id: '/_authenticated/_shell/mellano/luukku/paintingRoundDefects'
      path: '/mellano/luukku/paintingRoundDefects'
      fullPath: '/mellano/luukku/paintingRoundDefects'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/paintingRounds': {
      id: '/_authenticated/_shell/mellano/luukku/paintingRounds'
      path: '/mellano/luukku/paintingRounds'
      fullPath: '/mellano/luukku/paintingRounds'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPaintingRoundsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/productionPlanning': {
      id: '/_authenticated/_shell/mellano/luukku/productionPlanning'
      path: '/mellano/luukku/productionPlanning'
      fullPath: '/mellano/luukku/productionPlanning'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuProductionPlanningRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/productionStatus': {
      id: '/_authenticated/_shell/mellano/luukku/productionStatus'
      path: '/mellano/luukku/productionStatus'
      fullPath: '/mellano/luukku/productionStatus'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuProductionStatusRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/purchaseOrderImport': {
      id: '/_authenticated/_shell/mellano/luukku/purchaseOrderImport'
      path: '/mellano/luukku/purchaseOrderImport'
      fullPath: '/mellano/luukku/purchaseOrderImport'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPurchaseOrderImportRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/purchaseSuggestion': {
      id: '/_authenticated/_shell/mellano/luukku/purchaseSuggestion'
      path: '/mellano/luukku/purchaseSuggestion'
      fullPath: '/mellano/luukku/purchaseSuggestion'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuPurchaseSuggestionRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/shiftDefects': {
      id: '/_authenticated/_shell/mellano/luukku/shiftDefects'
      path: '/mellano/luukku/shiftDefects'
      fullPath: '/mellano/luukku/shiftDefects'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuShiftDefectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches': {
      id: '/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches'
      path: '/mellano/luukku/unpackagedDeliveryBatches'
      fullPath: '/mellano/luukku/unpackagedDeliveryBatches'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress': {
      id: '/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress'
      path: '/mellano/luukku/unsentDeliveriesByAddress'
      fullPath: '/mellano/luukku/unsentDeliveriesByAddress'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/unsentRonkkoDeliveries': {
      id: '/_authenticated/_shell/mellano/luukku/unsentRonkkoDeliveries'
      path: '/mellano/luukku/unsentRonkkoDeliveries'
      fullPath: '/mellano/luukku/unsentRonkkoDeliveries'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/luukku/workOrderSlotting': {
      id: '/_authenticated/_shell/mellano/luukku/workOrderSlotting'
      path: '/mellano/luukku/workOrderSlotting'
      fullPath: '/mellano/luukku/workOrderSlotting'
      preLoaderRoute: typeof AuthenticatedShellMellanoLuukkuWorkOrderSlottingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/mellano/winner/designs': {
      id: '/_authenticated/_shell/mellano/winner/designs'
      path: '/mellano/winner/designs'
      fullPath: '/mellano/winner/designs'
      preLoaderRoute: typeof AuthenticatedShellMellanoWinnerDesignsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId': {
      id: '/_authenticated/_shell/production/productionLineGroupStatus/$productionLineGroupId'
      path: '/production/productionLineGroupStatus/$productionLineGroupId'
      fullPath: '/production/productionLineGroupStatus/$productionLineGroupId'
      preLoaderRoute: typeof AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/productionLinesStatus/$productionLineId': {
      id: '/_authenticated/_shell/production/productionLinesStatus/$productionLineId'
      path: '/production/productionLinesStatus/$productionLineId'
      fullPath: '/production/productionLinesStatus/$productionLineId'
      preLoaderRoute: typeof AuthenticatedShellProductionProductionLinesStatusProductionLineIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/production/systemDiagrams/$systemDiagramId': {
      id: '/_authenticated/_shell/production/systemDiagrams/$systemDiagramId'
      path: '/production/systemDiagrams/$systemDiagramId'
      fullPath: '/production/systemDiagrams/$systemDiagramId'
      preLoaderRoute: typeof AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/allDeliveries': {
      id: '/_authenticated/_shell/project/delivery/allDeliveries'
      path: '/project/delivery/allDeliveries'
      fullPath: '/project/delivery/allDeliveries'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryAllDeliveriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/allDeliveryPackages': {
      id: '/_authenticated/_shell/project/delivery/allDeliveryPackages'
      path: '/project/delivery/allDeliveryPackages'
      fullPath: '/project/delivery/allDeliveryPackages'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryAllDeliveryPackagesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/deliverableActivities': {
      id: '/_authenticated/_shell/project/delivery/deliverableActivities'
      path: '/project/delivery/deliverableActivities'
      fullPath: '/project/delivery/deliverableActivities'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryDeliverableActivitiesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/deliverableProjects': {
      id: '/_authenticated/_shell/project/delivery/deliverableProjects'
      path: '/project/delivery/deliverableProjects'
      fullPath: '/project/delivery/deliverableProjects'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryDeliverableProjectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/deliverableSubProjects': {
      id: '/_authenticated/_shell/project/delivery/deliverableSubProjects'
      path: '/project/delivery/deliverableSubProjects'
      fullPath: '/project/delivery/deliverableSubProjects'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryDeliverableSubProjectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/pickableProjects': {
      id: '/_authenticated/_shell/project/delivery/pickableProjects'
      path: '/project/delivery/pickableProjects'
      fullPath: '/project/delivery/pickableProjects'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryPickableProjectsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/project/delivery/undeliveredPackages': {
      id: '/_authenticated/_shell/project/delivery/undeliveredPackages'
      path: '/project/delivery/undeliveredPackages'
      fullPath: '/project/delivery/undeliveredPackages'
      preLoaderRoute: typeof AuthenticatedShellProjectDeliveryUndeliveredPackagesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries': {
      id: '/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries'
      path: '/sales/delivery/allCustomerOrderDeliveries'
      fullPath: '/sales/delivery/allCustomerOrderDeliveries'
      preLoaderRoute: typeof AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/delivery/deliverableCustomerOrders': {
      id: '/_authenticated/_shell/sales/delivery/deliverableCustomerOrders'
      path: '/sales/delivery/deliverableCustomerOrders'
      fullPath: '/sales/delivery/deliverableCustomerOrders'
      preLoaderRoute: typeof AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/delivery/ownTransports': {
      id: '/_authenticated/_shell/sales/delivery/ownTransports'
      path: '/sales/delivery/ownTransports'
      fullPath: '/sales/delivery/ownTransports'
      preLoaderRoute: typeof AuthenticatedShellSalesDeliveryOwnTransportsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/delivery/transportPlanning': {
      id: '/_authenticated/_shell/sales/delivery/transportPlanning'
      path: '/sales/delivery/transportPlanning'
      fullPath: '/sales/delivery/transportPlanning'
      preLoaderRoute: typeof AuthenticatedShellSalesDeliveryTransportPlanningRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/delivery/transports': {
      id: '/_authenticated/_shell/sales/delivery/transports'
      path: '/sales/delivery/transports'
      fullPath: '/sales/delivery/transports'
      preLoaderRoute: typeof AuthenticatedShellSalesDeliveryTransportsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/picking/allDeliveryPackages': {
      id: '/_authenticated/_shell/sales/picking/allDeliveryPackages'
      path: '/sales/picking/allDeliveryPackages'
      fullPath: '/sales/picking/allDeliveryPackages'
      preLoaderRoute: typeof AuthenticatedShellSalesPickingAllDeliveryPackagesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/picking/pickableCustomerOrders': {
      id: '/_authenticated/_shell/sales/picking/pickableCustomerOrders'
      path: '/sales/picking/pickableCustomerOrders'
      fullPath: '/sales/picking/pickableCustomerOrders'
      preLoaderRoute: typeof AuthenticatedShellSalesPickingPickableCustomerOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/picking/undeliveredPackages': {
      id: '/_authenticated/_shell/sales/picking/undeliveredPackages'
      path: '/sales/picking/undeliveredPackages'
      fullPath: '/sales/picking/undeliveredPackages'
      preLoaderRoute: typeof AuthenticatedShellSalesPickingUndeliveredPackagesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/pricing/priceLists': {
      id: '/_authenticated/_shell/sales/pricing/priceLists'
      path: '/sales/pricing/priceLists'
      fullPath: '/sales/pricing/priceLists'
      preLoaderRoute: typeof AuthenticatedShellSalesPricingPriceListsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesCommissions/createPayment': {
      id: '/_authenticated/_shell/sales/salesCommissions/createPayment'
      path: '/sales/salesCommissions/createPayment'
      fullPath: '/sales/salesCommissions/createPayment'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesCommissionsCreatePaymentRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesCommissions/lineNames': {
      id: '/_authenticated/_shell/sales/salesCommissions/lineNames'
      path: '/sales/salesCommissions/lineNames'
      fullPath: '/sales/salesCommissions/lineNames'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesCommissionsLineNamesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesCommissions/payments': {
      id: '/_authenticated/_shell/sales/salesCommissions/payments'
      path: '/sales/salesCommissions/payments'
      fullPath: '/sales/salesCommissions/payments'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesCommissionsPaymentsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines': {
      id: '/_authenticated/_shell/sales/salesCommissions/unapprovedSalesCommissionLines'
      path: '/sales/salesCommissions/unapprovedSalesCommissionLines'
      fullPath: '/sales/salesCommissions/unapprovedSalesCommissionLines'
      preLoaderRoute: typeof AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId': {
      id: '/_authenticated/_shell/sales/systemDiagrams/$systemDiagramId'
      path: '/sales/systemDiagrams/$systemDiagramId'
      fullPath: '/sales/systemDiagrams/$systemDiagramId'
      preLoaderRoute: typeof AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/cChartEvents/search': {
      id: '/_authenticated/_shell/spc/cChartEvents/search'
      path: '/spc/cChartEvents/search'
      fullPath: '/spc/cChartEvents/search'
      preLoaderRoute: typeof AuthenticatedShellSpcCChartEventsSearchRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/controlChartCollections/management': {
      id: '/_authenticated/_shell/spc/controlChartCollections/management'
      path: '/spc/controlChartCollections/management'
      fullPath: '/spc/controlChartCollections/management'
      preLoaderRoute: typeof AuthenticatedShellSpcControlChartCollectionsManagementRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId': {
      id: '/_authenticated/_shell/spc/controlChartParentGroup/$parentGroupId'
      path: '/spc/controlChartParentGroup/$parentGroupId'
      fullPath: '/spc/controlChartParentGroup/$parentGroupId'
      preLoaderRoute: typeof AuthenticatedShellSpcControlChartParentGroupParentGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/defectGroups/$parentGroupId': {
      id: '/_authenticated/_shell/spc/defectGroups/$parentGroupId'
      path: '/spc/defectGroups/$parentGroupId'
      fullPath: '/spc/defectGroups/$parentGroupId'
      preLoaderRoute: typeof AuthenticatedShellSpcDefectGroupsParentGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/masterData/yieldCharts': {
      id: '/_authenticated/_shell/spc/masterData/yieldCharts'
      path: '/spc/masterData/yieldCharts'
      fullPath: '/spc/masterData/yieldCharts'
      preLoaderRoute: typeof AuthenticatedShellSpcMasterDataYieldChartsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/specialCauses/chartGroups': {
      id: '/_authenticated/_shell/spc/specialCauses/chartGroups'
      path: '/spc/specialCauses/chartGroups'
      fullPath: '/spc/specialCauses/chartGroups'
      preLoaderRoute: typeof AuthenticatedShellSpcSpecialCausesChartGroupsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/specialCauses/resources': {
      id: '/_authenticated/_shell/spc/specialCauses/resources'
      path: '/spc/specialCauses/resources'
      fullPath: '/spc/specialCauses/resources'
      preLoaderRoute: typeof AuthenticatedShellSpcSpecialCausesResourcesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/summaryViews/': {
      id: '/_authenticated/_shell/spc/summaryViews/'
      path: '/spc/summaryViews'
      fullPath: '/spc/summaryViews/'
      preLoaderRoute: typeof AuthenticatedShellSpcSummaryViewsIndexRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId': {
      id: '/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId'
      path: '/spc/systemDiagrams/$systemDiagramId'
      fullPath: '/spc/systemDiagrams/$systemDiagramId'
      preLoaderRoute: typeof AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/surveys/submissions/audit': {
      id: '/_authenticated/_shell/surveys/submissions/audit'
      path: '/surveys/submissions/audit'
      fullPath: '/surveys/submissions/audit'
      preLoaderRoute: typeof AuthenticatedShellSurveysSubmissionsAuditRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents': {
      id: '/_authenticated/_shell/warehouse/inventory/allInventoryLevelEvents'
      path: '/warehouse/inventory/allInventoryLevelEvents'
      fullPath: '/warehouse/inventory/allInventoryLevelEvents'
      preLoaderRoute: typeof AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/inventory/manualEvents': {
      id: '/_authenticated/_shell/warehouse/inventory/manualEvents'
      path: '/warehouse/inventory/manualEvents'
      fullPath: '/warehouse/inventory/manualEvents'
      preLoaderRoute: typeof AuthenticatedShellWarehouseInventoryManualEventsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/warehouse/inventory/stockCounts': {
      id: '/_authenticated/_shell/warehouse/inventory/stockCounts'
      path: '/warehouse/inventory/stockCounts'
      fullPath: '/warehouse/inventory/stockCounts'
      preLoaderRoute: typeof AuthenticatedShellWarehouseInventoryStockCountsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines': {
      id: '/_authenticated/_shell/erp/parts/costCalculation/configurableCustomerOrderLines'
      path: '/erp/parts/costCalculation/configurableCustomerOrderLines'
      fullPath: '/erp/parts/costCalculation/configurableCustomerOrderLines'
      preLoaderRoute: typeof AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/project/delivery/bundling': {
      id: '/_authenticated/_shell/erp/project/delivery/bundling'
      path: '/erp/project/delivery/bundling'
      fullPath: '/erp/project/delivery/bundling'
      preLoaderRoute: typeof AuthenticatedShellErpProjectDeliveryBundlingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/project/delivery/loading': {
      id: '/_authenticated/_shell/erp/project/delivery/loading'
      path: '/erp/project/delivery/loading'
      fullPath: '/erp/project/delivery/loading'
      preLoaderRoute: typeof AuthenticatedShellErpProjectDeliveryLoadingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/project/delivery/outboundWarehouse': {
      id: '/_authenticated/_shell/erp/project/delivery/outboundWarehouse'
      path: '/erp/project/delivery/outboundWarehouse'
      fullPath: '/erp/project/delivery/outboundWarehouse'
      preLoaderRoute: typeof AuthenticatedShellErpProjectDeliveryOutboundWarehouseRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/delivery/bundling': {
      id: '/_authenticated/_shell/erp/sales/delivery/bundling'
      path: '/erp/sales/delivery/bundling'
      fullPath: '/erp/sales/delivery/bundling'
      preLoaderRoute: typeof AuthenticatedShellErpSalesDeliveryBundlingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/delivery/loading': {
      id: '/_authenticated/_shell/erp/sales/delivery/loading'
      path: '/erp/sales/delivery/loading'
      fullPath: '/erp/sales/delivery/loading'
      preLoaderRoute: typeof AuthenticatedShellErpSalesDeliveryLoadingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/delivery/outboundWarehouse': {
      id: '/_authenticated/_shell/erp/sales/delivery/outboundWarehouse'
      path: '/erp/sales/delivery/outboundWarehouse'
      fullPath: '/erp/sales/delivery/outboundWarehouse'
      preLoaderRoute: typeof AuthenticatedShellErpSalesDeliveryOutboundWarehouseRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/invoicing/allInvoices': {
      id: '/_authenticated/_shell/erp/sales/invoicing/allInvoices'
      path: '/erp/sales/invoicing/allInvoices'
      fullPath: '/erp/sales/invoicing/allInvoices'
      preLoaderRoute: typeof AuthenticatedShellErpSalesInvoicingAllInvoicesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders': {
      id: '/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders'
      path: '/erp/sales/invoicing/billableCustomerOrders'
      fullPath: '/erp/sales/invoicing/billableCustomerOrders'
      preLoaderRoute: typeof AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/reports/customerOrderBacklog': {
      id: '/_authenticated/_shell/erp/sales/reports/customerOrderBacklog'
      path: '/erp/sales/reports/customerOrderBacklog'
      fullPath: '/erp/sales/reports/customerOrderBacklog'
      preLoaderRoute: typeof AuthenticatedShellErpSalesReportsCustomerOrderBacklogRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog': {
      id: '/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog'
      path: '/erp/sales/reports/customerOrderOfferBacklog'
      fullPath: '/erp/sales/reports/customerOrderOfferBacklog'
      preLoaderRoute: typeof AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue': {
      id: '/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue'
      path: '/erp/warehouse/reports/shippingWarehouseInventoryValue'
      fullPath: '/erp/warehouse/reports/shippingWarehouseInventoryValue'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/warehouse/reports/warehouseValue': {
      id: '/_authenticated/_shell/erp/warehouse/reports/warehouseValue'
      path: '/erp/warehouse/reports/warehouseValue'
      fullPath: '/erp/warehouse/reports/warehouseValue'
      preLoaderRoute: typeof AuthenticatedShellErpWarehouseReportsWarehouseValueRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId': {
      id: '/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
      path: '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
      fullPath: '/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId'
      preLoaderRoute: typeof AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/controlChartCollections/view/$collectionId': {
      id: '/_authenticated/_shell/spc/controlChartCollections/view/$collectionId'
      path: '/spc/controlChartCollections/view/$collectionId'
      fullPath: '/spc/controlChartCollections/view/$collectionId'
      preLoaderRoute: typeof AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId': {
      id: '/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId'
      path: '/spc/processDiagrams/chartGroups/$chartGroupId'
      fullPath: '/spc/processDiagrams/chartGroups/$chartGroupId'
      preLoaderRoute: typeof AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/processDiagrams/resources/$resourceId': {
      id: '/_authenticated/_shell/spc/processDiagrams/resources/$resourceId'
      path: '/spc/processDiagrams/resources/$resourceId'
      fullPath: '/spc/processDiagrams/resources/$resourceId'
      preLoaderRoute: typeof AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId': {
      id: '/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId'
      path: '/spc/summaryViews/diagram/$summaryViewId'
      fullPath: '/spc/summaryViews/diagram/$summaryViewId'
      preLoaderRoute: typeof AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/spc/summaryViews/grid/$summaryViewId': {
      id: '/_authenticated/_shell/spc/summaryViews/grid/$summaryViewId'
      path: '/spc/summaryViews/grid/$summaryViewId'
      fullPath: '/spc/summaryViews/grid/$summaryViewId'
      preLoaderRoute: typeof AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/erp/sales/invoicing/reports/invoices': {
      id: '/_authenticated/_shell/erp/sales/invoicing/reports/invoices'
      path: '/erp/sales/invoicing/reports/invoices'
      fullPath: '/erp/sales/invoicing/reports/invoices'
      preLoaderRoute: typeof AuthenticatedShellErpSalesInvoicingReportsInvoicesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
  }
}

interface AuthenticatedShellRouteChildren {
  AuthenticatedShellBiRoute: typeof AuthenticatedShellBiRoute
  AuthenticatedShellDevTestRoute: typeof AuthenticatedShellDevTestRoute
  AuthenticatedShellIndexRoute: typeof AuthenticatedShellIndexRoute
  AuthenticatedShellAiCostsRoute: typeof AuthenticatedShellAiCostsRoute
  AuthenticatedShellAiManagementRoute: typeof AuthenticatedShellAiManagementRoute
  AuthenticatedShellAppsCustomAppIdRoute: typeof AuthenticatedShellAppsCustomAppIdRoute
  AuthenticatedShellCommonCompaniesRoute: typeof AuthenticatedShellCommonCompaniesRoute
  AuthenticatedShellCommonCurrenciesRoute: typeof AuthenticatedShellCommonCurrenciesRoute
  AuthenticatedShellCommonDocumentTemplatesRoute: typeof AuthenticatedShellCommonDocumentTemplatesRoute
  AuthenticatedShellCommonEmailTemplatesRoute: typeof AuthenticatedShellCommonEmailTemplatesRoute
  AuthenticatedShellCommonNumberSequencesRoute: typeof AuthenticatedShellCommonNumberSequencesRoute
  AuthenticatedShellCommonObjectAttributeFieldsRoute: typeof AuthenticatedShellCommonObjectAttributeFieldsRoute
  AuthenticatedShellCommonSitesRoute: typeof AuthenticatedShellCommonSitesRoute
  AuthenticatedShellCommonSystemDiagramsRoute: typeof AuthenticatedShellCommonSystemDiagramsRoute
  AuthenticatedShellConfiguratorLibrariesRoute: typeof AuthenticatedShellConfiguratorLibrariesRoute
  AuthenticatedShellConfiguratorOptionListsRoute: typeof AuthenticatedShellConfiguratorOptionListsRoute
  AuthenticatedShellConfiguratorProductFamiliesRoute: typeof AuthenticatedShellConfiguratorProductFamiliesRoute
  AuthenticatedShellConfiguratorProductFamilyCategoriesRoute: typeof AuthenticatedShellConfiguratorProductFamilyCategoriesRoute
  AuthenticatedShellConfiguratorTablesRoute: typeof AuthenticatedShellConfiguratorTablesRoute
  AuthenticatedShellCrmContactsRoute: typeof AuthenticatedShellCrmContactsRoute
  AuthenticatedShellCrmCustomersRoute: typeof AuthenticatedShellCrmCustomersRoute
  AuthenticatedShellCrmIncomingLeadsRoute: typeof AuthenticatedShellCrmIncomingLeadsRoute
  AuthenticatedShellCrmSalesAreasRoute: typeof AuthenticatedShellCrmSalesAreasRoute
  AuthenticatedShellCrmSalesLeadActivitiesRoute: typeof AuthenticatedShellCrmSalesLeadActivitiesRoute
  AuthenticatedShellCrmSalesLeadActivityCategoriesRoute: typeof AuthenticatedShellCrmSalesLeadActivityCategoriesRoute
  AuthenticatedShellCrmSalesLeadSourcesRoute: typeof AuthenticatedShellCrmSalesLeadSourcesRoute
  AuthenticatedShellCrmSalesLeadsRoute: typeof AuthenticatedShellCrmSalesLeadsRoute
  AuthenticatedShellCrmSalesPipelineRoute: typeof AuthenticatedShellCrmSalesPipelineRoute
  AuthenticatedShellCrmSalesPipelineBoardRoute: typeof AuthenticatedShellCrmSalesPipelineBoardRoute
  AuthenticatedShellCustomizationsApiConnectionsRoute: typeof AuthenticatedShellCustomizationsApiConnectionsRoute
  AuthenticatedShellCustomizationsApiKeysRoute: typeof AuthenticatedShellCustomizationsApiKeysRoute
  AuthenticatedShellCustomizationsCustomAppsRoute: typeof AuthenticatedShellCustomizationsCustomAppsRoute
  AuthenticatedShellCustomizationsCustomFunctionsRoute: typeof AuthenticatedShellCustomizationsCustomFunctionsRoute
  AuthenticatedShellCustomizationsSentEmailsRoute: typeof AuthenticatedShellCustomizationsSentEmailsRoute
  AuthenticatedShellDocumentsDocumentCategoriesRoute: typeof AuthenticatedShellDocumentsDocumentCategoriesRoute
  AuthenticatedShellDocumentsSearchRoute: typeof AuthenticatedShellDocumentsSearchRoute
  AuthenticatedShellMellanoLisToLsbRoute: typeof AuthenticatedShellMellanoLisToLsbRoute
  AuthenticatedShellMellanoPaintingControlChartsRoute: typeof AuthenticatedShellMellanoPaintingControlChartsRoute
  AuthenticatedShellProductDesignBomLineGroupsRoute: typeof AuthenticatedShellProductDesignBomLineGroupsRoute
  AuthenticatedShellProductManagementCatalogPartsRoute: typeof AuthenticatedShellProductManagementCatalogPartsRoute
  AuthenticatedShellProductManagementPartCategoriesRoute: typeof AuthenticatedShellProductManagementPartCategoriesRoute
  AuthenticatedShellProductManagementProductChangeCategoriesRoute: typeof AuthenticatedShellProductManagementProductChangeCategoriesRoute
  AuthenticatedShellProductManagementProductChangePackagesRoute: typeof AuthenticatedShellProductManagementProductChangePackagesRoute
  AuthenticatedShellProductManagementProductChangeRequestsRoute: typeof AuthenticatedShellProductManagementProductChangeRequestsRoute
  AuthenticatedShellProductManagementProductChangesRoute: typeof AuthenticatedShellProductManagementProductChangesRoute
  AuthenticatedShellProductManagementSearchPartsByAttributesRoute: typeof AuthenticatedShellProductManagementSearchPartsByAttributesRoute
  AuthenticatedShellProductManagementUnitsRoute: typeof AuthenticatedShellProductManagementUnitsRoute
  AuthenticatedShellProductionOnProductionLineRoute: typeof AuthenticatedShellProductionOnProductionLineRoute
  AuthenticatedShellProductionOperationsRoute: typeof AuthenticatedShellProductionOperationsRoute
  AuthenticatedShellProductionProductionLineGroupJobQueueRoute: typeof AuthenticatedShellProductionProductionLineGroupJobQueueRoute
  AuthenticatedShellProductionProductionLineJobQueueRoute: typeof AuthenticatedShellProductionProductionLineJobQueueRoute
  AuthenticatedShellProductionProductionLinesRoute: typeof AuthenticatedShellProductionProductionLinesRoute
  AuthenticatedShellProductionShopOrderBatchJobQueueRoute: typeof AuthenticatedShellProductionShopOrderBatchJobQueueRoute
  AuthenticatedShellProductionShopOrderBatchesRoute: typeof AuthenticatedShellProductionShopOrderBatchesRoute
  AuthenticatedShellProductionShopOrderPackagingRoute: typeof AuthenticatedShellProductionShopOrderPackagingRoute
  AuthenticatedShellProductionShopOrdersRoute: typeof AuthenticatedShellProductionShopOrdersRoute
  AuthenticatedShellProductionSubcontractingJobQueueRoute: typeof AuthenticatedShellProductionSubcontractingJobQueueRoute
  AuthenticatedShellProductionSupplementShopOrderRoute: typeof AuthenticatedShellProductionSupplementShopOrderRoute
  AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute: typeof AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute
  AuthenticatedShellProductionWorkCenterJobQueueRoute: typeof AuthenticatedShellProductionWorkCenterJobQueueRoute
  AuthenticatedShellProductionWorkCentersRoute: typeof AuthenticatedShellProductionWorkCentersRoute
  AuthenticatedShellProjectActivityResourcesRoute: typeof AuthenticatedShellProjectActivityResourcesRoute
  AuthenticatedShellProjectActivityTypesRoute: typeof AuthenticatedShellProjectActivityTypesRoute
  AuthenticatedShellProjectCostEventsRoute: typeof AuthenticatedShellProjectCostEventsRoute
  AuthenticatedShellProjectJobQueueRoute: typeof AuthenticatedShellProjectJobQueueRoute
  AuthenticatedShellProjectProjectTypesRoute: typeof AuthenticatedShellProjectProjectTypesRoute
  AuthenticatedShellProjectProjectsRoute: typeof AuthenticatedShellProjectProjectsRoute
  AuthenticatedShellProjectResourcesGanttRoute: typeof AuthenticatedShellProjectResourcesGanttRoute
  AuthenticatedShellProjectSchedulingRoute: typeof AuthenticatedShellProjectSchedulingRoute
  AuthenticatedShellProjectSubProjectTypesRoute: typeof AuthenticatedShellProjectSubProjectTypesRoute
  AuthenticatedShellProjectTreeRoute: typeof AuthenticatedShellProjectTreeRoute
  AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute: typeof AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute
  AuthenticatedShellPurchaseDeliveryNoticesRoute: typeof AuthenticatedShellPurchaseDeliveryNoticesRoute
  AuthenticatedShellPurchaseProcessViewRoute: typeof AuthenticatedShellPurchaseProcessViewRoute
  AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute: typeof AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute
  AuthenticatedShellPurchasePurchaseOrdersRoute: typeof AuthenticatedShellPurchasePurchaseOrdersRoute
  AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute: typeof AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute
  AuthenticatedShellPurchasePurchaseRequestsRoute: typeof AuthenticatedShellPurchasePurchaseRequestsRoute
  AuthenticatedShellSalesAccountingRoute: typeof AuthenticatedShellSalesAccountingRoute
  AuthenticatedShellSalesAllCustomerOrderLinesRoute: typeof AuthenticatedShellSalesAllCustomerOrderLinesRoute
  AuthenticatedShellSalesBillingPlanLinesToApproveRoute: typeof AuthenticatedShellSalesBillingPlanLinesToApproveRoute
  AuthenticatedShellSalesBillingPlanModelsRoute: typeof AuthenticatedShellSalesBillingPlanModelsRoute
  AuthenticatedShellSalesBillingPlanPartsRoute: typeof AuthenticatedShellSalesBillingPlanPartsRoute
  AuthenticatedShellSalesContractualTermsRoute: typeof AuthenticatedShellSalesContractualTermsRoute
  AuthenticatedShellSalesCustomerGroupsRoute: typeof AuthenticatedShellSalesCustomerGroupsRoute
  AuthenticatedShellSalesCustomerOfferTypesRoute: typeof AuthenticatedShellSalesCustomerOfferTypesRoute
  AuthenticatedShellSalesCustomerOrderSalesConditionsRoute: typeof AuthenticatedShellSalesCustomerOrderSalesConditionsRoute
  AuthenticatedShellSalesCustomerOrderTypesRoute: typeof AuthenticatedShellSalesCustomerOrderTypesRoute
  AuthenticatedShellSalesCustomerOrdersRoute: typeof AuthenticatedShellSalesCustomerOrdersRoute
  AuthenticatedShellSalesCustomerPriceGroupsRoute: typeof AuthenticatedShellSalesCustomerPriceGroupsRoute
  AuthenticatedShellSalesCustomersRoute: typeof AuthenticatedShellSalesCustomersRoute
  AuthenticatedShellSalesEInvoiceOperatorsRoute: typeof AuthenticatedShellSalesEInvoiceOperatorsRoute
  AuthenticatedShellSalesOffersRoute: typeof AuthenticatedShellSalesOffersRoute
  AuthenticatedShellSalesOrderDeliveryProcessViewRoute: typeof AuthenticatedShellSalesOrderDeliveryProcessViewRoute
  AuthenticatedShellSalesPaymentTermRoute: typeof AuthenticatedShellSalesPaymentTermRoute
  AuthenticatedShellSalesReceivedCustomerOrdersRoute: typeof AuthenticatedShellSalesReceivedCustomerOrdersRoute
  AuthenticatedShellSalesSalesConditionsRoute: typeof AuthenticatedShellSalesSalesConditionsRoute
  AuthenticatedShellSalesSalesPartCategoriesRoute: typeof AuthenticatedShellSalesSalesPartCategoriesRoute
  AuthenticatedShellSalesSalesPartPriceGroupsRoute: typeof AuthenticatedShellSalesSalesPartPriceGroupsRoute
  AuthenticatedShellSalesSalesPartsRoute: typeof AuthenticatedShellSalesSalesPartsRoute
  AuthenticatedShellSalesSalespersonsRoute: typeof AuthenticatedShellSalesSalespersonsRoute
  AuthenticatedShellSalesTransportRoutesRoute: typeof AuthenticatedShellSalesTransportRoutesRoute
  AuthenticatedShellSalesVatCodesRoute: typeof AuthenticatedShellSalesVatCodesRoute
  AuthenticatedShellSalesVatHandlingTypesRoute: typeof AuthenticatedShellSalesVatHandlingTypesRoute
  AuthenticatedShellSalvosSalesCommissionLimitsRoute: typeof AuthenticatedShellSalvosSalesCommissionLimitsRoute
  AuthenticatedShellSpcCalendarsRoute: typeof AuthenticatedShellSpcCalendarsRoute
  AuthenticatedShellSpcControlChartsRoute: typeof AuthenticatedShellSpcControlChartsRoute
  AuthenticatedShellSpcCycleTimeMeasurementRoute: typeof AuthenticatedShellSpcCycleTimeMeasurementRoute
  AuthenticatedShellSpcDimensionSearchRoute: typeof AuthenticatedShellSpcDimensionSearchRoute
  AuthenticatedShellSpcImportDataRoute: typeof AuthenticatedShellSpcImportDataRoute
  AuthenticatedShellSpcProcessImprovementCategoriesRoute: typeof AuthenticatedShellSpcProcessImprovementCategoriesRoute
  AuthenticatedShellSpcProcessImprovementsRoute: typeof AuthenticatedShellSpcProcessImprovementsRoute
  AuthenticatedShellSpcResourcesRoute: typeof AuthenticatedShellSpcResourcesRoute
  AuthenticatedShellSpcTimeMeasurementRoute: typeof AuthenticatedShellSpcTimeMeasurementRoute
  AuthenticatedShellSpcYieldChartsRoute: typeof AuthenticatedShellSpcYieldChartsRoute
  AuthenticatedShellSurveysSurveyCategoriesRoute: typeof AuthenticatedShellSurveysSurveyCategoriesRoute
  AuthenticatedShellSurveysSurveyFormsRoute: typeof AuthenticatedShellSurveysSurveyFormsRoute
  AuthenticatedShellTasksAllTasksRoute: typeof AuthenticatedShellTasksAllTasksRoute
  AuthenticatedShellTasksMyRoute: typeof AuthenticatedShellTasksMyRoute
  AuthenticatedShellTasksOnMyResponsibilityRoute: typeof AuthenticatedShellTasksOnMyResponsibilityRoute
  AuthenticatedShellTasksTaskTemplatesRoute: typeof AuthenticatedShellTasksTaskTemplatesRoute
  AuthenticatedShellUsersManagementRoute: typeof AuthenticatedShellUsersManagementRoute
  AuthenticatedShellUsersRolesRoute: typeof AuthenticatedShellUsersRolesRoute
  AuthenticatedShellWarehouseDataCollectionRoute: typeof AuthenticatedShellWarehouseDataCollectionRoute
  AuthenticatedShellWarehouseDeliveryPackageTypesRoute: typeof AuthenticatedShellWarehouseDeliveryPackageTypesRoute
  AuthenticatedShellWarehouseInventoryLevelProfileRoute: typeof AuthenticatedShellWarehouseInventoryLevelProfileRoute
  AuthenticatedShellWarehousePartCostCalculationRoute: typeof AuthenticatedShellWarehousePartCostCalculationRoute
  AuthenticatedShellWarehousePartImportCodesRoute: typeof AuthenticatedShellWarehousePartImportCodesRoute
  AuthenticatedShellWarehousePartsRoute: typeof AuthenticatedShellWarehousePartsRoute
  AuthenticatedShellWarehouseTransferJobQueueRoute: typeof AuthenticatedShellWarehouseTransferJobQueueRoute
  AuthenticatedShellWarehouseUnverifiedPartsRoute: typeof AuthenticatedShellWarehouseUnverifiedPartsRoute
  AuthenticatedShellWarehouseWarehouseLocationPartsRoute: typeof AuthenticatedShellWarehouseWarehouseLocationPartsRoute
  AuthenticatedShellWarehouseWarehouseLocationsRoute: typeof AuthenticatedShellWarehouseWarehouseLocationsRoute
  AuthenticatedShellWarehouseWarehouseTransfersRoute: typeof AuthenticatedShellWarehouseWarehouseTransfersRoute
  AuthenticatedShellWorkspaceCategoriesRoute: typeof AuthenticatedShellWorkspaceCategoriesRoute
  AuthenticatedShellWorkspaceWorkspacesRoute: typeof AuthenticatedShellWorkspaceWorkspacesRoute
  AuthenticatedShellCommonAccountingAccountsRoute: typeof AuthenticatedShellCommonAccountingAccountsRoute
  AuthenticatedShellCommonAccountingDimensionsRoute: typeof AuthenticatedShellCommonAccountingDimensionsRoute
  AuthenticatedShellErpCommonAddCostEventRoute: typeof AuthenticatedShellErpCommonAddCostEventRoute
  AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute: typeof AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute
  AuthenticatedShellErpCommonCostEventPriceListsRoute: typeof AuthenticatedShellErpCommonCostEventPriceListsRoute
  AuthenticatedShellErpCommonCostEventsRoute: typeof AuthenticatedShellErpCommonCostEventsRoute
  AuthenticatedShellErpConfiguratorLogSearchRoute: typeof AuthenticatedShellErpConfiguratorLogSearchRoute
  AuthenticatedShellErpDeliveryTransportEquipmentRoute: typeof AuthenticatedShellErpDeliveryTransportEquipmentRoute
  AuthenticatedShellErpInventoryForecastRoute: typeof AuthenticatedShellErpInventoryForecastRoute
  AuthenticatedShellErpProductionCapacityRoute: typeof AuthenticatedShellErpProductionCapacityRoute
  AuthenticatedShellErpProductionCompletedQuantityRoute: typeof AuthenticatedShellErpProductionCompletedQuantityRoute
  AuthenticatedShellErpProductionLoadChartRoute: typeof AuthenticatedShellErpProductionLoadChartRoute
  AuthenticatedShellErpProductionProductionPlanningRoute: typeof AuthenticatedShellErpProductionProductionPlanningRoute
  AuthenticatedShellErpProductionSalesProductionBacklogRoute: typeof AuthenticatedShellErpProductionSalesProductionBacklogRoute
  AuthenticatedShellErpPurchaseSupplierGroupsRoute: typeof AuthenticatedShellErpPurchaseSupplierGroupsRoute
  AuthenticatedShellErpPurchaseSuppliersRoute: typeof AuthenticatedShellErpPurchaseSuppliersRoute
  AuthenticatedShellErpReclamationsReclamationCategoryRoute: typeof AuthenticatedShellErpReclamationsReclamationCategoryRoute
  AuthenticatedShellErpReclamationsReclamationCauseRoute: typeof AuthenticatedShellErpReclamationsReclamationCauseRoute
  AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute: typeof AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute
  AuthenticatedShellErpReclamationsReclamationLocationRoute: typeof AuthenticatedShellErpReclamationsReclamationLocationRoute
  AuthenticatedShellErpReclamationsReclamationsRoute: typeof AuthenticatedShellErpReclamationsReclamationsRoute
  AuthenticatedShellErpReclamationsRoundsRoute: typeof AuthenticatedShellErpReclamationsRoundsRoute
  AuthenticatedShellErpReclamationsWeekPlanningRoute: typeof AuthenticatedShellErpReclamationsWeekPlanningRoute
  AuthenticatedShellErpReclamationsWorkQueueRoute: typeof AuthenticatedShellErpReclamationsWorkQueueRoute
  AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute: typeof AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute
  AuthenticatedShellErpSafetyControlSurveySummaryRoute: typeof AuthenticatedShellErpSafetyControlSurveySummaryRoute
  AuthenticatedShellErpSafetyControlSurveySurveysRoute: typeof AuthenticatedShellErpSafetyControlSurveySurveysRoute
  AuthenticatedShellErpSafetyControlSurveyTeamsRoute: typeof AuthenticatedShellErpSafetyControlSurveyTeamsRoute
  AuthenticatedShellErpSalesCustomerOrderImportRoute: typeof AuthenticatedShellErpSalesCustomerOrderImportRoute
  AuthenticatedShellErpVertexIndConfigRoute: typeof AuthenticatedShellErpVertexIndConfigRoute
  AuthenticatedShellErpWarehouseCargoDriversRoute: typeof AuthenticatedShellErpWarehouseCargoDriversRoute
  AuthenticatedShellErpWarehouseDeliveryMethodsRoute: typeof AuthenticatedShellErpWarehouseDeliveryMethodsRoute
  AuthenticatedShellErpWarehouseDeliveryTermsRoute: typeof AuthenticatedShellErpWarehouseDeliveryTermsRoute
  AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute: typeof AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute
  AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute: typeof AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute
  AuthenticatedShellMellanoLuukkuCapacityRoute: typeof AuthenticatedShellMellanoLuukkuCapacityRoute
  AuthenticatedShellMellanoLuukkuDataCollectionRoute: typeof AuthenticatedShellMellanoLuukkuDataCollectionRoute
  AuthenticatedShellMellanoLuukkuDispatchSlottingRoute: typeof AuthenticatedShellMellanoLuukkuDispatchSlottingRoute
  AuthenticatedShellMellanoLuukkuDrillStampsRoute: typeof AuthenticatedShellMellanoLuukkuDrillStampsRoute
  AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute: typeof AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute
  AuthenticatedShellMellanoLuukkuKetMetricsRoute: typeof AuthenticatedShellMellanoLuukkuKetMetricsRoute
  AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute: typeof AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute
  AuthenticatedShellMellanoLuukkuOrderStatusRoute: typeof AuthenticatedShellMellanoLuukkuOrderStatusRoute
  AuthenticatedShellMellanoLuukkuPackagedAmountRoute: typeof AuthenticatedShellMellanoLuukkuPackagedAmountRoute
  AuthenticatedShellMellanoLuukkuPaintStockForecastRoute: typeof AuthenticatedShellMellanoLuukkuPaintStockForecastRoute
  AuthenticatedShellMellanoLuukkuPaintingPlanRoute: typeof AuthenticatedShellMellanoLuukkuPaintingPlanRoute
  AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute: typeof AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute
  AuthenticatedShellMellanoLuukkuPaintingRoundsRoute: typeof AuthenticatedShellMellanoLuukkuPaintingRoundsRoute
  AuthenticatedShellMellanoLuukkuProductionPlanningRoute: typeof AuthenticatedShellMellanoLuukkuProductionPlanningRoute
  AuthenticatedShellMellanoLuukkuProductionStatusRoute: typeof AuthenticatedShellMellanoLuukkuProductionStatusRoute
  AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute: typeof AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute
  AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute: typeof AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute
  AuthenticatedShellMellanoLuukkuShiftDefectsRoute: typeof AuthenticatedShellMellanoLuukkuShiftDefectsRoute
  AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute: typeof AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute
  AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute: typeof AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute
  AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute: typeof AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute
  AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute: typeof AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute
  AuthenticatedShellMellanoWinnerDesignsRoute: typeof AuthenticatedShellMellanoWinnerDesignsRoute
  AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute: typeof AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute
  AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute: typeof AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute
  AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute: typeof AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute
  AuthenticatedShellProjectDeliveryAllDeliveriesRoute: typeof AuthenticatedShellProjectDeliveryAllDeliveriesRoute
  AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute: typeof AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute
  AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute: typeof AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute
  AuthenticatedShellProjectDeliveryDeliverableProjectsRoute: typeof AuthenticatedShellProjectDeliveryDeliverableProjectsRoute
  AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute: typeof AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute
  AuthenticatedShellProjectDeliveryPickableProjectsRoute: typeof AuthenticatedShellProjectDeliveryPickableProjectsRoute
  AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute: typeof AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute
  AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute: typeof AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute
  AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute: typeof AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute
  AuthenticatedShellSalesDeliveryOwnTransportsRoute: typeof AuthenticatedShellSalesDeliveryOwnTransportsRoute
  AuthenticatedShellSalesDeliveryTransportPlanningRoute: typeof AuthenticatedShellSalesDeliveryTransportPlanningRoute
  AuthenticatedShellSalesDeliveryTransportsRoute: typeof AuthenticatedShellSalesDeliveryTransportsRoute
  AuthenticatedShellSalesPickingAllDeliveryPackagesRoute: typeof AuthenticatedShellSalesPickingAllDeliveryPackagesRoute
  AuthenticatedShellSalesPickingPickableCustomerOrdersRoute: typeof AuthenticatedShellSalesPickingPickableCustomerOrdersRoute
  AuthenticatedShellSalesPickingUndeliveredPackagesRoute: typeof AuthenticatedShellSalesPickingUndeliveredPackagesRoute
  AuthenticatedShellSalesPricingPriceListsRoute: typeof AuthenticatedShellSalesPricingPriceListsRoute
  AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute: typeof AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute
  AuthenticatedShellSalesSalesCommissionsLineNamesRoute: typeof AuthenticatedShellSalesSalesCommissionsLineNamesRoute
  AuthenticatedShellSalesSalesCommissionsPaymentsRoute: typeof AuthenticatedShellSalesSalesCommissionsPaymentsRoute
  AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute: typeof AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute
  AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute: typeof AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute
  AuthenticatedShellSpcCChartEventsSearchRoute: typeof AuthenticatedShellSpcCChartEventsSearchRoute
  AuthenticatedShellSpcControlChartCollectionsManagementRoute: typeof AuthenticatedShellSpcControlChartCollectionsManagementRoute
  AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute: typeof AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute
  AuthenticatedShellSpcDefectGroupsParentGroupIdRoute: typeof AuthenticatedShellSpcDefectGroupsParentGroupIdRoute
  AuthenticatedShellSpcMasterDataYieldChartsRoute: typeof AuthenticatedShellSpcMasterDataYieldChartsRoute
  AuthenticatedShellSpcSpecialCausesChartGroupsRoute: typeof AuthenticatedShellSpcSpecialCausesChartGroupsRoute
  AuthenticatedShellSpcSpecialCausesResourcesRoute: typeof AuthenticatedShellSpcSpecialCausesResourcesRoute
  AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute: typeof AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute
  AuthenticatedShellSurveysSubmissionsAuditRoute: typeof AuthenticatedShellSurveysSubmissionsAuditRoute
  AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute: typeof AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute
  AuthenticatedShellWarehouseInventoryManualEventsRoute: typeof AuthenticatedShellWarehouseInventoryManualEventsRoute
  AuthenticatedShellWarehouseInventoryStockCountsRoute: typeof AuthenticatedShellWarehouseInventoryStockCountsRoute
  AuthenticatedShellSpcSummaryViewsIndexRoute: typeof AuthenticatedShellSpcSummaryViewsIndexRoute
  AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute: typeof AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute
  AuthenticatedShellErpProjectDeliveryBundlingRoute: typeof AuthenticatedShellErpProjectDeliveryBundlingRoute
  AuthenticatedShellErpProjectDeliveryLoadingRoute: typeof AuthenticatedShellErpProjectDeliveryLoadingRoute
  AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute: typeof AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute
  AuthenticatedShellErpSalesDeliveryBundlingRoute: typeof AuthenticatedShellErpSalesDeliveryBundlingRoute
  AuthenticatedShellErpSalesDeliveryLoadingRoute: typeof AuthenticatedShellErpSalesDeliveryLoadingRoute
  AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute: typeof AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute
  AuthenticatedShellErpSalesInvoicingAllInvoicesRoute: typeof AuthenticatedShellErpSalesInvoicingAllInvoicesRoute
  AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute: typeof AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute
  AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute: typeof AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute
  AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute: typeof AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute
  AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute: typeof AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute
  AuthenticatedShellErpWarehouseReportsWarehouseValueRoute: typeof AuthenticatedShellErpWarehouseReportsWarehouseValueRoute
  AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute: typeof AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute
  AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute: typeof AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute
  AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute: typeof AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute
  AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute: typeof AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute
  AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute: typeof AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute
  AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute: typeof AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute
  AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute: typeof AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute
}

const AuthenticatedShellRouteChildren: AuthenticatedShellRouteChildren = {
  AuthenticatedShellBiRoute: AuthenticatedShellBiRoute,
  AuthenticatedShellDevTestRoute: AuthenticatedShellDevTestRoute,
  AuthenticatedShellIndexRoute: AuthenticatedShellIndexRoute,
  AuthenticatedShellAiCostsRoute: AuthenticatedShellAiCostsRoute,
  AuthenticatedShellAiManagementRoute: AuthenticatedShellAiManagementRoute,
  AuthenticatedShellAppsCustomAppIdRoute:
    AuthenticatedShellAppsCustomAppIdRoute,
  AuthenticatedShellCommonCompaniesRoute:
    AuthenticatedShellCommonCompaniesRoute,
  AuthenticatedShellCommonCurrenciesRoute:
    AuthenticatedShellCommonCurrenciesRoute,
  AuthenticatedShellCommonDocumentTemplatesRoute:
    AuthenticatedShellCommonDocumentTemplatesRoute,
  AuthenticatedShellCommonEmailTemplatesRoute:
    AuthenticatedShellCommonEmailTemplatesRoute,
  AuthenticatedShellCommonNumberSequencesRoute:
    AuthenticatedShellCommonNumberSequencesRoute,
  AuthenticatedShellCommonObjectAttributeFieldsRoute:
    AuthenticatedShellCommonObjectAttributeFieldsRoute,
  AuthenticatedShellCommonSitesRoute: AuthenticatedShellCommonSitesRoute,
  AuthenticatedShellCommonSystemDiagramsRoute:
    AuthenticatedShellCommonSystemDiagramsRoute,
  AuthenticatedShellConfiguratorLibrariesRoute:
    AuthenticatedShellConfiguratorLibrariesRoute,
  AuthenticatedShellConfiguratorOptionListsRoute:
    AuthenticatedShellConfiguratorOptionListsRoute,
  AuthenticatedShellConfiguratorProductFamiliesRoute:
    AuthenticatedShellConfiguratorProductFamiliesRoute,
  AuthenticatedShellConfiguratorProductFamilyCategoriesRoute:
    AuthenticatedShellConfiguratorProductFamilyCategoriesRoute,
  AuthenticatedShellConfiguratorTablesRoute:
    AuthenticatedShellConfiguratorTablesRoute,
  AuthenticatedShellCrmContactsRoute: AuthenticatedShellCrmContactsRoute,
  AuthenticatedShellCrmCustomersRoute: AuthenticatedShellCrmCustomersRoute,
  AuthenticatedShellCrmIncomingLeadsRoute:
    AuthenticatedShellCrmIncomingLeadsRoute,
  AuthenticatedShellCrmSalesAreasRoute: AuthenticatedShellCrmSalesAreasRoute,
  AuthenticatedShellCrmSalesLeadActivitiesRoute:
    AuthenticatedShellCrmSalesLeadActivitiesRoute,
  AuthenticatedShellCrmSalesLeadActivityCategoriesRoute:
    AuthenticatedShellCrmSalesLeadActivityCategoriesRoute,
  AuthenticatedShellCrmSalesLeadSourcesRoute:
    AuthenticatedShellCrmSalesLeadSourcesRoute,
  AuthenticatedShellCrmSalesLeadsRoute: AuthenticatedShellCrmSalesLeadsRoute,
  AuthenticatedShellCrmSalesPipelineRoute:
    AuthenticatedShellCrmSalesPipelineRoute,
  AuthenticatedShellCrmSalesPipelineBoardRoute:
    AuthenticatedShellCrmSalesPipelineBoardRoute,
  AuthenticatedShellCustomizationsApiConnectionsRoute:
    AuthenticatedShellCustomizationsApiConnectionsRoute,
  AuthenticatedShellCustomizationsApiKeysRoute:
    AuthenticatedShellCustomizationsApiKeysRoute,
  AuthenticatedShellCustomizationsCustomAppsRoute:
    AuthenticatedShellCustomizationsCustomAppsRoute,
  AuthenticatedShellCustomizationsCustomFunctionsRoute:
    AuthenticatedShellCustomizationsCustomFunctionsRoute,
  AuthenticatedShellCustomizationsSentEmailsRoute:
    AuthenticatedShellCustomizationsSentEmailsRoute,
  AuthenticatedShellDocumentsDocumentCategoriesRoute:
    AuthenticatedShellDocumentsDocumentCategoriesRoute,
  AuthenticatedShellDocumentsSearchRoute:
    AuthenticatedShellDocumentsSearchRoute,
  AuthenticatedShellMellanoLisToLsbRoute:
    AuthenticatedShellMellanoLisToLsbRoute,
  AuthenticatedShellMellanoPaintingControlChartsRoute:
    AuthenticatedShellMellanoPaintingControlChartsRoute,
  AuthenticatedShellProductDesignBomLineGroupsRoute:
    AuthenticatedShellProductDesignBomLineGroupsRoute,
  AuthenticatedShellProductManagementCatalogPartsRoute:
    AuthenticatedShellProductManagementCatalogPartsRoute,
  AuthenticatedShellProductManagementPartCategoriesRoute:
    AuthenticatedShellProductManagementPartCategoriesRoute,
  AuthenticatedShellProductManagementProductChangeCategoriesRoute:
    AuthenticatedShellProductManagementProductChangeCategoriesRoute,
  AuthenticatedShellProductManagementProductChangePackagesRoute:
    AuthenticatedShellProductManagementProductChangePackagesRoute,
  AuthenticatedShellProductManagementProductChangeRequestsRoute:
    AuthenticatedShellProductManagementProductChangeRequestsRoute,
  AuthenticatedShellProductManagementProductChangesRoute:
    AuthenticatedShellProductManagementProductChangesRoute,
  AuthenticatedShellProductManagementSearchPartsByAttributesRoute:
    AuthenticatedShellProductManagementSearchPartsByAttributesRoute,
  AuthenticatedShellProductManagementUnitsRoute:
    AuthenticatedShellProductManagementUnitsRoute,
  AuthenticatedShellProductionOnProductionLineRoute:
    AuthenticatedShellProductionOnProductionLineRoute,
  AuthenticatedShellProductionOperationsRoute:
    AuthenticatedShellProductionOperationsRoute,
  AuthenticatedShellProductionProductionLineGroupJobQueueRoute:
    AuthenticatedShellProductionProductionLineGroupJobQueueRoute,
  AuthenticatedShellProductionProductionLineJobQueueRoute:
    AuthenticatedShellProductionProductionLineJobQueueRoute,
  AuthenticatedShellProductionProductionLinesRoute:
    AuthenticatedShellProductionProductionLinesRoute,
  AuthenticatedShellProductionShopOrderBatchJobQueueRoute:
    AuthenticatedShellProductionShopOrderBatchJobQueueRoute,
  AuthenticatedShellProductionShopOrderBatchesRoute:
    AuthenticatedShellProductionShopOrderBatchesRoute,
  AuthenticatedShellProductionShopOrderPackagingRoute:
    AuthenticatedShellProductionShopOrderPackagingRoute,
  AuthenticatedShellProductionShopOrdersRoute:
    AuthenticatedShellProductionShopOrdersRoute,
  AuthenticatedShellProductionSubcontractingJobQueueRoute:
    AuthenticatedShellProductionSubcontractingJobQueueRoute,
  AuthenticatedShellProductionSupplementShopOrderRoute:
    AuthenticatedShellProductionSupplementShopOrderRoute,
  AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute:
    AuthenticatedShellProductionWorkCenterIncompleteOperationsRoute,
  AuthenticatedShellProductionWorkCenterJobQueueRoute:
    AuthenticatedShellProductionWorkCenterJobQueueRoute,
  AuthenticatedShellProductionWorkCentersRoute:
    AuthenticatedShellProductionWorkCentersRoute,
  AuthenticatedShellProjectActivityResourcesRoute:
    AuthenticatedShellProjectActivityResourcesRoute,
  AuthenticatedShellProjectActivityTypesRoute:
    AuthenticatedShellProjectActivityTypesRoute,
  AuthenticatedShellProjectCostEventsRoute:
    AuthenticatedShellProjectCostEventsRoute,
  AuthenticatedShellProjectJobQueueRoute:
    AuthenticatedShellProjectJobQueueRoute,
  AuthenticatedShellProjectProjectTypesRoute:
    AuthenticatedShellProjectProjectTypesRoute,
  AuthenticatedShellProjectProjectsRoute:
    AuthenticatedShellProjectProjectsRoute,
  AuthenticatedShellProjectResourcesGanttRoute:
    AuthenticatedShellProjectResourcesGanttRoute,
  AuthenticatedShellProjectSchedulingRoute:
    AuthenticatedShellProjectSchedulingRoute,
  AuthenticatedShellProjectSubProjectTypesRoute:
    AuthenticatedShellProjectSubProjectTypesRoute,
  AuthenticatedShellProjectTreeRoute: AuthenticatedShellProjectTreeRoute,
  AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute:
    AuthenticatedShellPurchaseAllPurchaseOrderLinesRoute,
  AuthenticatedShellPurchaseDeliveryNoticesRoute:
    AuthenticatedShellPurchaseDeliveryNoticesRoute,
  AuthenticatedShellPurchaseProcessViewRoute:
    AuthenticatedShellPurchaseProcessViewRoute,
  AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute:
    AuthenticatedShellPurchasePurchaseOrderConfirmationsRoute,
  AuthenticatedShellPurchasePurchaseOrdersRoute:
    AuthenticatedShellPurchasePurchaseOrdersRoute,
  AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute:
    AuthenticatedShellPurchasePurchaseOrdersToReceiveRoute,
  AuthenticatedShellPurchasePurchaseRequestsRoute:
    AuthenticatedShellPurchasePurchaseRequestsRoute,
  AuthenticatedShellSalesAccountingRoute:
    AuthenticatedShellSalesAccountingRoute,
  AuthenticatedShellSalesAllCustomerOrderLinesRoute:
    AuthenticatedShellSalesAllCustomerOrderLinesRoute,
  AuthenticatedShellSalesBillingPlanLinesToApproveRoute:
    AuthenticatedShellSalesBillingPlanLinesToApproveRoute,
  AuthenticatedShellSalesBillingPlanModelsRoute:
    AuthenticatedShellSalesBillingPlanModelsRoute,
  AuthenticatedShellSalesBillingPlanPartsRoute:
    AuthenticatedShellSalesBillingPlanPartsRoute,
  AuthenticatedShellSalesContractualTermsRoute:
    AuthenticatedShellSalesContractualTermsRoute,
  AuthenticatedShellSalesCustomerGroupsRoute:
    AuthenticatedShellSalesCustomerGroupsRoute,
  AuthenticatedShellSalesCustomerOfferTypesRoute:
    AuthenticatedShellSalesCustomerOfferTypesRoute,
  AuthenticatedShellSalesCustomerOrderSalesConditionsRoute:
    AuthenticatedShellSalesCustomerOrderSalesConditionsRoute,
  AuthenticatedShellSalesCustomerOrderTypesRoute:
    AuthenticatedShellSalesCustomerOrderTypesRoute,
  AuthenticatedShellSalesCustomerOrdersRoute:
    AuthenticatedShellSalesCustomerOrdersRoute,
  AuthenticatedShellSalesCustomerPriceGroupsRoute:
    AuthenticatedShellSalesCustomerPriceGroupsRoute,
  AuthenticatedShellSalesCustomersRoute: AuthenticatedShellSalesCustomersRoute,
  AuthenticatedShellSalesEInvoiceOperatorsRoute:
    AuthenticatedShellSalesEInvoiceOperatorsRoute,
  AuthenticatedShellSalesOffersRoute: AuthenticatedShellSalesOffersRoute,
  AuthenticatedShellSalesOrderDeliveryProcessViewRoute:
    AuthenticatedShellSalesOrderDeliveryProcessViewRoute,
  AuthenticatedShellSalesPaymentTermRoute:
    AuthenticatedShellSalesPaymentTermRoute,
  AuthenticatedShellSalesReceivedCustomerOrdersRoute:
    AuthenticatedShellSalesReceivedCustomerOrdersRoute,
  AuthenticatedShellSalesSalesConditionsRoute:
    AuthenticatedShellSalesSalesConditionsRoute,
  AuthenticatedShellSalesSalesPartCategoriesRoute:
    AuthenticatedShellSalesSalesPartCategoriesRoute,
  AuthenticatedShellSalesSalesPartPriceGroupsRoute:
    AuthenticatedShellSalesSalesPartPriceGroupsRoute,
  AuthenticatedShellSalesSalesPartsRoute:
    AuthenticatedShellSalesSalesPartsRoute,
  AuthenticatedShellSalesSalespersonsRoute:
    AuthenticatedShellSalesSalespersonsRoute,
  AuthenticatedShellSalesTransportRoutesRoute:
    AuthenticatedShellSalesTransportRoutesRoute,
  AuthenticatedShellSalesVatCodesRoute: AuthenticatedShellSalesVatCodesRoute,
  AuthenticatedShellSalesVatHandlingTypesRoute:
    AuthenticatedShellSalesVatHandlingTypesRoute,
  AuthenticatedShellSalvosSalesCommissionLimitsRoute:
    AuthenticatedShellSalvosSalesCommissionLimitsRoute,
  AuthenticatedShellSpcCalendarsRoute: AuthenticatedShellSpcCalendarsRoute,
  AuthenticatedShellSpcControlChartsRoute:
    AuthenticatedShellSpcControlChartsRoute,
  AuthenticatedShellSpcCycleTimeMeasurementRoute:
    AuthenticatedShellSpcCycleTimeMeasurementRoute,
  AuthenticatedShellSpcDimensionSearchRoute:
    AuthenticatedShellSpcDimensionSearchRoute,
  AuthenticatedShellSpcImportDataRoute: AuthenticatedShellSpcImportDataRoute,
  AuthenticatedShellSpcProcessImprovementCategoriesRoute:
    AuthenticatedShellSpcProcessImprovementCategoriesRoute,
  AuthenticatedShellSpcProcessImprovementsRoute:
    AuthenticatedShellSpcProcessImprovementsRoute,
  AuthenticatedShellSpcResourcesRoute: AuthenticatedShellSpcResourcesRoute,
  AuthenticatedShellSpcTimeMeasurementRoute:
    AuthenticatedShellSpcTimeMeasurementRoute,
  AuthenticatedShellSpcYieldChartsRoute: AuthenticatedShellSpcYieldChartsRoute,
  AuthenticatedShellSurveysSurveyCategoriesRoute:
    AuthenticatedShellSurveysSurveyCategoriesRoute,
  AuthenticatedShellSurveysSurveyFormsRoute:
    AuthenticatedShellSurveysSurveyFormsRoute,
  AuthenticatedShellTasksAllTasksRoute: AuthenticatedShellTasksAllTasksRoute,
  AuthenticatedShellTasksMyRoute: AuthenticatedShellTasksMyRoute,
  AuthenticatedShellTasksOnMyResponsibilityRoute:
    AuthenticatedShellTasksOnMyResponsibilityRoute,
  AuthenticatedShellTasksTaskTemplatesRoute:
    AuthenticatedShellTasksTaskTemplatesRoute,
  AuthenticatedShellUsersManagementRoute:
    AuthenticatedShellUsersManagementRoute,
  AuthenticatedShellUsersRolesRoute: AuthenticatedShellUsersRolesRoute,
  AuthenticatedShellWarehouseDataCollectionRoute:
    AuthenticatedShellWarehouseDataCollectionRoute,
  AuthenticatedShellWarehouseDeliveryPackageTypesRoute:
    AuthenticatedShellWarehouseDeliveryPackageTypesRoute,
  AuthenticatedShellWarehouseInventoryLevelProfileRoute:
    AuthenticatedShellWarehouseInventoryLevelProfileRoute,
  AuthenticatedShellWarehousePartCostCalculationRoute:
    AuthenticatedShellWarehousePartCostCalculationRoute,
  AuthenticatedShellWarehousePartImportCodesRoute:
    AuthenticatedShellWarehousePartImportCodesRoute,
  AuthenticatedShellWarehousePartsRoute: AuthenticatedShellWarehousePartsRoute,
  AuthenticatedShellWarehouseTransferJobQueueRoute:
    AuthenticatedShellWarehouseTransferJobQueueRoute,
  AuthenticatedShellWarehouseUnverifiedPartsRoute:
    AuthenticatedShellWarehouseUnverifiedPartsRoute,
  AuthenticatedShellWarehouseWarehouseLocationPartsRoute:
    AuthenticatedShellWarehouseWarehouseLocationPartsRoute,
  AuthenticatedShellWarehouseWarehouseLocationsRoute:
    AuthenticatedShellWarehouseWarehouseLocationsRoute,
  AuthenticatedShellWarehouseWarehouseTransfersRoute:
    AuthenticatedShellWarehouseWarehouseTransfersRoute,
  AuthenticatedShellWorkspaceCategoriesRoute:
    AuthenticatedShellWorkspaceCategoriesRoute,
  AuthenticatedShellWorkspaceWorkspacesRoute:
    AuthenticatedShellWorkspaceWorkspacesRoute,
  AuthenticatedShellCommonAccountingAccountsRoute:
    AuthenticatedShellCommonAccountingAccountsRoute,
  AuthenticatedShellCommonAccountingDimensionsRoute:
    AuthenticatedShellCommonAccountingDimensionsRoute,
  AuthenticatedShellErpCommonAddCostEventRoute:
    AuthenticatedShellErpCommonAddCostEventRoute,
  AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute:
    AuthenticatedShellErpCommonCostEventObjectTypeSettingsRoute,
  AuthenticatedShellErpCommonCostEventPriceListsRoute:
    AuthenticatedShellErpCommonCostEventPriceListsRoute,
  AuthenticatedShellErpCommonCostEventsRoute:
    AuthenticatedShellErpCommonCostEventsRoute,
  AuthenticatedShellErpConfiguratorLogSearchRoute:
    AuthenticatedShellErpConfiguratorLogSearchRoute,
  AuthenticatedShellErpDeliveryTransportEquipmentRoute:
    AuthenticatedShellErpDeliveryTransportEquipmentRoute,
  AuthenticatedShellErpInventoryForecastRoute:
    AuthenticatedShellErpInventoryForecastRoute,
  AuthenticatedShellErpProductionCapacityRoute:
    AuthenticatedShellErpProductionCapacityRoute,
  AuthenticatedShellErpProductionCompletedQuantityRoute:
    AuthenticatedShellErpProductionCompletedQuantityRoute,
  AuthenticatedShellErpProductionLoadChartRoute:
    AuthenticatedShellErpProductionLoadChartRoute,
  AuthenticatedShellErpProductionProductionPlanningRoute:
    AuthenticatedShellErpProductionProductionPlanningRoute,
  AuthenticatedShellErpProductionSalesProductionBacklogRoute:
    AuthenticatedShellErpProductionSalesProductionBacklogRoute,
  AuthenticatedShellErpPurchaseSupplierGroupsRoute:
    AuthenticatedShellErpPurchaseSupplierGroupsRoute,
  AuthenticatedShellErpPurchaseSuppliersRoute:
    AuthenticatedShellErpPurchaseSuppliersRoute,
  AuthenticatedShellErpReclamationsReclamationCategoryRoute:
    AuthenticatedShellErpReclamationsReclamationCategoryRoute,
  AuthenticatedShellErpReclamationsReclamationCauseRoute:
    AuthenticatedShellErpReclamationsReclamationCauseRoute,
  AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute:
    AuthenticatedShellErpReclamationsReclamationHandlingMethodRoute,
  AuthenticatedShellErpReclamationsReclamationLocationRoute:
    AuthenticatedShellErpReclamationsReclamationLocationRoute,
  AuthenticatedShellErpReclamationsReclamationsRoute:
    AuthenticatedShellErpReclamationsReclamationsRoute,
  AuthenticatedShellErpReclamationsRoundsRoute:
    AuthenticatedShellErpReclamationsRoundsRoute,
  AuthenticatedShellErpReclamationsWeekPlanningRoute:
    AuthenticatedShellErpReclamationsWeekPlanningRoute,
  AuthenticatedShellErpReclamationsWorkQueueRoute:
    AuthenticatedShellErpReclamationsWorkQueueRoute,
  AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute:
    AuthenticatedShellErpSafetyControlSurveyNoteCategoriesRoute,
  AuthenticatedShellErpSafetyControlSurveySummaryRoute:
    AuthenticatedShellErpSafetyControlSurveySummaryRoute,
  AuthenticatedShellErpSafetyControlSurveySurveysRoute:
    AuthenticatedShellErpSafetyControlSurveySurveysRoute,
  AuthenticatedShellErpSafetyControlSurveyTeamsRoute:
    AuthenticatedShellErpSafetyControlSurveyTeamsRoute,
  AuthenticatedShellErpSalesCustomerOrderImportRoute:
    AuthenticatedShellErpSalesCustomerOrderImportRoute,
  AuthenticatedShellErpVertexIndConfigRoute:
    AuthenticatedShellErpVertexIndConfigRoute,
  AuthenticatedShellErpWarehouseCargoDriversRoute:
    AuthenticatedShellErpWarehouseCargoDriversRoute,
  AuthenticatedShellErpWarehouseDeliveryMethodsRoute:
    AuthenticatedShellErpWarehouseDeliveryMethodsRoute,
  AuthenticatedShellErpWarehouseDeliveryTermsRoute:
    AuthenticatedShellErpWarehouseDeliveryTermsRoute,
  AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute:
    AuthenticatedShellErpWarehouseWarehousePickerGroupsRoute,
  AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute:
    AuthenticatedShellErpWarehouseWarehouseReplenishmentGroupsRoute,
  AuthenticatedShellMellanoLuukkuCapacityRoute:
    AuthenticatedShellMellanoLuukkuCapacityRoute,
  AuthenticatedShellMellanoLuukkuDataCollectionRoute:
    AuthenticatedShellMellanoLuukkuDataCollectionRoute,
  AuthenticatedShellMellanoLuukkuDispatchSlottingRoute:
    AuthenticatedShellMellanoLuukkuDispatchSlottingRoute,
  AuthenticatedShellMellanoLuukkuDrillStampsRoute:
    AuthenticatedShellMellanoLuukkuDrillStampsRoute,
  AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute:
    AuthenticatedShellMellanoLuukkuHandPaintingPlanRoute,
  AuthenticatedShellMellanoLuukkuKetMetricsRoute:
    AuthenticatedShellMellanoLuukkuKetMetricsRoute,
  AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute:
    AuthenticatedShellMellanoLuukkuMelamineStockForecastRoute,
  AuthenticatedShellMellanoLuukkuOrderStatusRoute:
    AuthenticatedShellMellanoLuukkuOrderStatusRoute,
  AuthenticatedShellMellanoLuukkuPackagedAmountRoute:
    AuthenticatedShellMellanoLuukkuPackagedAmountRoute,
  AuthenticatedShellMellanoLuukkuPaintStockForecastRoute:
    AuthenticatedShellMellanoLuukkuPaintStockForecastRoute,
  AuthenticatedShellMellanoLuukkuPaintingPlanRoute:
    AuthenticatedShellMellanoLuukkuPaintingPlanRoute,
  AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute:
    AuthenticatedShellMellanoLuukkuPaintingRoundDefectsRoute,
  AuthenticatedShellMellanoLuukkuPaintingRoundsRoute:
    AuthenticatedShellMellanoLuukkuPaintingRoundsRoute,
  AuthenticatedShellMellanoLuukkuProductionPlanningRoute:
    AuthenticatedShellMellanoLuukkuProductionPlanningRoute,
  AuthenticatedShellMellanoLuukkuProductionStatusRoute:
    AuthenticatedShellMellanoLuukkuProductionStatusRoute,
  AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute:
    AuthenticatedShellMellanoLuukkuPurchaseOrderImportRoute,
  AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute:
    AuthenticatedShellMellanoLuukkuPurchaseSuggestionRoute,
  AuthenticatedShellMellanoLuukkuShiftDefectsRoute:
    AuthenticatedShellMellanoLuukkuShiftDefectsRoute,
  AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute:
    AuthenticatedShellMellanoLuukkuUnpackagedDeliveryBatchesRoute,
  AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute:
    AuthenticatedShellMellanoLuukkuUnsentDeliveriesByAddressRoute,
  AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute:
    AuthenticatedShellMellanoLuukkuUnsentRonkkoDeliveriesRoute,
  AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute:
    AuthenticatedShellMellanoLuukkuWorkOrderSlottingRoute,
  AuthenticatedShellMellanoWinnerDesignsRoute:
    AuthenticatedShellMellanoWinnerDesignsRoute,
  AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute:
    AuthenticatedShellProductionProductionLineGroupStatusProductionLineGroupIdRoute,
  AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute:
    AuthenticatedShellProductionProductionLinesStatusProductionLineIdRoute,
  AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute:
    AuthenticatedShellProductionSystemDiagramsSystemDiagramIdRoute,
  AuthenticatedShellProjectDeliveryAllDeliveriesRoute:
    AuthenticatedShellProjectDeliveryAllDeliveriesRoute,
  AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute:
    AuthenticatedShellProjectDeliveryAllDeliveryPackagesRoute,
  AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute:
    AuthenticatedShellProjectDeliveryDeliverableActivitiesRoute,
  AuthenticatedShellProjectDeliveryDeliverableProjectsRoute:
    AuthenticatedShellProjectDeliveryDeliverableProjectsRoute,
  AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute:
    AuthenticatedShellProjectDeliveryDeliverableSubProjectsRoute,
  AuthenticatedShellProjectDeliveryPickableProjectsRoute:
    AuthenticatedShellProjectDeliveryPickableProjectsRoute,
  AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute:
    AuthenticatedShellProjectDeliveryUndeliveredPackagesRoute,
  AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute:
    AuthenticatedShellSalesDeliveryAllCustomerOrderDeliveriesRoute,
  AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute:
    AuthenticatedShellSalesDeliveryDeliverableCustomerOrdersRoute,
  AuthenticatedShellSalesDeliveryOwnTransportsRoute:
    AuthenticatedShellSalesDeliveryOwnTransportsRoute,
  AuthenticatedShellSalesDeliveryTransportPlanningRoute:
    AuthenticatedShellSalesDeliveryTransportPlanningRoute,
  AuthenticatedShellSalesDeliveryTransportsRoute:
    AuthenticatedShellSalesDeliveryTransportsRoute,
  AuthenticatedShellSalesPickingAllDeliveryPackagesRoute:
    AuthenticatedShellSalesPickingAllDeliveryPackagesRoute,
  AuthenticatedShellSalesPickingPickableCustomerOrdersRoute:
    AuthenticatedShellSalesPickingPickableCustomerOrdersRoute,
  AuthenticatedShellSalesPickingUndeliveredPackagesRoute:
    AuthenticatedShellSalesPickingUndeliveredPackagesRoute,
  AuthenticatedShellSalesPricingPriceListsRoute:
    AuthenticatedShellSalesPricingPriceListsRoute,
  AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute:
    AuthenticatedShellSalesSalesCommissionsCreatePaymentRoute,
  AuthenticatedShellSalesSalesCommissionsLineNamesRoute:
    AuthenticatedShellSalesSalesCommissionsLineNamesRoute,
  AuthenticatedShellSalesSalesCommissionsPaymentsRoute:
    AuthenticatedShellSalesSalesCommissionsPaymentsRoute,
  AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute:
    AuthenticatedShellSalesSalesCommissionsUnapprovedSalesCommissionLinesRoute,
  AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute:
    AuthenticatedShellSalesSystemDiagramsSystemDiagramIdRoute,
  AuthenticatedShellSpcCChartEventsSearchRoute:
    AuthenticatedShellSpcCChartEventsSearchRoute,
  AuthenticatedShellSpcControlChartCollectionsManagementRoute:
    AuthenticatedShellSpcControlChartCollectionsManagementRoute,
  AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute:
    AuthenticatedShellSpcControlChartParentGroupParentGroupIdRoute,
  AuthenticatedShellSpcDefectGroupsParentGroupIdRoute:
    AuthenticatedShellSpcDefectGroupsParentGroupIdRoute,
  AuthenticatedShellSpcMasterDataYieldChartsRoute:
    AuthenticatedShellSpcMasterDataYieldChartsRoute,
  AuthenticatedShellSpcSpecialCausesChartGroupsRoute:
    AuthenticatedShellSpcSpecialCausesChartGroupsRoute,
  AuthenticatedShellSpcSpecialCausesResourcesRoute:
    AuthenticatedShellSpcSpecialCausesResourcesRoute,
  AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute:
    AuthenticatedShellSpcSystemDiagramsSystemDiagramIdRoute,
  AuthenticatedShellSurveysSubmissionsAuditRoute:
    AuthenticatedShellSurveysSubmissionsAuditRoute,
  AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute:
    AuthenticatedShellWarehouseInventoryAllInventoryLevelEventsRoute,
  AuthenticatedShellWarehouseInventoryManualEventsRoute:
    AuthenticatedShellWarehouseInventoryManualEventsRoute,
  AuthenticatedShellWarehouseInventoryStockCountsRoute:
    AuthenticatedShellWarehouseInventoryStockCountsRoute,
  AuthenticatedShellSpcSummaryViewsIndexRoute:
    AuthenticatedShellSpcSummaryViewsIndexRoute,
  AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute:
    AuthenticatedShellErpPartsCostCalculationConfigurableCustomerOrderLinesRoute,
  AuthenticatedShellErpProjectDeliveryBundlingRoute:
    AuthenticatedShellErpProjectDeliveryBundlingRoute,
  AuthenticatedShellErpProjectDeliveryLoadingRoute:
    AuthenticatedShellErpProjectDeliveryLoadingRoute,
  AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute:
    AuthenticatedShellErpProjectDeliveryOutboundWarehouseRoute,
  AuthenticatedShellErpSalesDeliveryBundlingRoute:
    AuthenticatedShellErpSalesDeliveryBundlingRoute,
  AuthenticatedShellErpSalesDeliveryLoadingRoute:
    AuthenticatedShellErpSalesDeliveryLoadingRoute,
  AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute:
    AuthenticatedShellErpSalesDeliveryOutboundWarehouseRoute,
  AuthenticatedShellErpSalesInvoicingAllInvoicesRoute:
    AuthenticatedShellErpSalesInvoicingAllInvoicesRoute,
  AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute:
    AuthenticatedShellErpSalesInvoicingBillableCustomerOrdersRoute,
  AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute:
    AuthenticatedShellErpSalesReportsCustomerOrderBacklogRoute,
  AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute:
    AuthenticatedShellErpSalesReportsCustomerOrderOfferBacklogRoute,
  AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute:
    AuthenticatedShellErpWarehouseReportsShippingWarehouseInventoryValueRoute,
  AuthenticatedShellErpWarehouseReportsWarehouseValueRoute:
    AuthenticatedShellErpWarehouseReportsWarehouseValueRoute,
  AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute:
    AuthenticatedShellSpcCollectCChartEventsControlChartGroupControlChartGroupIdRoute,
  AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute:
    AuthenticatedShellSpcControlChartCollectionsViewCollectionIdRoute,
  AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute:
    AuthenticatedShellSpcProcessDiagramsChartGroupsChartGroupIdRoute,
  AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute:
    AuthenticatedShellSpcProcessDiagramsResourcesResourceIdRoute,
  AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute:
    AuthenticatedShellSpcSummaryViewsDiagramSummaryViewIdRoute,
  AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute:
    AuthenticatedShellSpcSummaryViewsGridSummaryViewIdRoute,
  AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute:
    AuthenticatedShellErpSalesInvoicingReportsInvoicesRoute,
}

const AuthenticatedShellRouteWithChildren =
  AuthenticatedShellRoute._addFileChildren(AuthenticatedShellRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedShellRoute: typeof AuthenticatedShellRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedShellRoute: AuthenticatedShellRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  EmailVerifiedRoute: EmailVerifiedRoute,
  IndexDothtmlRoute: IndexDothtmlRoute,
  InsufficientPermissionsRoute: InsufficientPermissionsRoute,
  LoggedOutRoute: LoggedOutRoute,
  CustomAppWindowWindowIdRoute: CustomAppWindowWindowIdRoute,
  ViewsSplatRoute: ViewsSplatRoute,
  ConnectionOauthCallbackRoute: ConnectionOauthCallbackRoute,
  WopiActionFileIdRoute: WopiActionFileIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
